/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

/**
 * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
 * useful for filtering.
 *
 * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
 * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
 * * Case sensitive
 * * Maximum number of tags per resource: 25
 * * Reserved prefix — `st:`
 * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
 * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
 * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
 * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
 * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
 * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
 */
export type Tags = Record<string, string>;

/** A request object used to update a resource's tags. */
export interface UpdateTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the updated tags. */
export interface UpdateTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A request object used to update a resource's tags. */
export interface PatchTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  upserts?: Tags;
  removals?: string[];
}

/** A response object containing the updated tags. */
export interface PatchTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the resource's tags. */
export interface GetTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

export interface Device {
  /** The identifier for the Device instance. */
  deviceId: DeviceId;
  /**
   * The name that the Device integration (Device Handler or SmartApp) defines for the Device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the Device. This defaults to the same value as name.
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The Device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * A non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The Device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The ID of the Location with which the Device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The identifier for the owner of the Device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The ID of the Room with which the Device is associated. If the Device is not associated with any room, this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /**
   * Deprecated please look under "dth".
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "Deprecated please look under "dth"."
   */
  deviceTypeId?: string;
  /**
   * Deprecated please look under "dth".
   * @example "Deprecated please look under "dth"."
   */
  deviceTypeName?: string;
  /**
   * Deprecated please look under "dth".
   * @example "Deprecated please look under "dth"."
   */
  deviceNetworkType?: string;
  /** The IDs of all compenents on the Device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the Device. */
  childDevices?: Device[];
  profile?: DeviceProfileReference;
  /** Device Profile information for the SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration (may be null).
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is OCF, the details are in the "ocf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface DeviceComponentRequest {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReferenceRequest[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

export interface DeviceComponent {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReference[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

/** @example {"commands":[{"component":"main","capability":"colorTemperature","command":"setColorTemperature","arguments":["30000"]}]} */
export interface DeviceCommandsRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceCommand[];
}

/** @example {"component":"main","capability":"switchLevel","command":"setLevel","arguments":[80]} */
export interface DeviceCommand {
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "main"
   */
  component?: string;
  /** Capability that this command relates to. This must be a capability of the component. */
  capability: string;
  /** Name of the command, this must be valid for the capability. */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://developer-preview.smartthings.com/docs/devices/capabilities/capabilities-reference
   */
  arguments?: object[];
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

/** The status of a Device. */
export interface DeviceStatus {
  /**
   * A map of componentId to Component status.
   * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
   */
  components?: Record<string, ComponentStatus>;
  healthState?: {
    /** Current state of the device */
    state?: 'ONLINE' | 'OFFLINE';
    /**
     * Last reported date/time in UTC
     * @format date-time
     */
    lastUpdatedDate?: string;
  };
}

/**
 * A map of capabilityId to Capability status.
 * @example {"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}
 */
export type ComponentStatus = Record<string, CapabilityStatus>;

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface DeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceStateEvent[];
}

/** @example {"component":"main","capability":"switchLevel","attribute":"level","value":0,"unit":null,"data":null} */
export interface DeviceStateEvent {
  /** The name of the component on this device, default is 'main'. */
  component?: string;
  /** Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /** Unit of the value field. */
  unit?: string;
  /** Key value pairs about the state of the device. Valid values depend on the capability. */
  data?: Record<string, object>;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface DeviceInstallRequest {
  /**
   * The label for the Device.
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  app: {
    /**
     * The device profile Id
     * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
     */
    profileId: string;
    /**
     * The ID of the installed application
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
     */
    installedAppId: string;
    /**
     * A field to store an ID from a system external to SmartThings.
     * @maxLength 64
     * @example "Th13390"
     */
    externalId?: string;
  };
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

/**
 * The type of device integration (may be null).
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is OCF, the details are in the "ocf" field.
 * If the type is VIPER, the details are in the "viper" field.
 * @default "DTH"
 */
export enum DeviceIntegrationType {
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export type CreateDeviceEventsResponse = object;

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type DeleteDeviceCommandsResponse = object;

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

/** @example {"label":"Living room light","locationId":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","roomId":"0fd2b1ef-1b33-4a54-9153-65aca91e9660","components":[{"id":"main","label":"living room light switch 2","icon":"string","categories":["Light"]}],"indoorMap":{"coordinates":[1,2,3],"rotation":[0,0,0],"visible":true}} */
export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  components?: UpdateDeviceComponent[];
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The identifier for the Device instance.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceId = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface DeviceProfileBase {
  /** @example "a362ddb6-349b-4650-9911-681b51069a57" */
  id?: string;
  /** @example "thermostat1.model1" */
  name?: string;
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
}

export type DeviceProfileResponse = DeviceProfileBase &
  DeviceProfileMigrationStatus & {
    /**
     * The lifecycle status of a device profile.
     * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
     * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
     */
    status?: DeviceProfileStatus;
    preferences?: PreferenceResponse[];
    components?: DeviceComponent[];
  };

export interface PagedDeviceProfiles {
  items?: DeviceProfileResponse[];
  _links?: Links;
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

/** Describes the migration status (from v1 -> v2). This profile will be available in a backwards compatible fashion regardless. */
export interface DeviceProfileMigrationStatus {
  /** @default "NOT_MIGRATED" */
  migrationStatus: 'MIGRATED' | 'NOT_MIGRATED';
}

export interface UpdateDeviceProfileRequest {
  /**
   * A list of `[ 1..20 ]` components for this profile.
   * @maxItems 20
   * @minItems 1
   */
  components?: DeviceComponentRequest[];
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** A list of preferences for this profile, whether implicit or explicit. */
  preferences?: PreferenceRequest[];
}

export interface CreateDeviceProfileRequest {
  /**
   * A name for the device profile.
   * @format ^(?!\s)[-_!.~'() *0-9a-zA-Z\p{L}]{1,100}(?<!\s)$
   * @minLength 1
   * @maxLength 100
   * @example "thermostat1.model1"
   */
  name: string;
  /**
   * A list of components for this profile. Exactly 1 component ID must be `main`.
   * @maxItems 20
   * @minItems 1
   */
  components: DeviceComponentRequest[];
  /** A list of preferences for this profile, whether implicit or explicit. */
  preferences?: PreferenceRequest[];
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  config?: DeviceProfileConfig;
}

export type DeleteDeviceProfileResponse = object;

/**
 * The lifecycle status of a device profile.
 * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
 * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
 * @default "DEVELOPMENT"
 */
export enum DeviceProfileStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  PUBLISHED = 'PUBLISHED',
}

/** The list of supported locales for the device profile. */
export interface DeviceProfileLocaleTranslations {
  items?: LocaleReference[];
}

export interface DeviceProfileTranslations {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  tag?: LocaleTag;
  /**
   * A map of component ID to it's translations.
   * @example {"main":{"label":"Main","description":"The main component of the device."},"component2":{"label":"Component 2","description":"A second component of the device."}}
   */
  components?: Record<string, ComponentTranslations>;
}

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

export interface LocaleReference {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  tag?: LocaleTag;
}

/**
 * The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt).
 * @example "en"
 */
export type LocaleTag = string;

/** A map of i18n translations. */
export interface ComponentTranslations {
  /**
   * Short UTF-8 text used when displaying the component.
   * @maxLength 25
   * @example "Main"
   */
  label?: string;
  /**
   * UTF-8 text describing the component.
   * @maxLength 255
   * @example "The main component of the device."
   */
  description?: string;
}

/** @example {"title":"Temperature Offset","description":"The offset for a particular temperature setting","required":false,"preferenceType":"number","definition":{"minimum":-10,"maximum":10,"default":0}} */
export interface PreferenceRequest {
  /** The ID of the preference */
  preferenceId?: string;
  /**
   * An alphanumeric English language name for this preference. Will be appended to a namespace to generate the full preference id.
   * @pattern ^[a-zA-Z0-9][a-zA-Z0-9 ]{1,35}$
   * @example "tempOffset"
   */
  name: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
  /** The definition of this preference. */
  definition: {
    /**
     * Minimum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    maximum?: number;
    /** Minimum length a string may be set to. Only valid for `string` preference type. */
    minLength?: number;
    /** Maximum length a string may be set to. Only valid for `string` preference type. */
    maxLength?: number;
    /** Default value for a preference. */
    default?: any;
    /** The type of a string preference. `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes. */
    stringType?: 'text' | 'password' | 'paragraph';
    /** The available selections for an `enumeration` preference. */
    options?: Record<string, string>;
  };
}

export interface PreferenceResponse {
  /** The ID of the preference */
  preferenceId?: string;
  /** An alphanumeric English language name for this preference. */
  name?: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

export interface PagedPreferences {
  items?: PreferenceResponse[];
  _links?: Links;
}

/** The list of supported locales. */
export interface PreferenceLocaleLocalizations {
  items?: LocaleReference[];
}

export interface PreferenceLocalization {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  tag: LocaleTag;
  /**
   * A localized label for the Preference
   * @example "Sensibilité au mouvement"
   */
  label: string;
  /**
   * A localized description of the Preference
   * @example "Sensibilité au mouvement"
   */
  description?: string;
  /** Map of an option name to localizations. Options can only be provided to localize Enumeration type Preferences, and are required for Enumerations. The number of options in a Preference Localization must match the number of options in the Preference. */
  options?: Record<
    string,
    {
      /** The localized substitution for the option value */
      label: string;
    }
  >;
}

export interface SmartAppEventRequest {
  /**
   * An arbitrary name for the custom SmartApp event.  Typically useful as a hook for in-app routing.
   * @format ^[a-zA-Z_]{1,36}$
   */
  name?: string;
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 256 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

/** An event used to trigger a client action on a SmartApp dashboard card. */
export interface SmartAppDashboardCardEventRequest {
  /**
   * A developer defined dashboard card ID.
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "my_dashboard_card"
   */
  cardId?: string;
  lifecycle?: DashboardCardLifecycle;
}

export enum DashboardCardLifecycle {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

/**
 * The type of the group in question
 *
 * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
 */
export enum DeviceGroupType {
  UNDETERMINED = 'UNDETERMINED',
  GENERIC = 'GENERIC',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
  LIGHTING = 'LIGHTING',
}

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /**
   * Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands.
   * @default false
   */
  summaryGroup?: boolean;
}

/** A group */
export interface DeviceGroupResponse {
  /**
   * Name of the group created
   * @example "helloWorldGroup"
   */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: DeviceGroupType;
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** restriction tier of the device group */
  restrictionTier?: number;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  deviceGroupId: string;
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /** Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands. */
  summaryGroup: boolean;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
}

export type DeviceGroupDeleteResponse = Record<string, any>;

/** @example {"groupName":"helloWorldGroup","deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"30d3691f-2416-4cbc-b193-2329581f300d2":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"30d7421f-2416-4cbc-b193-2329581f29d1":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}} */
export interface DeviceGroupStatusGizmoResponse {
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<string, DeviceStatus>;
  groupAggregate?: Record<string, CapabilityStatus>;
}

/** @example {"capability":"switchLevel","command":"setLevel","arguments":[100,1]} */
export interface DeviceGroupCommand {
  capability?: string;
  command?: string;
  arguments?: object[];
}

export interface DeviceGroupCommandRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceGroupCommand[];
}

export type DeviceGroupCommandResponse = Record<string, any>;

/** Represents a single page of Locations available in a user account. */
export interface PagedLocations {
  items: PagedLocation[];
  _links?: Links;
}

/**
 * A slimmed-down representation of the Location model.
 * @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}}
 */
export interface PagedLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent: LocationParent;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface Location {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** @example {"name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface CreateLocationRequest {
  /**
   * A name given to the Location (e.g. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * An ISO Alpha-3 country code (e.g. GBR, USA)
   * @pattern ^[A-Z]{3}$
   */
  countryCode: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800} */
export interface CreateLocationResponse {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
}

/** @example {"latitude":{"toNull":true},"longitude":{"value":50}} */
export interface PatchLocationRequest {
  /** Settings for the geographic latitude. */
  latitude?: {
    /**
     * the new value
     * @min -90
     * @max 90
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the geographic longitude. */
  longitude?: {
    /**
     * the new value
     * @min -180
     * @max 180
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the radius in meters around the latitude and longitude defining the location. */
  regionRadius?: {
    /**
     * the new value
     * @min 20
     * @max 500000
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
}

/** @example {"name":"Home","temperatureScale":"F"} */
export interface UpdateLocationRequest {
  /**
   * A name for the Location.
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface UpdateLocationResponse {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteLocationResponse = object;

/** The parent of a Location */
export interface LocationParent {
  /** The type of the Location's parent. */
  type?: LocationParentTypes;
  /**
   * The ID of the parent
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
}

/**
 * The type of the Location's parent.
 * @minLength 7
 * @maxLength 14
 */
export enum LocationParentTypes {
  LOCATIONGROUP = 'LOCATIONGROUP',
  ACCOUNT = 'ACCOUNT',
}

/** Represents a single page of Rooms available in a Location. */
export interface PagedRooms {
  items: Room[];
  _links?: Links;
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface CreateRoomResponse {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface UpdateRoomResponse {
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface Room {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"name":"Living Room","indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface CreateRoomRequest {
  /**
   * A name for the room (e.g. Living Room)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"name":"Living Room","indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface UpdateRoomRequest {
  /**
   * A name for the room.
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** Data used for indoor map related to this room. If this property is not provided or has a null value, then the map data will not be deleted. */
  indoorMap?: {
    /**
     * The reference id for the room map. Setting this property to null disassociates the map from the room.
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteRoomResponse = object;

export interface Mode {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:modes - the user can edit the Mode
   *   <li> d:modes - the user can delete the Mode
   *   </ul>
   */
  allowed?: string[];
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
   * then the returned label will be translated from the name based on the `Accept-Language` header.
   * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * Unique per Location.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface ModesResponse {
  /** @maxItems 10 */
  items: Mode[];
}

export interface CreateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface UpdateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface CreateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface UpdateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface ChangeModeRequest {
  /**
   * Update the current Mode for this Location to the given Mode ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  modeId: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteModeResponse = object;

/** Represents a single page of Invitations available in a user account. */
export interface PagedInvitations {
  items: Invitation[];
  _links?: Links;
}

/** @example {"invitationId":"0dc4abe0-583c-494f-b45c-e4d9776fc1e5","inviterUsername":"user_uuid:76275c80-21e2-68bb-1ea2-f8b965a38932","entityType":"LOCATION","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}],"status":"PENDING","expiration":"2018-02-14T12:44:18+00:00"} */
export interface Invitation {
  /**
   * The ID of the invitation.
   * @format uuid
   */
  invitationId: string;
  /** The username for the inviter. */
  inviterUsername: string;
  /** The entity type you are inviting access to. */
  entityType: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId: string;
  deliveryMethods: DeliveryMethods;
  /** The current status of the invite. */
  status: StatusTypes;
  /**
   * The IS0-8601 date time string in UTC for the expiration of an invitation.
   * @example "2018-02-14T12:44:18+00:00"
   */
  expiration: string;
}

/** The entity type you are inviting access to. */
export enum EntityTypes {
  LOCATION = 'LOCATION',
}

export type DeliveryMethods = Delivery[];

export interface Delivery {
  /** The delivery type of the invite. */
  deliveryType?: DeliveryType;
  /** Target for the delivery type. */
  deliveryTarget?: string;
}

/** The delivery type of the invite. */
export enum DeliveryType {
  EMAIL = 'EMAIL',
  LOGINID = 'LOGINID',
}

/**
 * List of device UUIDs to be accessible to the invited user.
 * If not provided, all devices will be accessible to the invited user.
 */
export type DeviceList = string[];

/** The current status of the invite. */
export enum StatusTypes {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}

/** @example {"entityType":"LOCATION","permissionExpiration":"2023-08-15T00:00:00Z","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","deviceList":["E8DF13FC-318C-42B4-9AA9-B07ADFFE5874","894F1489-EBE9-4C4F-9205-042E74E98D7A"],"deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}]} */
export interface CreateInvitationRequest {
  /**
   * An ISO 8601 date-time indicating the expiration of permissions for the user.
   * This date must not be more than one year in the future.
   * If not provided, the invited user's permissions will not expire.
   * @format date-time
   */
  permissionExpiration?: string;
  /**
   * List of device UUIDs to be accessible to the invited user.
   * If not provided, all devices will be accessible to the invited user.
   */
  deviceList?: DeviceList;
  /** The entity type you are inviting access to. */
  entityType: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId: string;
  deliveryMethods: DeliveryMethods;
  consent?: ConsentPayload;
  /**
   * Can be set to `restrictedshare` to grant limited permissions to the invitee, or `share` to grant full access.
   * Defaults to `share` if no value is passed in.
   */
  grantType?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteInvitationResponse = object;

/**
 * An empty object response.
 * @example {}
 */
export type AcceptInvitationResponse = object;

export interface AcceptInvitationRequest {
  consent?: ConsentPayload;
}

export interface ConsentPayload {
  agreed: ConsentPayloadAgreed[];
}

export interface ConsentPayloadAgreed {
  country: string;
  /** ISO 8601 date-time */
  updatetime: string;
  version: string;
  isOptional: boolean;
  isAgreed: boolean;
}

/**
 * An empty object response.
 * @example {}
 */
export type RejectInvitationResponse = object;

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]} */
export interface InstalledApp {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus: InstalledAppStatus;
  /**
   * A user defined name for the installed app. May be null.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
  referenceId?: string;
  /**
   * The ID of the location to which the installed app may belong.
   * @format uuid
   */
  locationId?: string;
  /** A typed model which provides information around ownership of a specific domain. */
  owner: Owner;
  notices: Notice[];
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: {
    /** @format ^[a-zA-Z._]{1,99}$ */
    pluginId?: string;
    /** @format uri */
    pluginUri?: string;
    dashboardCardsEnabled: boolean;
    preInstallDashboardCardsEnabled: boolean;
  };
  /**
   * A default icon image for the app.
   * @example {"url":"https://smart-home-monitor.com/image"}
   */
  iconImage?: {
    /**
     * A default icon image url for an app. https url required.
     * @format uri
     */
    url?: string;
  };
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType: 'LOCATION' | 'USER_LEVEL';
  /** Restriction tier of the install, if any. */
  restrictionTier?: number;
  /**
   * Inform the installation systems that the associated app can only be installed once within a user's account.
   * @default false
   */
  singleInstance: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   * <ul>
   * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
   * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
   * </ul>
   */
  allowed?: string[];
}

/**
 * An configuration instance of an Installed App.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"DONE","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"}
 */
export interface InstallConfiguration {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * Encompasses both a configuration value, and any required permissions that maybe needed.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"AUTHORIZED","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"main","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}}]}}
 */
export interface InstallConfigurationDetail {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * A simple string configuration.
 * @example {"value":"31192dc9-eb45-4d90-b606-21e9b66d8c2b"}
 */
export interface StringConfig {
  /**
   * A config value
   * @maxLength 2048
   */
  value?: string;
}

/**
 * A device and component configuration with any required permissions.
 * @example {"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}
 */
export interface DeviceConfig {
  /**
   * The ID of the device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * The component ID on the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * Required permissions for the installed app.
 * @example {"permissions":["w:notifications","r:devices:*"]}
 */
export interface PermissionConfig {
  /**
   * @maxItems 25
   * @minItems 1
   */
  permissions?: string[];
}

/**
 * A mode configuration.
 * @example {"modeId":"9206ea57-2e2e-414c-a792-9087117ca3d8"}
 */
export interface ModeConfig {
  /**
   * The ID of the mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
}

/**
 * A scene configuration.
 * @example {"sceneId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["x:scences:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface SceneConfig {
  /**
   * The ID of the scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A message configuration.
 * @example {"messageGroupKey":"leaks"}
 */
export interface MessageConfig {
  /**
   * The key value of the message group.
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A room configuration.
 * @example {"roomId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["r:locations:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface RoomConfig {
  /**
   * The ID of the room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A configuration value type and the correspodning configuration.
 * @example {"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}
 */
export interface ConfigEntry {
  /** The value type. */
  valueType?: 'STRING' | 'DEVICE' | 'PERMISSION' | 'MODE' | 'SCENE' | 'MESSAGE' | 'ROOM';
  /** The config if valueType is STRING, meaningless otherwise */
  stringConfig?: StringConfig;
  /** The config if valueType is DEVICE, meaningless otherwise */
  deviceConfig?: DeviceConfig;
  /** The config if valueType is PERMISSION, meaningless otherwise */
  permissionConfig?: PermissionConfig;
  /** The config if valueType is MODE, meaningless otherwise */
  modeConfig?: ModeConfig;
  /** The config if valueType is SCENE, meaningless otherwise */
  sceneConfig?: SceneConfig;
  /** The config if valueType is MESSAGE, meaningless otherwise */
  messageConfig?: MessageConfig;
  /** The config if valueType is ROOM, meaningless otherwise */
  roomConfig?: RoomConfig;
}

/** A list of available configuration values. */
export type ConfigEntries = ConfigEntry[];

/**
 * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
 * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
 * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
 * @example {"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}]}
 */
export type ConfigMap = Record<string, ConfigEntries>;

/** Denotes the type of installed app. */
export enum InstalledAppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
}

/**
 * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
 * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
 * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
 * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
 * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
 */
export enum InstallConfigurationStatus {
  STAGED = 'STAGED',
  DONE = 'DONE',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
}

/**
 * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
 * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
 * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
 * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
 * 'AUTHORIZED' Installed App will not execute.
 */
export enum InstalledAppStatus {
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
  DISABLED = 'DISABLED',
}

/** Represents a single page of InstalledApps available in a user account. */
export interface PagedInstalledApps {
  items?: InstalledApp[];
  _links?: Links;
}

/** Represents a single page of InstallConfiguration models available for an InstalledApp. */
export interface PagedInstallConfigurations {
  items?: InstallConfiguration[];
  _links?: Links;
}

/** The number of deleted installed apps. */
export interface DeleteInstalledAppResponse {
  /** @format int32 */
  count?: number;
}

/** @example {"displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","installedAppType":"WEBHOOK_SMART_APP","configurationStatus":"STAGED","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface CreateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. */
  referenceId?: string;
  /**
   * The ID of the location.  A locationId may or may not be required based on the type of install.
   * @format uuid
   */
  locationId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface CreateInstalledAppEventsRequest {
  /**
   * An array of smartapp events used to trigger client behavior in loaded web plugin detail pages.  Events will
   * be delivered to JavaScript event handler of all active client processes related to parameterized installed app.
   * @maxItems 8
   * @minItems 1
   */
  smartAppEvents?: SmartAppEventRequest[];
  /**
   * An array of smartapp dashboard card events used to trigger client behavior for dashboard cards.
   * Dashboard card events are directives to a SmartThings client to take actions in relation to lifecycle changes
   * to a specific dashboard card.  These events are not delivered to the web plugin event handler.
   * @maxItems 8
   * @minItems 1
   */
  smartAppDashboardCardEvents?: SmartAppDashboardCardEventRequest[];
}

export type CreateInstalledAppEventsResponse = object;

/** A composite model to provide both the details of an InstalledApp and the current configuration. */
export interface InstalledAppComposite {
  installedApp?: InstalledApp;
  /** Encompasses both a configuration value, and any required permissions that maybe needed. */
  configurationDetail?: InstallConfigurationDetail;
}

/** A response containing details about the bearer token. */
export interface InstalledAppMeResponse {
  /**
   * The installedapp identifier.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The location identifier.
   * @format uuid
   */
  locationId?: string;
  /** A unique set of the OAuth scope associated with the bearer token. */
  scope?: string[];
}

/** @example {"displayName":"Color App"} */
export interface UpdateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
}

/** @example {"config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface UpdateInstallConfigurationRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config: ConfigMap;
}

/** @example {"removals":["temperature_controls","some_other_developer_defined_key"],"upserts":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface PatchInstalledAppRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  upserts?: ConfigMap;
  /** An array of config name's to delete. */
  removals?: string[];
}

export interface Notice {
  /**
   * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
   * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
   * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
   */
  code?: NoticeCode;
  /** The url of the badge icon for the notice card */
  badgeUrl?: string;
  /** The localized message to be displayed */
  message?: string;
  /** The action(s) a user can take to resolve this notice */
  actions?: NoticeAction[];
}

/**
 * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
 * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
 * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
 */
export enum NoticeCode {
  USER_PAUSE = 'USER_PAUSE',
  REVISIT = 'REVISIT',
  RECONFIGURE = 'RECONFIGURE',
}

/**
 * An action the user can take to resolve a notice
 * @default "none"
 */
export enum NoticeAction {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  NONE = 'NONE',
}

export interface OnceSchedule {
  /**
   * The time in millis from jan 1 1970 UTC for ONCE schedules. Must be less than 2 years from now.
   * @format int64
   */
  time: number;
  overwrite?: boolean;
}

export interface CronSchedule {
  /**
   * The cron expression for the schedule for CRON schedules.
   * The format matches that specified by the [Quartz scheduler](http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html) but should not include the seconds (1st)
   * field. The exact second will be chosen at random but will remain consistent. The years part must be les than 2 years from now.
   * @maxLength 256
   * @example "15 10 * * ? *"
   */
  expression: string;
  /**
   * The timezone id for CRON schedules.
   * @example "GMT"
   */
  timezone: string;
}

/** @example {"name":"on_schedule_1","cron":{"expression":"15 10 * * ? *","timezone":"GMT"}} */
export interface ScheduleRequest {
  once?: OnceSchedule;
  /**
   * The unique per installed app name of the schedule.
   * @format ^[A-Za-z0-9._\-]{1,36}$
   * @minLength 1
   * @maxLength 36
   * @example "on_schedule-1"
   */
  name: string;
  cron?: CronSchedule;
}

/** @example {"installedAppId":"736e3903-001c-4d40-b408-ff40d162a06b","scheduledExecutions":[1490892856362],"name":"on_schedule-1","cron":{"expression":"15 10 * * ? *","timezone":"GMT"}} */
export interface Schedule {
  /**
   * The ID of the installed app.
   * @format uuid
   * @example "736e3903-001c-4d40-b408-ff40d162a06b"
   */
  installedAppId?: string;
  /**
   * The ID of the location the installed app is in.
   * @format uuid
   * @example "35451c7a-cc23-4838-8a3b-1205090cf161"
   */
  locationId?: string;
  /**
   * The UUID of the user who created the schedule.
   * @format uuid
   * @example "27843aec-56a1-4b91-83b6-7957d26a3f7d"
   */
  userUuid?: string;
  /** list of scheduled execution times in millis from jan 1 1970 UTC */
  scheduledExecutions?: number[];
  /**
   * The unique per installed app name of the schedule.
   * @format ^[A-Za-z0-9._\-]{1,36}$
   * @minLength 1
   * @maxLength 36
   * @example "on_schedule-1"
   */
  name: string;
  cron?: CronSchedule;
}

/**
 * An array of schedules
 * @example {"items":[{"scheduledExecutions":[1505752823000],"name":"schedule-name","cron":{"expression":"0/10 * * * ? *","timezone":"America/Chicago"},"installedAppId":"937e11d5-317d-445f-bec7-3055fdb827a3","locationId":"8418eebd-8d5f-48dd-a028-054744j8secb"}],"_links":{"next":null,"previous":null}}
 */
export interface PagedSchedules {
  items?: Schedule[];
  _links?: Links;
}

/** Delete schedule response */
export type DeleteScheduleResponse = object;

/** @example {"id":"5e1b134b-bd85-4125-9c25-4a8291e754aa","installedAppId":"fb05c874-cf1d-406a-930c-69a081e0eaee","sourceType":"DEVICE","device":{"componentId":"main","deviceId":"e457978e-5e37-43e6-979d-18112e12c961,","capability":"contactSensor,","attribute":"contact,","stateChangeOnly":"true,","subscriptionName":"contact_subscription',","value":"*"}} */
export interface Subscription {
  /**
   * The id of the subscription.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "736e3903-001c-4d40-b408-ff40d162a06b"
   */
  id?: string;
  /**
   * The id of the subscribing app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  installedAppId?: string;
  /** The type of the event that is being subscribed to. */
  sourceType?: SubscriptionSource;
  /** Details of a subscription of source type DEVICE. The combination of subscribed values must be unique per installed app. */
  device?: DeviceSubscriptionDetail;
  /** Details of a subscription of source type CAPABILITY. The combination of subscribed values must be unique per installed app. */
  capability?: CapabilitySubscriptionDetail;
  /** Details of a subscription of source type MODE. This will subscribe to all mode changes for the given location. The installed app can then act on the resulting mode change event accordingly. */
  mode?: ModeSubscriptionDetail;
  /** Details of a subscription of source type DEVICE_LIFECYCLE. Only one of deviceIds or locationId should be supplied. */
  deviceLifecycle?: DeviceLifecycleDetail;
  /** Details of a subscription of source type DEVICE_HEALTH. Only one of deviceIds or locationId should be supplied. */
  deviceHealth?: DeviceHealthDetail;
  /** Details of a subscription of souce type SECURITY_ARM_STATE */
  securityArmState?: SecurityArmStateDetail;
  /** Details of a subscription of souce type HUB_HEALTH */
  hubHealth?: HubHealthDetail;
  /** Details of a subscription of source type SCENE_LIFECYCLE. */
  sceneLifecycle?: SceneLifecycleDetail;
}

/** The type of the event that is being subscribed to. */
export enum SubscriptionSource {
  DEVICE = 'DEVICE',
  CAPABILITY = 'CAPABILITY',
  MODE = 'MODE',
  DEVICE_LIFECYCLE = 'DEVICE_LIFECYCLE',
  DEVICE_HEALTH = 'DEVICE_HEALTH',
  SECURITY_ARM_STATE = 'SECURITY_ARM_STATE',
  HUB_HEALTH = 'HUB_HEALTH',
  SCENE_LIFECYCLE = 'SCENE_LIFECYCLE',
}

/** @example {"sourceType":"DEVICE","device":{"deviceId":"736e3903-001c-4d40-b408-ff40d162a06b","componentId":"freezer","capability":"temperatureMeasurement","attribute":"temperature","stateChangeOnly":true,"modes":["e34b57fb-e73a-4228-8819-e99502d17890","cfa3a42e-5f52-452e-9515-c32bcbea48ce"]}} */
export interface SubscriptionRequest {
  /** The type of the event that is being subscribed to. */
  sourceType: SubscriptionSource;
  /** Details of a subscription of source type DEVICE. The combination of subscribed values must be unique per installed app. */
  device?: DeviceSubscriptionDetail;
  /** Details of a subscription of source type CAPABILITY. The combination of subscribed values must be unique per installed app. */
  capability?: CapabilitySubscriptionDetail;
  /** Details of a subscription of source type MODE. This will subscribe to all mode changes for the given location. The installed app can then act on the resulting mode change event accordingly. */
  mode?: ModeSubscriptionDetail;
  /** Details of a subscription of source type DEVICE_LIFECYCLE. Only one of deviceIds or locationId should be supplied. */
  deviceLifecycle?: DeviceLifecycleDetail;
  /** Details of a subscription of source type DEVICE_HEALTH. Only one of deviceIds or locationId should be supplied. */
  deviceHealth?: DeviceHealthDetail;
  /** Details of a subscription of souce type SECURITY_ARM_STATE */
  securityArmState?: SecurityArmStateDetail;
  /** Details of a subscription of souce type HUB_HEALTH */
  hubHealth?: HubHealthDetail;
  /** Details of a subscription of source type SCENE_LIFECYCLE. */
  sceneLifecycle?: SceneLifecycleDetail;
}

/** Details of a subscription of source type DEVICE. The combination of subscribed values must be unique per installed app. */
export interface DeviceSubscriptionDetail {
  /**
   * The GUID of the device that is subscribed to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "35451c7a-cc23-4838-8a3b-1205090cf161"
   */
  deviceId: string;
  /**
   * The component ID on the device that is subscribed to or * for all.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "*"
   * @example "main"
   */
  componentId?: string;
  /**
   * Name of the capability that is subscribed to or * for all.
   * @minLength 1
   * @maxLength 128
   * @default "*"
   * @example "switch"
   */
  capability?: string;
  /**
   * Name of the capabilities attribute or * for all.
   * @minLength 1
   * @maxLength 256
   * @default "*"
   * @example "switch"
   */
  attribute?: string;
  /**
   * A particular value for the attribute that will trigger the subscription or * for all.
   * @maxLength 256
   * @default "*"
   * @example ["*",1,"on",{"key":30}]
   */
  value?: object;
  /** Only execute the subscription if the subscribed event is a state change from previous events. */
  stateChangeOnly?: boolean;
  /**
   * A name for the subscription that will be passed to the installed app. Must be unique per installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /** List of mode ID's that the subscription will execute for. If not provided then all modes will be supported. */
  modes?: string[];
}

/** Details of a subscription of source type CAPABILITY. The combination of subscribed values must be unique per installed app. */
export interface CapabilitySubscriptionDetail {
  /**
   * The id of the location that both the app and source device are in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * Name of the capability that is subscribed to.
   * @minLength 1
   * @maxLength 128
   * @example "switch"
   */
  capability: string;
  /**
   * Name of the capabilities attribute or * for all.
   * @minLength 1
   * @maxLength 256
   * @default "*"
   * @example "switch"
   */
  attribute?: string;
  /**
   * A particular value for the attribute that will trigger the subscription or * for all.
   * @maxLength 256
   * @default "*"
   * @example ["*",1,"on",{"key":30}]
   */
  value?: object;
  /**
   * Only execute the subscription if the subscribed event is a state change from previous events.
   * @default true
   */
  stateChangeOnly?: boolean;
  /**
   * A name for the subscription that will be passed to the installed app. Must be unique per installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /** List of modes that the subscription will execute for. If not provided then all modes will be supported. */
  modes?: string[];
}

/** The number of deleted subscriptions */
export interface SubscriptionDelete {
  /** @format int32 */
  count?: number;
}

/** An array of subscriptions */
export interface PagedSubscriptions {
  items?: Subscription[];
  _links?: Links;
}

/** Details of a subscription of source type MODE. This will subscribe to all mode changes for the given location. The installed app can then act on the resulting mode change event accordingly. */
export interface ModeSubscriptionDetail {
  /**
   * The GUID for the location to subscribe to mode changes.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9f24edfd-f2e5-4a82-8a24-c1955ee46419"
   */
  locationId: string;
}

/** Details of a subscription of source type DEVICE_LIFECYCLE. Only one of deviceIds or locationId should be supplied. */
export interface DeviceLifecycleDetail {
  /**
   * An array of GUIDs of devices being subscribed to. A max of 20 GUIDs are allowed.
   * @maxItems 20
   */
  deviceIds?: string[];
  /**
   * A name for the subscription that will be passed to the installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /**
   * The id of the location that both the app and source device are in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

/** Details of a subscription of source type DEVICE_HEALTH. Only one of deviceIds or locationId should be supplied. */
export interface DeviceHealthDetail {
  /**
   * An array of GUIDs of devices being subscribed to. A max of 20 GUIDs are allowed.
   * @maxItems 20
   */
  deviceIds?: string[];
  /**
   * A name for the subscription that will be passed to the installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /**
   * The id of the location that both the app and source device are in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

/** Details of a subscription of souce type SECURITY_ARM_STATE */
export interface SecurityArmStateDetail {
  /**
   * A name for the subscription that will be passed to the installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /**
   * The id of the location that both the app and the security system are in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** Details of a subscription of souce type HUB_HEALTH */
export interface HubHealthDetail {
  /**
   * A name for the subscription that will be passed to the installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /**
   * The id of the location that both the app and hubs are in
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** Details of a subscription of source type SCENE_LIFECYCLE. */
export interface SceneLifecycleDetail {
  /**
   * A name for the subscription that will be passed to the installed app.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  subscriptionName?: string;
  /**
   * The id of the location that both the app and scenes are in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/**
 * The subscription id of the subscription.
 * @format uuid
 */
export type SubscriptionId = string;

/** An array of subscription filters */
export type SubscriptionFilters = SubscriptionFilter[];

export interface SubscriptionFilter {
  /** The type of filter */
  type?: SubscriptionFilterTypes;
  /** An array of subscription filter values. */
  value?: SubscriptionFilterValues;
  eventType?: SubscriptionFilterEventTypes;
  attribute?: SubscriptionFilterAttributes;
  capability?: SubscriptionFilterCapabilities;
  component?: SubscriptionFilterComponents;
}

/** The type of filter */
export enum SubscriptionFilterTypes {
  LOCATIONIDS = 'LOCATIONIDS',
  DEVICEIDS = 'DEVICEIDS',
  INSTALLEDSMARTAPPIDS = 'INSTALLEDSMARTAPPIDS',
  SMARTAPPIDS = 'SMARTAPPIDS',
}

/** An array of subscription filter values. */
export type SubscriptionFilterValues = string[];

export type SubscriptionFilterEventTypes = string[];

export type SubscriptionFilterAttributes = string[];

export type SubscriptionFilterCapabilities = string[];

export type SubscriptionFilterComponents = string[];

export interface SubscriptionTarget {
  /** The address to send events to. */
  url?: SubscriptionTargetValue;
}

/**
 * The address to send events to.
 * @format uri
 */
export type SubscriptionTargetValue = string;

/** @example {"version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionRequest {
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface GetSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionRequest {
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** An empty object 200 response. */
export type DeleteSubscriptionResponse = object;

export interface RegisterSubscriptionRequest {
  subscriptionTarget?: SubscriptionTarget;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface RegisterSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** Represents a single page of Apps available in an account. */
export interface PagedApps {
  items?: PagedApp[];
  _links?: Links;
}

/** @example {"appName":"security-home-monitor","appId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","appType":"WEBHOOK_SMART_APP","displayName":"Security Home Monitor","description":"An intergration that leverages all security devices in your home - cameras, motion sensors, etc to provide\nyou with peace of mind and #security.\n","iconImage":{"url":"https://smart-home-monitor.com/image"},"owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"} */
export interface PagedApp {
  /**
   * A user defined unique identifier for an app.  It is alpha-numeric, may contain dashes,
   * underscores, periods, and be less then 250 characters long.  It must be unique within your account.
   * @format ^[a-z0-9.-_]{1,250}$
   */
  appName?: string;
  /**
   * A globally unique identifier for an app.
   * @format uuid
   */
  appId?: string;
  /** Denotes the type of app. */
  appType?: AppType;
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications?: AppClassification[];
  /**
   * A default display name for an app.
   * @maxLength 75
   */
  displayName?: string;
  /**
   * A default description for an app.
   * @maxLength 250
   */
  description?: string;
  /** A default icon image for the app. */
  iconImage?: IconImage;
  /** A typed model which provides information around ownership of a specific domain. */
  owner?: Owner;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * A default icon image for the app.
 * @example {"url":"https://smart-home-monitor.com/image"}
 */
export interface IconImage {
  /**
   * A default icon image url for an app. https url required.
   * @format uri
   */
  url?: string;
}

/** Denotes the type of app. */
export enum AppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
}

/**
 * An App maybe associated to many classifications.  A classification drives how the integration is presented
 * to the user in the SmartThings mobile clients.  These classifications include:
 * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
 * * SERVICE - Denotes an integration that is classified as a "Service".
 * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
 * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
 * * HIDDEN - Denotes an integration that should not display in mobile clients
 */
export enum AppClassification {
  AUTOMATION = 'AUTOMATION',
  SERVICE = 'SERVICE',
  DEVICE = 'DEVICE',
  CONNECTED_SERVICE = 'CONNECTED_SERVICE',
  HIDDEN = 'HIDDEN',
  LABS = 'LABS',
}

/** Prepares to subscribe an endpoint by sending the endpoint a confirmation message */
export type AppRegisterRequest = object;

/** A response object for successful app registration push. */
export type AppRegisterResponse = object;

/** @example {"appName":"security-home-monitor","appId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","appType":"WEBHOOK_SMART_APP","classifications":["AUTOMATION"],"displayName":"Security Home Monitor","description":"An intergration that leverages all security devices in your home - cameras, motion sensors, etc to provide\nyou with peace of mind and #security.\n","iconImage":{"url":"https://smart-home-monitor.com/image"},"installMetadata":{"certified":"true","maxInstalls":"-1"},"owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"webhookSmartApp":{"targetUrl":"https://securityhome.com/smartthings","publicKey":"-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlz00iTNPXIo+RM8n0Eudnh84XDWBFAkR\nL7mkOtXvZiKViCR1qs5LT3SaNy62hkUroexCoii4vjRTSHaQ9FwyBRo98EY9U3qzWmr9Row9ONcQ\nVKFVX6qiwb9SZG7QvHSfqVAuWhMGb1fFGUWl94L7kY0CihF+WJS5fdhXc1h/f/tY1439hruL3+BR\n/idfYjAKDa1+euW4b0HKMi4BdJutL/G5FXjDP7MP5fTRuM52erKpON1pwPD8ow/03MhK4wRikHqS\n/Kvd3UnQ8Q7OSrfJevqR0CqBf83Am1HSHh/bqOfsG0epl+2I1RKLBzB2tSTvMfk0ftiRSq/fRrhl\nxsJmFQIDAQAB\n-----END PUBLIC KEY-----\n"},"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"} */
export interface App {
  /**
   * A user defined unique identifier for an app.  It is alpha-numeric, may contain dashes,
   * underscores, periods, and be less then 250 characters long.  It must be unique within your account.
   * @format ^[a-z0-9.-_]{1,250}$
   */
  appName?: string;
  /**
   * A globally unique identifier for an app.
   * @format uuid
   */
  appId?: string;
  /** Denotes the type of app. */
  appType?: AppType;
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType?: PrincipalType;
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications?: AppClassification[];
  /**
   * A default display name for an app.
   * @maxLength 75
   */
  displayName?: string;
  /**
   * A default description for an app.
   * @maxLength 250
   */
  description?: string;
  /**
   * Inform the installation systems that a particular app can only be installed once within a user's account.
   * @default false
   */
  singleInstance?: boolean;
  /** A default icon image for the app. */
  iconImage?: IconImage;
  /** System generated metadata that impacts eligibility requirements around installing an App. */
  installMetadata?: Record<string, string>;
  /** A typed model which provides information around ownership of a specific domain. */
  owner?: Owner;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
  /** Details related to a Lambda Smart App implementation.  This model will only be available for apps of type LAMBDA_SMART_APP. */
  lambdaSmartApp?: LambdaSmartApp;
  /** Details related to a Webhook Smart App implementation.  This model will only be available for apps of type WEBHOOK_SMART_APP. */
  webhookSmartApp?: WebhookSmartApp;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: AppUISettings;
}

/** Details related to a Lambda Smart App implementation.  This model will only be available for apps of type LAMBDA_SMART_APP. */
export interface LambdaSmartApp {
  /** A list of AWS arns referencing a Lambda function. */
  functions?: string[];
}

/**
 * Details related to a Webhook Smart App implementation.  This model will only be available for apps of type WEBHOOK_SMART_APP.
 * @example {"appName":"security-home-monitor","appId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","appType":"WEBHOOK_SMART_APP","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"targetUrl":"https://securityhome.com/smartthings","targetStatus":"CONFIRMED","publicKey":"-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlz00iTNPXIo+RM8n0Eudnh84XDWBFAkR\nL7mkOtXvZiKViCR1qs5LT3SaNy62hkUroexCoii4vjRTSHaQ9FwyBRo98EY9U3qzWmr9Row9ONcQ\nVKFVX6qiwb9SZG7QvHSfqVAuWhMGb1fFGUWl94L7kY0CihF+WJS5fdhXc1h/f/tY1439hruL3+BR\n/idfYjAKDa1+euW4b0HKMi4BdJutL/G5FXjDP7MP5fTRuM52erKpON1pwPD8ow/03MhK4wRikHqS\n/Kvd3UnQ8Q7OSrfJevqR0CqBf83Am1HSHh/bqOfsG0epl+2I1RKLBzB2tSTvMfk0ftiRSq/fRrhl\nxsJmFQIDAQAB\n-----END PUBLIC KEY-----\n","signatureType":"APP_RSA"}
 */
export interface WebhookSmartApp {
  /** A URL that should be invoked during execution. */
  targetUrl?: string;
  /** The registration status of a target url. */
  targetStatus?: AppTargetStatus;
  /**
   * The public half of an RSA key pair.  Useful for verifying a Webhook execution request signature to
   * ensure it came from SmartThings.
   */
  publicKey?: string;
  /**
   * The http signature type used for authorizing event delivery. APP_RSA generates an RSA key pair that will be used
   * to verify requests from SmartThings. ST_PADLOCK requires verifcation through SmartThings public certificate.
   */
  signatureType?: SignatureType;
}

/** @example {"clientName":"My SmartThings Integration","scope":["r:installedapps","w:installedapps","x:installedapps"]} */
export interface AppOAuth {
  /** A name given to the OAuth Client. */
  clientName?: string;
  /** A list of SmartThings API OAuth scope identifiers that may be required to execute your integration. */
  scope?: string[];
  /**
   * A list of redirect URIs.
   * @maxItems 10
   * @minItems 0
   */
  redirectUris?: string[];
}

export interface CreateAppRequest {
  /**
   * A globally unique, developer-defined identifier for an app. It is alpha-numeric, may contain dashes,
   * underscores, periods, and must be less then 250 characters long.
   * @format ^[a-z0-9.-_]{1,250}$
   */
  appName: string;
  /**
   * A default display name for an app.
   * @maxLength 75
   */
  displayName: string;
  /**
   * A default description for an app.
   * @maxLength 250
   */
  description: string;
  /**
   * Inform the installation systems that a particular app can only be installed once within a user's account.
   * @default false
   */
  singleInstance?: boolean;
  /** A default icon image for the app. */
  iconImage?: IconImage;
  /** Denotes the type of app. */
  appType: AppType;
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType?: PrincipalType;
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: AppClassification[];
  /** Details related to a Lambda Smart App implementation.  This model should only be specified for apps of type LAMBDA_SMART_APP. */
  lambdaSmartApp?: CreateOrUpdateLambdaSmartAppRequest;
  /** Details related to a Webhook Smart App implementation.  This model should only be specified for apps of type WEBHOOK_SMART_APP. */
  webhookSmartApp?: CreateOrUpdateWebhookSmartAppRequest;
  oauth?: AppOAuth;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: AppUISettings;
}

export interface UpdateAppRequest {
  /**
   * A default display name for an app.
   * @maxLength 75
   */
  displayName: string;
  /**
   * A default description for an app.
   * @maxLength 250
   */
  description: string;
  /**
   * Inform the installation systems that a particular app can only be installed once within a user's account.
   * @default false
   */
  singleInstance?: boolean;
  /** A default icon image for the app. */
  iconImage?: IconImage;
  /** Denotes the type of app. */
  appType: AppType;
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: AppClassification[];
  /** Details related to a Lambda Smart App implementation.  This model should only be specified for apps of type LAMBDA_SMART_APP. */
  lambdaSmartApp?: CreateOrUpdateLambdaSmartAppRequest;
  /** Details related to a Webhook Smart App implementation.  This model should only be specified for apps of type WEBHOOK_SMART_APP. */
  webhookSmartApp?: CreateOrUpdateWebhookSmartAppRequest;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: AppUISettings;
}

/**
 * A response object containing the newly created App and OAuth client details.
 * @example {"app":{"appName":"security-home-monitor","appId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","appType":"WEBHOOK_SMART_APP","displayName":"Security Home Monitor","description":"An intergration that leverages all security devices in your home - cameras, motion sensors, etc to provide\nyou with peace of mind and #security.\n","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"webhookSmartApp":{"targetUrl":"https://securityhome.com/smartthings","publicKey":"-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlz00iTNPXIo+RM8n0Eudnh84XDWBFAkR\nL7mkOtXvZiKViCR1qs5LT3SaNy62hkUroexCoii4vjRTSHaQ9FwyBRo98EY9U3qzWmr9Row9ONcQ\nVKFVX6qiwb9SZG7QvHSfqVAuWhMGb1fFGUWl94L7kY0CihF+WJS5fdhXc1h/f/tY1439hruL3+BR\n/idfYjAKDa1+euW4b0HKMi4BdJutL/G5FXjDP7MP5fTRuM52erKpON1pwPD8ow/03MhK4wRikHqS\n/Kvd3UnQ8Q7OSrfJevqR0CqBf83Am1HSHh/bqOfsG0epl+2I1RKLBzB2tSTvMfk0ftiRSq/fRrhl\nxsJmFQIDAQAB\n-----END PUBLIC KEY-----\n"},"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"},"oauthClientId":"7cd4d474-7b36-4e03-bbdb-4cd4ae45a2be","oauthClientSecret":"9b3fd445-42d6-441b-b386-99ea51e13cb0"}
 */
export interface CreateAppResponse {
  app?: App;
  /**
   * The OAuth Client ID.
   * @format uuid
   */
  oauthClientId?: string;
  /**
   * The OAuth Client Secret.
   * @format uuid
   */
  oauthClientSecret?: string;
}

/**
 * Details related to a Lambda Smart App implementation.  This model should only be specified for apps of type LAMBDA_SMART_APP.
 * @example {"functions":["arn:aws:lambda:eu-central-1:account-id:function:function-name:alias-name","arn:aws:lambda:ap-southeast-1:account-id:function:function-name:alias-name"]}
 */
export interface CreateOrUpdateLambdaSmartAppRequest {
  /** A list of AWS arns referencing a Lambda function. */
  functions: string[];
}

/**
 * Details related to a Webhook Smart App implementation.  This model should only be specified for apps of type WEBHOOK_SMART_APP.
 * @example {"targetUrl":"https://securityhome.com/smartthings"}
 */
export interface CreateOrUpdateWebhookSmartAppRequest {
  /** A URL that should be invoked during execution. */
  targetUrl: string;
}

/** @example {"clientName":"My SmartThings Integration","scope":["r:installedapps","w:installedapps"]} */
export interface UpdateAppOAuthRequest {
  /** A name given to the OAuth Client. */
  clientName: string;
  /** A list of SmartThings API OAuth scope identifiers that may be required to execute your integration. */
  scope: string[];
  /**
   * A list of redirect URIs.
   * @maxItems 10
   * @minItems 0
   */
  redirectUris: string[];
}

/** @example {"clientName":"My SmartThings Integration","scope":["r:installedapps","w:installedapps"]} */
export interface GenerateAppOAuthRequest {
  /** A name given to the OAuth Client. */
  clientName?: string;
  /** A list of SmartThings API OAuth scope identifiers that may be required to execute your integration. */
  scope?: string[];
}

/** An empty object 200 response. */
export type DeleteAppResponse = object;

/**
 * Settings for a given app
 * @example {"settings":{"mySecretData":"6c21f9ee-7634-413f-89f7-bdfdce88bf0e"}}
 */
export interface UpdateAppSettingsRequest {
  settings?: Record<string, string>;
}

/**
 * Settings for a given app
 * @example {"settings":{"mySecretData":"6c21f9ee-7634-413f-89f7-bdfdce88bf0e"}}
 */
export interface UpdateAppSettingsResponse {
  settings?: Record<string, string>;
}

/**
 * A request object used to switch the signing mechanism for authorizing SmartApp callbacks.
 * @example {"signatureType":"ST_PADLOCK"}
 */
export interface UpdateSignatureTypeRequest {
  /**
   * The http signature type used for authorizing event delivery. APP_RSA generates an RSA key pair that will be used
   * to verify requests from SmartThings. ST_PADLOCK requires verifcation through SmartThings public certificate.
   */
  signatureType?: SignatureType;
}

/**
 * An empty object response.
 * @example {}
 */
export type UpdateSignatureTypeResponse = object;

/**
 * Settings for a given app
 * @example {"settings":{"mySecretData":"6c21f9ee-7634-413f-89f7-bdfdce88bf0e"}}
 */
export interface GetAppSettingsResponse {
  settings?: Record<string, string>;
}

/**
 * A response object containing a new OAuth Client and its details.
 * @example {"oauthClientDetails":{"clientName":"My SmartThings Integration","scope":["r:installedapps","w:installedapps","x:installedapps"]},"oauthClientId":"7cd4d474-7b36-4e03-bbdb-4cd4ae45a2be","oauthClientSecret":"9b3fd445-42d6-441b-b386-99ea51e13cb0"}
 */
export interface GenerateAppOAuthResponse {
  oauthClientDetails?: AppOAuth;
  /**
   * The OAuth Client ID.
   * @format uuid
   */
  oauthClientId?: string;
  /**
   * The OAuth Client Secret.
   * @format uuid
   */
  oauthClientSecret?: string;
}

/**
 * The http signature type used for authorizing event delivery. APP_RSA generates an RSA key pair that will be used
 * to verify requests from SmartThings. ST_PADLOCK requires verifcation through SmartThings public certificate.
 */
export enum SignatureType {
  APP_RSA = 'APP_RSA',
  ST_PADLOCK = 'ST_PADLOCK',
}

/** Denotes the principal type to be used with the app.  Default is LOCATION. */
export enum PrincipalType {
  LOCATION = 'LOCATION',
  USER_LEVEL = 'USER_LEVEL',
}

/**
 * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
 * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
 */
export interface AppUISettings {
  /** @format ^[a-zA-Z._]{1,99}$ */
  pluginId?: string;
  /** @format uri */
  pluginUri?: string;
  dashboardCardsEnabled: boolean;
  preInstallDashboardCardsEnabled: boolean;
}

/** The registration status of a target url. */
export enum AppTargetStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
}

/**
 * An adhoc message contains a list of message templates representing the same message in different locales. The
 * system will serve the template with the locale that best matches the Recipient's language preferences. If the
 * user's language preferences do not correlate to any message templates, the template defined by the
 * `fallbackLocale` will be used. Variables from the template matching the locale of the Message will be assigned
 * first, then `defaultVariables`.
 * @example {"fallbackLocale":"en","defaultVariables":{"duration":"5"},"templates":[{"localeTag":"en","template":"{{ deviceName }} will turn off in {{ duration }} minutes.","variables":{"deviceName":"lamp"}},{"localeTag":"es","template":"{{ deviceName }} se apagará en {{ duration }} minutos.","variables":{"deviceName":"lámpara"}}]}
 */
export interface AdhocMessage {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  fallbackLocale: LocaleTag;
  /**
   * A map<string,string> with the key representing the variable name, and the value representing the verbiage
   * to be replaced in template string. `defaultVariables` will only be used if there are no matching locale-level
   * (template) variables for that key.
   */
  defaultVariables?: Record<string, string>;
  /**
   * A list of templates representing the same message in different languages.
   * @maxItems 35
   * @minItems 1
   */
  templates: AdhocMessageTemplate[];
}

/**
 * A message template definition, representing a message in a specific locale and it's variables.
 * @example {"localeTag":"en","template":"Hello, {{ firstName }}!","variables":{"firstName":"Jason"}}
 */
export interface AdhocMessageTemplate {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  localeTag: LocaleTag;
  /**
   * A map<string,string> with the key representing the variable name, and the value representing the verbiage
   * to be replaced in template string.
   */
  variables?: Record<string, string>;
  /**
   * A message template string.  Specify variables using the double curly braces convention.
   * i.e. "Hello, {{ firstName }}!"
   */
  template: string;
}

/** A response object for when a message template is successfully deleted. */
export type DeleteMessageTemplateResponse = object;

/** A response object for when message templates are successfully deleted. */
export type DeleteMessageTemplatesResponse = object;

/** A response object for getting a Message Template. */
export interface GetMessageTemplateResponse {
  /**
   * A globally unique identifier for an app.
   * @format uuid
   */
  appId: string;
  /** @format ^[a-z0-9._]{1,36}$ */
  messageTemplateKey: string;
  /**
   * A Message contains a list of message templates representing the same message in different locales. The system will
   * serve the template with the locale that best matches the Recipient's language preferences. If the user's language
   * preferences do not correlate to any message templates, the template defined by the `fallbackLocale` will be used.
   */
  message: Message;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

/** Message template variables associated with a certain locale. */
export interface LocaleVariables {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  localeTag: LocaleTag;
  /**
   * A map<string,string> with the key representing the variable name, and the value representing the verbiage
   * to be replaced in template string.
   */
  variables?: Record<string, string>;
}

/**
 * A Message contains a list of message templates representing the same message in different locales. The system will
 * serve the template with the locale that best matches the Recipient's language preferences. If the user's language
 * preferences do not correlate to any message templates, the template defined by the `fallbackLocale` will be used.
 * @example {"fallbackLocale":"en","templates":[{"localeTag":"en","template":"{{ deviceName }} will turn off in {{ duration }} minutes."},{"localeTag":"es","template":"{{ deviceName }} se apagará en {{ duration }} minutos."}]}
 */
export interface Message {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  fallbackLocale: LocaleTag;
  /**
   * A list of templates representing the same message in different languages.
   * @maxItems 35
   * @minItems 1
   */
  templates: MessageTemplate[];
}

/**
 * A message template definition, representing a message in a specific locale.
 * @example {"localeTag":"en","template":"Hello, {{ firstName }}!"}
 */
export interface MessageTemplate {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  localeTag: LocaleTag;
  /**
   * A message template string. Specify variables using the double curly braces convention.
   * i.e. "Hello, {{ firstName }}!"
   */
  template: string;
}

/**
 * The expected message format to be sent.
 * @default "PREDEFINED"
 */
export enum MessageType {
  PREDEFINED = 'PREDEFINED',
  ADHOC = 'ADHOC',
}

/**
 * A simplified Message model which is retured during a list operation.
 * @example {"appId":"9cb655e0-bc31-4b94-9254-c4e2d0c35224","messageTemplateKey":"motion_detected_message"}
 */
export interface PagedMessageTemplate {
  /**
   * A globally unique identifier for an app.
   * @format uuid
   */
  appId: string;
  /** @format ^[a-z0-9._]{1,36}$ */
  messageTemplateKey: string;
}

/** Represents a single page of Message Templates. */
export interface PagedMessageTemplates {
  items?: PagedMessageTemplate[];
  _links?: Links;
}

/**
 * Predefined message options. Variables from `localeVariables` matching the locale of the Message will be assigned
 * first, then `defaultVariables`.
 * @example {"messageTemplateKey":"lamp_shutoff_message","defaultVariables":{"duration":"5"},"localeVariables":[{"localeTag":"en","variables":{"deviceName":"lamp"}},{"localeTag":"es","variables":{"deviceName":"lámpara"}}]}
 */
export interface PredefinedMessage {
  /** @format ^[a-z0-9._]{1,36}$ */
  messageTemplateKey: string;
  /**
   * A map<string,string> with the key representing the variable name, and the value representing the verbiage
   * to be replaced in template string. `defaultVariables` are only used when there are no matching
   * `localeVariables`.
   */
  defaultVariables?: Record<string, string>;
  /** Variables to resolve for specific locales. */
  localeVariables?: LocaleVariables[];
}

/** Upsert an InstalledApp's Message definition. */
export interface SendInstalledAppMessageRequest {
  /**
   * A developer defined identifier for a message group.
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey: string;
  /** The expected message format to be sent. */
  messageType: MessageType;
  /**
   * Predefined message options. Variables from `localeVariables` matching the locale of the Message will be assigned
   * first, then `defaultVariables`.
   */
  predefinedMessage?: PredefinedMessage;
  /**
   * An adhoc message contains a list of message templates representing the same message in different locales. The
   * system will serve the template with the locale that best matches the Recipient's language preferences. If the
   * user's language preferences do not correlate to any message templates, the template defined by the
   * `fallbackLocale` will be used. Variables from the template matching the locale of the Message will be assigned
   * first, then `defaultVariables`.
   */
  adhocMessage?: AdhocMessage;
}

/** A response object for when a Message is successfully queued for sending. */
export type SendInstalledAppMessageResponse = object;

/** Upsert an App's message template definition. */
export interface UpsertMessageTemplateRequest {
  /**
   * A Message contains a list of message templates representing the same message in different locales. The system will
   * serve the template with the locale that best matches the Recipient's language preferences. If the user's language
   * preferences do not correlate to any message templates, the template defined by the `fallbackLocale` will be used.
   */
  message: Message;
}

/** A response object for when a MessageGroup is successfully upserted. */
export interface UpsertMessageTemplateResponse {
  /**
   * A globally unique identifier for an app.
   * @format uuid
   */
  appId: string;
  /** @format ^[a-z0-9._]{1,36}$ */
  messageTemplateKey: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface RuleRequest {
  /** The name for the Rule. Limit 100 characters. */
  name: string;
  actions: Action[];
  /** The sequence in which the actions are to be executed (i.e. Serial (default) or Parallel). */
  sequence?: ActionSequence;
  /** The time zone ID for this Rule. This overrides the Location time zone ID, but is overridden by time zone ID provided by each operand individually. */
  timeZoneId?: string;
}

export type Rule = RuleRequest & {
  /**
   * Unique id for the Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /**
   * The status of the Rule
   * @default "Enabled"
   */
  status?: 'Enabled' | 'Disabled';
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: 'Cloud' | 'Local';
  /** Owner id */
  ownerId: string;
  /**
   * The owner of the rule is either a location or user
   * @default "Location"
   */
  ownerType: 'Location' | 'User';
  /** The creator name who create the behavior */
  creator?: Creator;
  /** Created date time */
  dateCreated: string;
  /** Last updated date time */
  dateUpdated: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:rules - the user can edit the rule
   *   <li> x:rules - the user can execute the rule
   *   <li> d:rules - the user can delete the rule
   *   </ul>
   */
  allowed?: 'w:rules' | 'x:rules' | 'd:rules';
};

export interface Action {
  if?: IfAction;
  sleep?: SleepAction;
  command?: CommandAction;
  every?: EveryAction;
  location?: LocationAction;
}

export type IfAction = Condition & {
  then?: Action[];
  else?: Action[];
  /** The sequence in which the actions are to be executed */
  sequence?: IfActionSequence;
};

export interface CommandAction {
  devices: string[];
  commands: DeviceCommand[];
  /** The sequence in which the commands are to be executed i.e. Serial or Parallel (default) */
  sequence?: CommandSequence;
}

export interface SleepAction {
  duration: Interval;
}

export interface EveryAction {
  interval?: Interval;
  specific?: DateTimeOperand;
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial (default) or Parallel */
  sequence?: ActionSequence;
}

export interface LocationAction {
  /**
   * locationId is required for "User level rule". (It's optional for "Location level rule")
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  mode?: string;
}

export interface BasicCondition {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
}

export interface Condition {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
  /** A condition that returns true when its evaluation resolves to true and the previous evaluation resolved to false. */
  changes?: ChangesCondition;
  /** A condition that returns true if its evaluation is true after the specified duration. */
  remains?: RemainsCondition;
  /** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
  was?: WasCondition;
}

export interface SimpleCondition {
  left: Operand;
  right: Operand;
  aggregation?: ConditionAggregationMode;
}

export type StandardCondition = SimpleCondition & {
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
};

export type EqualsCondition = StandardCondition;

export type GreaterThanCondition = StandardCondition;

export type GreaterThanOrEqualsCondition = StandardCondition;

export type LessThanCondition = StandardCondition;

export type LessThanOrEqualsCondition = StandardCondition;

export interface BetweenCondition {
  value: Operand;
  start: Operand;
  end: Operand;
  aggregation?: ConditionAggregationMode;
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
}

/** A condition that returns true when its evaluation resolves to true and the previous evaluation resolved to false. */
export type ChangesCondition = BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
};

/** A condition that returns true if its evaluation is true after the specified duration. */
export type RemainsCondition = BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
  duration: Interval;
  /** Determines whether the condition should return true in subsequent executions after initially satisfied. Default is false. */
  latching?: boolean;
};

/** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
export type WasCondition = BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  duration: Interval;
  operand?: Operand;
};

export interface Operand {
  boolean?: boolean;
  /** @format double */
  decimal?: number;
  /** @format int64 */
  integer?: number;
  string?: string;
  array?: ArrayOperand;
  map?: MapOperand;
  device?: DeviceOperand;
  location?: LocationOperand;
  date?: DateOperand;
  /** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
  time?: TimeOperand;
  datetime?: DateTimeOperand;
}

export interface ArrayOperand {
  operands: Operand[];
  aggregation?: OperandAggregationMode;
}

export interface DateOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  reference?: DateReference;
}

export interface DateTimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface DeviceOperand {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
  path?: string;
  aggregation?: OperandAggregationMode;
  trigger?: TriggerMode;
}

export interface LocationOperand {
  /**
   * Required for User level rule, optional for Location level in request. Will always be present in response for both.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Only valid for the attribute 'WeatherAlertSeverity' */
  postalCode?: string;
  attribute: LocationAttribute;
  trigger?: TriggerMode;
}

export type MapOperand = Record<string, Operand>;

/** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
export interface TimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export enum ExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Ignored = 'Ignored',
}

export enum IfExecutionResult {
  True = 'True',
  False = 'False',
}

export enum CommandExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Offline = 'Offline',
}

/** The result of a if action execution */
export interface IfActionExecutionResult {
  result: IfExecutionResult;
}

/** The result of a command action execution */
export interface CommandActionExecutionResult {
  result: CommandExecutionResult;
  /**
   * Device ID for device actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
}

/** The result of a location action execution */
export interface LocationActionExecutionResult {
  result: ExecutionResult;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** The result of a sleep action execution */
export interface SleepActionExecutionResult {
  result: ExecutionResult;
}

/** The result of an action execution */
export interface ActionExecutionResult {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  actionId: string;
  /** The result of a if action execution */
  if?: IfActionExecutionResult;
  /** The result of a location action execution */
  location?: LocationActionExecutionResult;
  command?: CommandActionExecutionResult[];
  /** The result of a sleep action execution */
  sleep?: SleepActionExecutionResult;
}

/** The result of a Rule execution */
export interface RuleExecutionResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  id: string;
  result: ExecutionResult;
  actions?: ActionExecutionResult[];
}

export enum LocationAttribute {
  FineDust = 'FineDust',
  FineDustIndex = 'FineDustIndex',
  Humidity = 'Humidity',
  Mode = 'Mode',
  Security = 'Security',
  Temperature = 'Temperature',
  TemperatureC = 'TemperatureC',
  TemperatureF = 'TemperatureF',
  UltraFineDust = 'UltraFineDust',
  UltraFineDustIndex = 'UltraFineDustIndex',
  Weather = 'Weather',
  WeatherAlertSeverity = 'WeatherAlertSeverity',
}

export enum ArmState {
  ArmedStay = 'ArmedStay',
  ArmedAway = 'ArmedAway',
  Disarmed = 'Disarmed',
}

export enum DayOfWeek {
  Sun = 'Sun',
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
}

export enum DateReference {
  Today = 'Today',
}

export enum TimeReference {
  Now = 'Now',
  Midnight = 'Midnight',
  Sunrise = 'Sunrise',
  Noon = 'Noon',
  Sunset = 'Sunset',
}

export enum IntervalUnit {
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

export interface Interval {
  value: Operand;
  unit: IntervalUnit;
}

/** @default "Auto" */
export enum TriggerMode {
  Auto = 'Auto',
  Always = 'Always',
  Never = 'Never',
}

/** @default "None" */
export enum OperandAggregationMode {
  None = 'None',
}

/** @default "Any" */
export enum ConditionAggregationMode {
  Any = 'Any',
  All = 'All',
}

/** An array of Rules */
export interface PagedRules {
  items?: Rule[];
  _links?: Links;
}

export enum Sequence {
  Serial = 'Serial',
  Parallel = 'Parallel',
}

export interface ActionSequence {
  actions?: Sequence;
}

export interface CommandSequence {
  commands?: Sequence;
  devices?: Sequence;
}

export interface IfActionSequence {
  then?: Sequence;
  else?: Sequence;
}

/** The creator name who create the behavior */
export enum Creator {
  SMARTTHINGS = 'SMARTTHINGS',
  ARB = 'ARB',
  RECIPE = 'RECIPE',
  UNDEFINED = 'UNDEFINED',
}

export interface SceneSummary {
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The user-defined name of the Scene */
  sceneName?: string;
  /** The name of the icon */
  sceneIcon?: string;
  /** The color of the icon */
  sceneColor?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The unique identifier of the user that created the scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  createdBy?: string;
  /**
   * The date the scene was created
   * @format date-time
   */
  createdDate?: string;
  /**
   * The date the scene was last updated
   * @format date-time
   */
  lastUpdatedDate?: string;
  /**
   * The date the scene was last executed
   * @format date-time
   */
  lastExecutedDate?: string;
  /** Whether or not this scene can be edited by the logged in user using the version of the app that made the request */
  editable?: boolean;
  apiVersion?: string;
}

export interface SceneDevice {
  /** the id of the device */
  deviceId?: string;
  /** the label of the device */
  deviceLabel?: string;
  /** the name of the device */
  deviceName?: string;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceTypeId?: string;
  components?: SceneComponent[];
  /**
   * Location of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface SceneDeviceGroup {
  /** the id of the device */
  deviceGroupId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode activated by the Scene */
export interface SceneMode {
  /**
   * the id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /** the name of the mode */
  modeName?: string;
}

/** JSON body for creating or updating a Scene */
export interface SceneRequest {
  /** The user-defined name of the Scene */
  sceneName: string;
  /** The name of the icon */
  sceneIcon?: string;
  /**
   * The color of the icon
   * @format ^\#[0-9A-F]{6}$
   */
  sceneColor?: string;
  /** Non-sequential list of device actions */
  devices: SceneDeviceRequest[];
  /** List of parallel action sequences */
  sequences?: SceneActionSequence[];
  /** The mode to be activated by the Scene */
  mode?: SceneModeRequest;
  /** The security mode to be activated by the Scene */
  securityMode?: SceneSecurityModeRequest;
  /** List of device group actions */
  devicegroups?: SceneDeviceGroupRequest[];
}

export type SceneActionSequence = SceneAction[];

/** Possible scene actions, mutually exclusive */
export interface SceneAction {
  /** JSON structure for a device when creating a Scene */
  deviceRequest?: SceneDeviceRequest;
  /** The mode to be activated by the Scene */
  modeRequest?: SceneModeRequest;
  /** Sleep a particular sequence */
  sleepRequest?: SceneSleepRequest;
  /** JSON structure for a device group when creating a Scene */
  deviceGroupRequest?: SceneDeviceGroupRequest;
}

/** JSON structure for a device when creating a Scene */
export interface SceneDeviceRequest {
  /**
   * the id of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  components?: SceneComponent[];
}

/** JSON structure for a device group when creating a Scene */
export interface SceneDeviceGroupRequest {
  /**
   * the id of the device group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode to be activated by the Scene */
export interface SceneModeRequest {
  /**
   * The id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The name of the mode */
  modeName?: string;
}

/** The security mode to be activated by the Scene */
export interface SceneSecurityModeRequest {
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The id of the security mode */
  security: 'setArmStay' | 'setArmAway' | 'disarm';
  /** Additional query param */
  arguments?: string;
}

/** Sleep a particular sequence */
export interface SceneSleepRequest {
  /** Number of seconds to sleep the sequence */
  seconds: number;
}

/** A component of the scene device */
export interface SceneComponent {
  /** the id of the component */
  componentId?: string;
  capabilities?: SceneCapability[];
}

/** A device component capability */
export interface SceneCapability {
  /** The id of the capability */
  capabilityId?: string;
  /** The status of the capability */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
  /** Capability commands */
  commands?: Record<string, SceneCommand>;
}

/** A component capability command */
export interface SceneCommand {
  /** the command arguments */
  arguments?: SceneArgument[];
}

/** A capability command argument */
export interface SceneArgument {
  /** the name of the command */
  name?: string;
  /** the schema of the command */
  schema?: object;
  /** The value being set for the capability command */
  value?: object;
}

export interface ScenePagedResult {
  items?: SceneSummary[];
  _links?: Links;
}

/** {"status": "success"} */
export interface StandardSuccessResponse {
  /** @default "success" */
  status?: 'success';
}

export interface PagedCapabilities {
  items?: CapabilitySummary[];
  _links?: Links;
}

export interface CapabilitySummary {
  /**
   * A URL safe unique identifier for the capability.
   * @example "switch"
   */
  id: string;
  /**
   * The version number of the capability.
   * @default 1
   * @example 1
   */
  version: number;
  /**
   * The status of the capability.
   * * __proposed__ - The capability is under a review and refinement process. The capability definition may go through changes, some of which may be breaking.
   * * __live__ - The capability has been through review and the definition has been solidified. Live capabilities can no longer be altered.
   * * __deprecated__ - The capability is marked for removal and should only be used during a period of migration to allow for existing integrations and automations to continue to work.
   * * __dead__ - The usage of a deprecated capability has dropped to a sufficiently low level to warrant removal. The capability definition still exists but can no longer be used by automations or implemented by devices.
   */
  status: 'proposed' | 'live' | 'deprecated' | 'dead';
  /**
   * @default false
   * @example true
   */
  ephemeral?: boolean;
}

export interface Capability {
  /**
   * A URL safe unique identifier for the capability.
   * @example "namespace.colorTemperature"
   */
  id: string;
  /**
   * The version number of the capability.
   * @default 1
   * @example 1
   */
  version: number;
  /**
   * The status of the capability.
   * * __proposed__ - The capability is currently under development / in review.  The capability definition may go through changes, some of which may currently not function properly.
   * * __live__ - The capability has been through review and the definition has been codified.  Once a definition transitions from proposed to live, it cannot be altered.
   * * __deprecated__ - The capability is marked for removal in future versions.  It should only be used during a short period of time to allow for existing integrations and automations to continue to work while the transition to a newer definition is made.
   * * __dead__ - A previously deprecated definition is now ready for removal.  Usage of the deprecated definition had dropped to a sufficiently low enough level to warrant removal.  The dead definition still exists but it can no longer be used or implemented by devices.
   */
  status: 'proposed' | 'live' | 'deprecated' | 'dead';
  /**
   * An alphanumeric English language name for the capability.
   * @example "Color Temperature"
   */
  name: string;
  /**
   * @default false
   * @example true
   */
  ephemeral?: boolean;
  /**
   * A mapping of attribute names to their definitions. All attribute names are lower camelcase.
   * @example {"colorTemperature":{"schema":{"type":"object","properties":{"value":{"type":"integer","minimum":1,"maximum":30000},"unit":{"type":"string","enum":["K"],"default":"K"},"required":["value"]}}}}
   */
  attributes?: Record<string, CapabilityAttribute>;
  /**
   * A mapping of command names to their definitions. All command names are lower camelcase.
   * @example {"setColorTemperature":{"arguments":[{"name":"temperature","schema":{"type":"integer","minimum":1,"maximum":30000}}]}}
   */
  commands?: Record<string, CapabilityCommand>;
}

export interface CapabilityAttribute {
  /** [JSON schema](http://json-schema.org/specification-links.html#draft-4) for the attribute. The API implements JSON schema version 4. For more info regarding JSON schema, please read [Understanding JSON Schema](https://json-schema.org/understanding-json-schema/index.html). */
  schema?: AttributeSchema;
  /**
   * The name of the command that sets this attribute
   * @example "setColor"
   */
  setter?: string;
  /**
   * a list of objects that specify which commands set this attribute
   * @example [{"command":"on","value":"on"},{"command":"off","value":"off"}]
   */
  enumCommands?: {
    /**
     * the command that sets this attribute to the associated value
     * @example null
     */
    command: string;
    /** the value that this command will set the attribute to */
    value: string;
  }[];
}

/** [JSON schema](http://json-schema.org/specification-links.html#draft-4) for the attribute. The API implements JSON schema version 4. For more info regarding JSON schema, please read [Understanding JSON Schema](https://json-schema.org/understanding-json-schema/index.html). */
export interface AttributeSchema {
  /** The capability's name, no spaces. */
  title?: string;
  /** For schema this will always be object and is the only allowed value. */
  type?: 'object';
  /** Data type and value properties used to describe the attribute. */
  properties: AttributeProperties;
  additionalProperties?: false;
  /** Provide requirement for `value`, `unit`, and `data` fields. */
  required?: ('value' | 'unit' | 'data')[];
}

/** Data type and value properties used to describe the attribute. */
export interface AttributeProperties {
  /**
   * Properties that describe the value of an attribute.
   * @example {"type":"number","minimum":0,"maximum":20}
   */
  value: {
    /** Data type of the attribute's value. */
    type?: string;
    /** Array of possible values or a `minimum:` `maximum:` can be defined for `integer` type. */
    enum?: string[];
    [key: string]: any;
  };
  /** The unit which describes the value of the attribute. */
  unit?: {
    /**
     * Data type for the unit. This is defined by capability schema as a `string`.
     * @default "string"
     */
    type?: 'string';
    /**
     * Array of all possible units for the attribute value.
     * @example ["mm","in"]
     */
    enum?: string[];
    /**
     * The default unit to be used for the attribute value.
     * @example "mm"
     */
    default?: string;
  };
  /** Special case details may be desired to describe the attribute that may not be used the same as a value. Some examples are a timeout or a lock code. */
  data?: {
    /**
     * The data type for the `data` schema is object.
     * @default "object"
     */
    type: 'object';
    /**
     * Indicates if properties not explicitly defined by the schema are allowed. Default is false.
     * @default false
     */
    additionalProperties?: boolean;
    /** An array of the properties the `data` schema requires. */
    required?: string[];
    /**
     * Objects can be described in JSON schema for the `data` that should be stored on this attribute.
     * @example {"val":{"type":"string"}}
     */
    properties?: object;
  };
}

export interface CapabilityCommand {
  /**
   * The name of the command. Unique for the capability
   * @pattern ^[[a-z0-9]*([A-Z0-9][a-z]*)*]{1,36}$
   * @example "setTemperature"
   */
  name: string;
  /** An array of argument definitions. The arguments must be supplied in the order specified. */
  arguments?: Argument[];
}

export interface Argument {
  /**
   * A name that is unique within the command. Used for i18n and named argument command execution.
   * @pattern ^[[a-z0-9]*([A-Z0-9][a-z]*)*]{1,36}$
   */
  name: string;
  /**
   * Whether or not the argument must be supplied.
   * If the argument is at the end of the arguments array then it can be completely ignored.
   * If the argument is followed by another argument `null` must be supplied.
   * @default false
   */
  optional?: boolean;
  /** [JSON schema](http://json-schema.org/specification-links.html#draft-4) for the argument. The API implements JSON schema version 4. For more info regarding JSON schema, please read [Understanding JSON Schema](https://json-schema.org/understanding-json-schema/index.html). */
  schema: object;
}

/** The list of supported locales. */
export interface CapabilityLocaleLocalizations {
  items?: LocaleReference[];
}

export interface CapabilityLocalization {
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  tag: LocaleTag;
  /**
   * A localized label for the capability
   * @example "Modo de ar condicionado"
   */
  label?: string;
  /**
   * A localized description of the capability
   * @example "Modo de ar condicionado"
   */
  description?: string;
  /**
   * Map of attribute name to localizations
   * @example {"airConditionerMode":{"displayTemplate":"é suposto {{device.label}} a palavra {{attribute}} igual a {{value}}.","label":"Este é o modo de ar condicionado","i18n":{"value":{"auto":{"label":"Auto","description":"Este é o modo automático"},"cool":{"label":"Frio","description":"Este é o modo frio"}}}}}
   */
  attributes?: Record<
    string,
    {
      /**
       * The localized version of the label value
       * @example "Modo de ar condicionado"
       */
      label?: string;
      /**
       * A localized description of what the attribute represents
       * @example "Modo de ar condicionado"
       */
      description?: string;
      /**
       * A template string for the text that will be displayed regarding the attribute state.
       * @example "é suposto {{device.label}} a palavra {{attribute}} igual a {{value}}."
       */
      displayTemplate?: string;
      /** Map of state property (value, unit, etc..) to localization mapping */
      i18n?: Record<
        string,
        Record<
          string,
          {
            /** The localized substitution for the property value */
            label: string;
            /** A description of the value */
            description?: string;
          }
        >
      >;
    }
  >;
  /**
   * Map of command name to localizations
   * @example {"setAirConditionerMode":{"arguments":{"mode":{"i18n":{"auto":{"label":"Auto"},"cool":{"label":"Frio"}}}}}}
   */
  commands?: Record<
    string,
    {
      label?: string;
      description?: string;
      /** Map of argument name to localizations */
      arguments?: Record<
        string,
        {
          /** Map of argument values to localizations */
          i18n?: Record<
            string,
            {
              /** The localized substitution for the argument value */
              label: string;
            }
          >;
          label?: string;
          description?: string;
        }
      >;
    }
  >;
}

export interface NamespaceRequest {
  /**
   * A URL safe globally unique namespace name (lower case ascii letters and numbers only)
   * @pattern ^[a-z0-9]{1,36}$
   * @example "companyx"
   */
  name: string;
}

export interface CreateCapabilityRequest {
  /**
   * An alphanumeric English language name for the capability.
   * @pattern ^[[a-zA-Z0-9]{1}][[a-zA-Z0-9 ]+]{1,254}$
   * @example "Color Temperature"
   */
  name: string;
  /**
   * @default false
   * @example true
   */
  ephemeral?: boolean;
  /**
   * A mapping of attribute names to their definitions. All attribute names are lower camelcase. Required if no commands are specified.
   * @example {"colorTemperature":{"schema":{"type":"object","properties":{"value":{"type":"integer","minimum":1,"maximum":30000},"unit":{"type":"string","enum":["K"],"default":"K"}},"additionalProperties":false},"required":["value"]}}
   */
  attributes?: Record<string, CapabilityAttribute>;
  /**
   * A mapping of command names to their definitions. All command names are lower camelcase. Required if no attributes are specified.
   * @example {"setColorTemperature":{"arguments":[{"name":"temperature","optional":false,"schema":{"type":"integer","minimum":1,"maximum":30000}}]}}
   */
  commands?: Record<string, CapabilityCommand>;
}

export interface UpdateCapabilityRequest {
  /**
   * A mapping of attribute names to their definitions. All attribute names are lower camelcase.
   * @example {"colorTemperature":{"schema":{"type":"object","properties":{"value":{"type":"integer","minimum":1,"maximum":30000},"unit":{"type":"string","enum":["K"],"default":"K"}},"additionalProperties":false},"required":["value"]}}
   */
  attributes?: Record<string, CapabilityAttribute>;
  /**
   * A mapping of command names to their definitions. All command names are lower camelcase.
   * @example {"setColorTemperature":{"arguments":[{"name":"temperature","optional":false,"schema":{"type":"integer","minimum":1,"maximum":30000}}]}}
   */
  commands?: Record<string, CapabilityCommand>;
}

export type DeleteNamespaceResponse = object;

export interface Namespace {
  /**
   * A URL safe globally unique namespace name (ascii letters and numbers only)
   * @example "companyx"
   */
  name: string;
  /** The type of owner of the namespace. */
  ownerType: 'user' | 'organization' | 'system';
  /**
   * id of the owner (user, or in the future, organization)
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  ownerId: string;
}

export type NamespaceList = Namespace[];

export type CreateCapabilityPresentationRequest = CapabilityPresentationForPUT & {
  id: string;
  /** The version number of the capability. */
  version: Version;
};

export interface PagedDeviceActivities {
  items?: DeviceActivity[];
  _links?: Links;
}

export interface DeviceActivity {
  /**
   * Device ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * Device nick name
   * @example "TV"
   */
  deviceName?: string;
  /**
   * Location ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * The IS0-8601 date time strings in UTC of the activity
   * @format date-time
   * @example "2017-12-18T22:14:52Z"
   */
  time?: string;
  /**
   * Translated human readable string (localized)
   * @example "battery of Button is: 89%"
   */
  text?: string;
  /**
   * device component ID. Not nullable.
   * @example "main"
   */
  component: string;
  /**
   * device component label. Nullable.
   * @example "left button"
   */
  componentLabel?: string;
  /**
   * capability name
   * @example "battery"
   */
  capability?: string;
  /**
   * attribute name
   * @example "battery"
   */
  attribute?: string;
  /**
   * attribute value
   * @example 0
   */
  value?: object;
  /** @example "%" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * translated attribute name based on 'Accept-Language' requested in header
   * @example "스위치"
   */
  translatedAttributeName?: string;
  /**
   * translated attribute value based on 'Accept-Language' requested in header
   * @example "켜짐"
   */
  translatedAttributeValue?: string;
}

/** @example {"capabilities":["weather","forecast","airQuality","airQualityForecast"],"isaId":"d61126ba-a485-4c6d-8ec4-0d41f5f2757c","type":"EXECUTION","predicate":"now.weather.temperature.value > 20 && now.airQuality.o2Index.value > 1"} */
export interface ServiceSubscriptionBody {
  /**
   * capability name(s).
   * NOTE: alert cannot be combined with other capabilities
   */
  capabilities: ('alert' | 'weather' | 'airQuality' | 'forecast' | 'airQualityForecast')[];
  /** InstalledApp ID */
  isaId: string;
  /** Geo Place ID (This ID is only supported in "alert" capability), postalCode must be empty */
  geoplaceId?: string;
  /** Postal code (This ID is only supported in "alert" capability), geoplaceId must be empty */
  postalCode?: string;
  /** DIRECT or EXECUTION delivery, default to DIRECT */
  type?: string;
  /** JEXL formatted expression. See https://commons.apache.org/proper/commons-jexl/reference/syntax.html */
  predicate?: string;
}

/** @example {"locationId":"fb9e719c-e432-4dc3-86b3-7b64ce76c1dc","subscriptionId":"76ba490c-f10d-4746-8f20-f291b327836c"} */
export interface ServiceNewSubscription {
  /** location ID */
  locationId: string;
  /** subscription ID created */
  subscriptionId?: string;
}

/** @example {"locationId":"fb9e719c-e432-4dc3-86b3-7b64ce76c1dc","count":1} */
export interface ServiceDeleteSubscription {
  /** location ID */
  locationId: string;
  /** number of subscription deleted */
  count: number;
}

/** @example {"locationId":"fb9e719c-e432-4dc3-86b3-7b64ce76c1dc","subscriptions":[{"subscriptionId":1234,"predicate":"weather.temperature.value > 15","type":"EXECUTION","subscribedCapabilities":["weather"]}],"city":"Sunnyvale","latitude":44.99,"longitude":-93.26} */
export interface ServiceLocationInfo {
  /** location ID */
  locationId: string;
  subscriptions: {
    /** subscription ID */
    subscriptionId: string;
    /** Geo Place ID (This ID is only supported in "alert" capability) */
    geoplaceId?: string;
    /** DIRECT or EXECUTION delivery, default to DIRECT */
    type: string;
    /** JEXL expression string */
    predicate?: string;
    /** capability name(s) */
    subscribedCapabilities: ServiceCapabilities;
  }[];
  /**
   * latitude
   * @format float
   */
  latitude?: number;
  /**
   * longitude
   * @format float
   */
  longitude?: number;
  /** city */
  city?: string;
}

/**
 * capability name(s)
 * @example {"capabilities":["alert","weather","forecast","airQuality","airQualityForecast"]}
 */
export type ServiceCapabilities = ('alert' | 'weather' | 'airQuality' | 'forecast' | 'airQualityForecast')[];

/** @example {"locationId":"fb9e719c-e432-4dc3-86b3-7b64ce76c1dc","forecast":{"precip1Hour":{"value":0,"unit":"mm"},"precip6Hour":{"value":0,"unit":"mm"},"precip24Hour":{"value":0.05,"unit":"mm"},"snow1Hour":{"value":0,"unit":"cm"},"snow6Hour":{"value":0,"unit":"cm"},"snow24Hour":{"value":0,"unit":"cm"},"temperature1Hour":{"value":30,"unit":"C"},"temperature2Hour":{"value":30,"unit":"C"},"temperature3Hour":{"value":30,"unit":"C"},"temperature4Hour":{"value":30,"unit":"C"},"temperature5Hour":{"value":30,"unit":"C"},"temperature6Hour":{"value":30,"unit":"C"},"temperature7Hour":{"value":30,"unit":"C"},"temperature8Hour":{"value":30,"unit":"C"},"temperature9Hour":{"value":30,"unit":"C"},"temperature10Hour":{"value":30,"unit":"C"},"temperature11Hour":{"value":30,"unit":"C"},"temperature12Hour":{"value":30,"unit":"C"},"lastUpdateTime":{"value":"2020-06-18T18:12:57.865Z"}},"weather":{"cloudCeiling":{"value":800,"unit":"m"},"cloudCoverPhrase":{"value":"Partly Cloudy"},"relativeHumidity":{"value":95,"unit":"%"},"sunriseTimeLocal":{"value":"2018-12-10T07:34:27Z"},"sunsetTimeLocal":{"value":"2018-12-10T17:27:59Z"},"temperature":{"value":38,"unit":"C"},"temperatureFeelsLike":{"value":38,"unit":"C"},"uvDescription":{"value":"Low"},"uvIndex":{"value":1},"visibility":{"value":10,"unit":"Km"},"weatherDetailUrl":{"value":"https://ssiotw.kr-weathernews.com/mv3/html/main.html?region=1114000000"},"windDirection":{"value":10,"unit":"°"},"windDirectionCardinal":{"value":"ESE"},"windGust":{"value":10,"unit":"Km/h"},"windSpeed":{"value":2,"unit":"Km/h"},"wxPhraseLong":{"value":"Partly Cloudy"},"lastUpdateTime":{"value":"2020-06-18T18:12:57.865Z"}},"airQuality":{"o3Amount":{"value":10,"unit":"μg/m^3"},"o3Index":{"value":50,"unit":"EPA"},"airQualityIndex":{"value":1,"unit":"CAQI"},"no2Amount":{"value":41.4,"unit":"μg/m^3"},"no2Index":{"value":21,"unit":"EPA"},"so2Amount":{"value":26.2,"unit":"μg/m^3"},"so2Index":{"value":14,"unit":"EPA"},"coAmount":{"value":8020.3,"unit":"μg/m^3"},"coIndex":{"value":76,"unit":"EPA"},"pm10Amount":{"value":154.5,"unit":"μg/m^3"},"pm10Index":{"value":1,"unit":"EPA"},"pm25Amount":{"value":35,"unit":"μg/m^3"},"pm25Index":{"value":1,"unit":"EPA"},"lastUpdateTime":{"value":"2020-06-18T18:12:57.865Z"}},"airQualityForecast":{"pm10Index1Hour":{"value":1},"pm10Index2Hour":{"value":1},"pm10Index3Hour":{"value":1},"pm10Index4Hour":{"value":1},"pm10Index5Hour":{"value":1},"pm10Index6Hour":{"value":1},"pm10Index7Hour":{"value":1},"pm10Index8Hour":{"value":1},"pm10Index9Hour":{"value":1},"pm10Index10Hour":{"value":1},"pm10Index11Hour":{"value":1},"pm10Index12Hour":{"value":1},"pm10Amount1Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount2Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount3Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount4Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount5Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount6Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount7Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount8Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount9Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount10Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount11Hour":{"value":30,"unit":"μg/m^3"},"pm10Amount12Hour":{"value":30,"unit":"μg/m^3"},"pm25Index1Hour":{"value":1},"pm25Index2Hour":{"value":1},"pm25Index3Hour":{"value":1},"pm25Index4Hour":{"value":1},"pm25Index5Hour":{"value":1},"pm25Index6Hour":{"value":1},"pm25Index7Hour":{"value":1},"pm25Index8Hour":{"value":1},"pm25Index9Hour":{"value":1},"pm25Index10Hour":{"value":1},"pm25Index11Hour":{"value":1},"pm25Index12Hour":{"value":1},"pm25Amount1Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount2Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount3Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount4Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount5Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount6Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount7Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount8Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount9Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount10Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount11Hour":{"value":30,"unit":"μg/m^3"},"pm25Amount12Hour":{"value":30,"unit":"μg/m^3"},"lastUpdateTime":{"value":"2020-06-18T18:12:57.865Z"}}} */
export interface ServiceCapabilityData {
  /** location ID */
  locationId: string;
  /** capability name(s) */
  name?: ServiceCapabilities;
  alert?: {
    lastUpdateTime?: {
      /**
       * Time the data was pull from content provider.
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    headlineText?: {
      /** severe alert headline text */
      value?: string;
    };
    severity?: {
      /** severity of the alert. Smaller the number the more severe the alert is. */
      value?: number;
    };
    messageType?: {
      /**
       * 1: new
       * 2: update
       * 3: cancel
       */
      value?: number;
    };
    issueTime?: {
      /** UTC time when the alert is issued */
      value?: string;
    };
    expireTime?: {
      /** UTC time when the alert is expired */
      value?: string;
    };
  }[];
  airQuality?: {
    lastUpdateTime?: {
      /**
       * Time the data was pull from content provider.
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    vendor?: {
      /** Name of the content provider */
      value?: string;
    };
    version?: {
      /** API version number used with the given vendor */
      value?: string;
    };
    airQualityIndex?: {
      /** air quality index */
      value?: number;
      /** CAQI */
      unit?: string;
    };
    o3Amount?: {
      /**
       * (Available for Korea Only) Ozone pollutant in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    o3Index?: {
      /** (Available for non-Korea Only) index of Ozone pollutant */
      value?: number;
      /** EPA */
      unit?: string;
    };
    no2Amount?: {
      /**
       * (Available for Korea Only) Nitrogen Dioxide pollutant in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    no2Index?: {
      /** (Available for non-Korea Only) index of Nitrogen Dioxide pollutant */
      value?: number;
      /** EPA */
      unit?: string;
    };
    so2Amount?: {
      /**
       * (Available for Korea Only) Sulfur Dioxide pollutant in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    so2Index?: {
      /** (Available for non-Korea Only) index of Sulfur Dioxide pollutant */
      value?: number;
      /** EPA */
      unit?: string;
    };
    coAmount?: {
      /**
       * (Available for Korea Only) Carbon Monoxide pollutant in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    coIndex?: {
      /** (Available for non-Korea Only) index of Carbon Monoxide pollutant */
      value?: number;
      /** EPA */
      unit?: string;
    };
    pm10Amount?: {
      /**
       * amount of particulate matter less than 10 microns in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Index?: {
      /** index of particulate matter less than 10 microns */
      value?: number;
      /** EPA */
      unit?: string;
    };
    pm25Amount?: {
      /**
       * amount of particulate matter less than 2.5 microns in ug/m3
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Index?: {
      /** index of particulate matter less than 2.5 microns */
      value?: number;
      /** EPA */
      unit?: string;
    };
  };
  forecast?: {
    lastUpdateTime?: {
      /**
       * Time the data was pull from content provider.
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    vendor?: {
      /** Name of the content provider */
      value?: string;
    };
    version?: {
      /** API version number used with the given vendor */
      value?: string;
    };
    precip1Hour?: {
      /**
       * Rolling hour liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin1Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 1 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax1Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * maximium 1 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 2 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 2 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 2 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 3 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 3 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 3 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 4 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 4 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 4 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      unit?: string;
    };
    precip5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan) 5 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 5 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 5 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip6Hour?: {
      /**
       * 6 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin6Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 6 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax6Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 6 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 7 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 7 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 7 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 8 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 8 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 8 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 9 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 9 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 9 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 10 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 10 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 10 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 11 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 11 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 11 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 12 hours forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMin12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 12 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precipMax12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * minimium 12 hour forecast liquid precipitation amount in millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    precip24Hour?: {
      /**
       * Rolling twenty-four hour liquid precipitation amount in
       * millimeters
       * @format float
       */
      value?: number;
      /** mm */
      unit?: string;
    };
    snow1Hour?: {
      /**
       * One hour snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin1Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium one hour forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax1Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium one hour forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 2 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 2 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax2Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 2 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 3 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 3 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax3Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 3 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 4 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 4 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax4Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 4 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 5 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 5 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax5Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 5 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow6Hour?: {
      /**
       * 6 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin6Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 6 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax6Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 6 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 7 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 7 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax7Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 7 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 8 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 8 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax8Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 8 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 9 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 9 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax9Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 9 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 10 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 10 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax10Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 10 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 11 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 11 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax11Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 11 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * 12 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMin12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Minimium 12 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snowMax12Hour?: {
      /**
       * (This attribute is only available in Korea and Japan)
       * Maximium 12 hours forecast snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    snow24Hour?: {
      /**
       * Twenty four hour snowfall amount in centimeters
       * @format float
       */
      value?: number;
      /** cm */
      unit?: string;
    };
    temperature1Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature2Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature3Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature4Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature5Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature6Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature7Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature8Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature9Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature10Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature11Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperature12Hour?: {
      /**
       * Rolling hour temperature in Celcius.
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
  };
  airQualityForecast?: {
    lastUpdateTime?: {
      /**
       * Time the data was pull from content provider.
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    vendor?: {
      /** Name of the content provider */
      value?: string;
    };
    version?: {
      /** API version number used with the given vendor */
      value?: string;
    };
    pm10Index1Hour?: {
      /**
       * (This attribute is only available in Korea)
       * one hour index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index2Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 2 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index3Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 3 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index4Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 4 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index5Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 5 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index6Hour?: {
      /**
       * (This attribute is only available in Korea)
       * six hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index7Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 7 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index8Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 8 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index9Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 9 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index10Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 10 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index11Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 11 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Index12Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 12 hours index forecast of particulate matter less than 10 microns
       */
      value?: number;
    };
    pm10Amount1Hour?: {
      /**
       * (This attribute is only available in Korea)
       * one hour dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount2Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 2 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount3Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 3 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount4Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 4 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount5Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 5 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount6Hour?: {
      /**
       * (This attribute is only available in Korea)
       * six hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount7Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 7 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount8Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 8 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount9Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 9 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount10Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 10 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount11Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 11 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm10Amount12Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 12 hours dust amount forecast of particulate matter less than 10 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Index1Hour?: {
      /**
       * (This attribute is only available in Korea)
       * one hour index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index2Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 2 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index3Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 3 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index4Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 4 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index5Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 5 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index6Hour?: {
      /**
       * (This attribute is only available in Korea)
       * six hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index7Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 7 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index8Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 8 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index9Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 9 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index10Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 10 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index11Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 11 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Index12Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 12 hours index forecast of particulate matter less than 2.5 microns
       */
      value?: number;
    };
    pm25Amount1Hour?: {
      /**
       * (This attribute is only available in Korea)
       * one hour dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount2Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 2 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount3Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 3 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount4Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 4 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount5Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 5 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount6Hour?: {
      /**
       * (This attribute is only available in Korea)
       * six hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount7Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 7 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount8Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 8 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount9Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 9 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount10Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 10 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount11Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 11 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
    pm25Amount12Hour?: {
      /**
       * (This attribute is only available in Korea)
       * 12 hours dust amount forecast of particulate matter less than 2.5 microns
       * @format double
       */
      value?: number;
      /** μg/m^3 */
      unit?: string;
    };
  };
  weather?: {
    lastUpdateTime?: {
      /**
       * Time the data was pull from content provider.
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    vendor?: {
      /** Name of the content provider */
      value?: string;
    };
    version?: {
      /** API version number used with the given vendor */
      value?: string;
    };
    cloudCeiling?: {
      /** (This attribute is not available in Korea and Japan) Base of lowest Mostly Cloudy or Cloudy layer in meters */
      value?: number;
      /** m */
      unit?: string;
    };
    cloudCoverPhrase?: {
      /**
       * (This attribute is not available in Korea and Japan)
       * Descriptive sky cover - based on percentage of cloud cover.
       *
       * Range - Clear: coverage < 0.09375; Partly Cloudy: coverage < .59375; Mostly Cloudy: coverage < .75; Cloudy: coverage >= .75
       */
      value?: string;
    };
    iconCode?: {
      /** This number is the key to the weather icon lookup. */
      value?: number;
    };
    conditionState?: {
      /** enumerated string of [CLEAR, SNOW, RAIN, CLOUDY, STORM, DUSTY, FOGGY] */
      value?: string;
    };
    relativeHumidity?: {
      /**
       * The relative humidity of the air, which is defined as the
       * ratio of the amount of water vapor in the air to the amount
       * of vapor required to bring the air to saturation at a
       * constant temperature. Relative humidity is always expressed
       * as a percentage.
       *
       * Range - 0 to 10
       */
      value?: number;
      /** % */
      unit?: string;
    };
    sunriseTimeLocal?: {
      /**
       * This field contains the local time of sunrise. It reflects
       * any local daylight savings conventions in UTC.
       *
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    sunsetTimeLocal?: {
      /**
       * This field contains the local time of sunset. It reflects
       * any local daylight savings conventions.
       *
       * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
       */
      value?: string;
    };
    temperature?: {
      /**
       * Temperature in Celcius
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    temperatureFeelsLike?: {
      /**
       * An apparent temperature in Celcius
       * @format float
       */
      value?: number;
      /** C */
      unit?: string;
    };
    uvDescription?: {
      /** (This attribute is not available in Korea and Japan) The UV index description which complements the uvIndex value */
      value?: string;
      unit?: string;
    };
    uvIndex?: {
      /**
       * The UV index provides indices of the intensity of the solar
       * radiation level and risk of skin damage due to exposure.
       *
       * Range - -2=Not Available, -1=No Report, 0-2=Low, 3-5=Moderate, 6-7=High, 8-10= Very High, 11-16=Extreme
       */
      value?: number;
    };
    visibility?: {
      /** The horizontal visibility at the observation point in kilometers */
      value?: number;
      /** Km */
      unit?: string;
    };
    weatherDetailUrl?: {
      /** A detail URL from weather vendor with a detail weather information web page */
      value?: string;
    };
    windDirection?: {
      /**
       * The magnetic wind direction from which the wind blows
       * expressed in degrees.
       *
       * Range - 0<=wind_dire_deg<=350, in 10 degree intervals
       */
      value?: number;
      /** ° */
      unit?: string;
    };
    windDirectionCardinal?: {
      /**
       * (This attribute is not available in Korea and Japan)
       * This field contains the cardinal direction from which the
       * wind blows in an abbreviated form.
       *
       * Range - N, NNE, NE, ENE, E, ESE, SE, SSE, S, SSW, SW, WSW, W, WNW, NW, NNW, CALM
       */
      value?: string;
    };
    windGust?: {
      /**
       * This data field contains information about sudden and
       * temporary variations of the average Wind Speed in kilometers
       * per hour.
       */
      value?: number;
      /** Km/h */
      unit?: string;
    };
    windSpeed?: {
      /**
       * The wind information reported in the hourly current
       * conditions corresponds to a 10-minute average called the
       * sustained wind speed in kilometers per hour
       */
      value?: number;
      /** Km/h */
      unit?: string;
    };
    wxPhraseLong?: {
      /**
       * A text description of observed weather conditions
       * accompanying the iconCode field.
       *
       * Range - 32 character phrase
       */
      value?: string;
    };
  };
}

/** @example {"text":"Hi Samsung SmartThings! This is the text to speech service","languageCode":"en-US","voiceId":"Matthew","audioFormat":"mp3","ttsProvider":"polly","engine":"neural","speakingStyle":"conversational"} */
export interface TTSBody {
  /** Text to be converted to audio. Cannot exceed 2000 characters for Polly and 425 characters for Bixby */
  text: string;
  /** Language used for the text to be converted to speech. Please refer tts/info API to get the options available */
  languageCode: string;
  /** VoiceId to be used for the text. Please refer tts/info API to get the options available */
  voiceId: string;
  /** Audio format of the audio file, default to mp3 when ttsProvider is Amazon Polly, default to pcm when ttsProvider is Bixby. Amazon Polly supports mp3 and pcm. Bixby supports only pcm. */
  audioFormat?: 'mp3' | 'pcm';
  /** TTS provider to use for converting text to speech, default to polly */
  ttsProvider?: 'polly' | 'bixby';
  /** TTS engine to be used, default to standard, standard - robotic voice, neural - human like and natural voice. This option is available only when ttsProvider is Amazon Polly. Please refer tts/info API to get the options available */
  engine?: 'standard' | 'neural';
  /** Speaking style to be used. This option is available only when ttsProvider is Amazon Polly, engine is neural, and voiceIds are one of the following - Matthew, Joanna, Lupe. Please refer tts/info API to get the options available */
  speakingStyle?: 'news' | 'conversational';
}

/** @example {"deviceId":"44dd1e8d-19df-5715-cd44-5cff17a552ee","text":"Hi Samsung SmartThings! This is the text to speech service","languageCode":"en-US","voiceId":"Matthew","audioFormat":"mp3","ttsProvider":"polly","engine":"neural","speakingStyle":"conversational","volume":50} */
export interface PlaytextBody {
  /** Device ID of device on which the audio should be played. Device must support audioNotification capability. */
  deviceId: string;
  /** Text to be converted to audio. Cannot exceed 2000 characters for Polly and 425 characters for Bixby */
  text: string;
  /** Language used for the text to be converted to speech. Please refer tts/info API to get the options available */
  languageCode: string;
  /** VoiceId to be used for the text. Please refer tts/info API to get the options available */
  voiceId: string;
  /** Audio format of the audio file, default to mp3 when ttsProvider is Amazon Polly, default to pcm when ttsProvider is Bixby. Amazon Polly supports mp3 and pcm. Bixby supports only pcm. */
  audioFormat?: 'mp3' | 'pcm';
  /** TTS provider to use for converting text to speech, default to polly */
  ttsProvider?: 'polly' | 'bixby';
  /** TTS engine to be used, default to standard, standard - robotic voice, neural - human like and natural voice. This option is available only when ttsProvider is Amazon Polly. Please refer tts/info API to get the options available */
  engine?: 'standard' | 'neural';
  /** Speaking style to be used. This option is available only when ttsProvider is Amazon Polly, engine is neural, and voiceIds are one of the following - Matthew, Joanna, Lupe. Please refer tts/info API to get the options available */
  speakingStyle?: 'news' | 'conversational';
  /**
   * Volume of the device at which the audio notification will be played
   * @min 0
   * @max 100
   */
  volume?: number;
}

/** @example {"message":"Successfully created an audio file","audioURL":"https://generic-tts-prod.s3.amazonaws.com/polly/6f546dd37587382fdafd7eb8a68d15e833efc8ed7278b17bc8ceece20ce70876.mp3"} */
export interface ConvertedTTS {
  /** message to indicate success */
  message: string;
  /** Audio URL */
  audioURL: string;
}

/** @example {"message":"Audio played on device successfully"} */
export interface PlayedText {
  /** message to indicate success */
  message: string;
}

/** @example {"voices":[{"Gender":"Female","Id":"Joanna","LanguageCode":"en-US","LanguageName":"US English","Name":"Joanna","SupportedEngines":["neural","standard"],"TTSProvider":"polly","SpeakingStyle":["news","conversational"]},{"Gender":"Male","Id":"Maxim","LanguageCode":"ru-RU","LanguageName":"Russian","Name":"Maxim","SupportedEngines":["standard"],"TTSProvider":"polly"},{"Gender":"Female","Id":"Lupe","LanguageCode":"es-US","LanguageName":"US Spanish","Name":"Lupe","SupportedEngines":["neural","standard"],"TTSProvider":"polly","SpeakingStyle":["news"]},{"Gender":"Female","Id":"F05","LanguageCode":"en-US","LanguageName":"USA","Name":"Lisa","TTSProvider":"bixby"}]} */
export interface TTSInfo {
  /** Voices supported by the TTS service */
  voices: {
    /** Gender of the voice */
    Gender: 'Female' | 'Male';
    /** Voice id of the voice */
    Id: string;
    /** Language code of the voice */
    LanguageCode: string;
    /** Language of the voice */
    LanguageName: string;
    /** Name of the voice */
    Name: string;
    /** Supported engines for the voice. This option will be available only when TTSProvider is Amazon Polly */
    SupportedEngines?: ('neural' | 'standard')[];
    /** TTS provider for the voice */
    TTSProvider: 'bixby' | 'polly';
    /** Supported speaking styles for the voice.  This option will be available only when TTSProvider is Amazon Polly, engine is neural, and voiceIds are one of the following - Matthew, Joanna, Lupe */
    SpeakingStyle?: ('news' | 'conversational')[];
  }[];
}

export interface UserIdApp {
  /** UserId */
  userId?: string;
  endpointApps?: EndpointApp[];
}

export interface Isa {
  /** Possible values - __requiresLogin__ or __loggedIn__. These two values determine what fields are returned in this response. If value is "requiresLogin", only "oAuthLink" is returned in the response. If value is "loggedIn", only isaId, partnerName, appName, devices and icons are returned. */
  pageType?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** partner or brand name eg LIFX Inc. */
  partnerName?: string;
  /** Connector name. eg Lifx (Connect) */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** location of the installed smart app */
  locationId?: string;
  devices?: DeviceResults[];
  /** generated oAuth link for the user to login to partner server. This will only be returned when the user is not logged in. */
  oAuthLink?: string;
  viperAppLinks?: ViperAppLinks;
  /** connection status between partner and ST platform */
  partnerSTConnection?: 'connected' | 'disconnected';
}

export interface LocationIsa {
  installedSmartApps?: IsaResults[];
}

export interface IsaResults {
  /** isaId installed for the user */
  isaId: string;
  /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
  appName: string;
  /** Parnter name eg Lifx Inc */
  partnerName: string;
  /** url of partner icon */
  icon: string;
  /** url of partner icon in 2x dimensions */
  icon2x: string;
  /** url of partner icon in 3x dimensions */
  icon3x: string;
  /** location of the installed smart app */
  locationId: string;
  /** connection status between partner and ST platform */
  partnerSTConnection: 'connected' | 'disconnected';
  /** endpoint app id of the installed smart app */
  endpointAppId: string;
}

export interface PostEndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface EndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName?: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl?: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** endpoint app id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId?: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret?: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl?: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType?: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface DeviceResults {
  /** deviceId created by DM */
  deviceId?: string;
  /** initial device name from the partner */
  name?: string;
}

/** @example 30 */
export type CommandArguments = string;

export interface PostReceipt {
  /**
   * @format uuid
   * @example "viper_9121f970-f503-11e8-a7de-7319cef9605d"
   */
  endpointAppId?: string;
  /**
   * @format uuid
   * @example "e3fd04cb-c488-4bbd-9759-8deb512656a8"
   */
  stClientId?: string;
  /**
   * @format uuid
   * @example "02c75d945e69e167233cb635b1f9be76d97ebb0b04f4e6839f3acfad320bed64ab86838dc6312585b037259e7797bf2bb44b3caa7a60539c1f402abe3bbe9256424615fddc48e76823b9c230b15669901becb33711e48192aa54a31e4e287ff47295c61c15e2e046103f13aa250bb561136625b69304cc31ef5004d267d0847184426144c60a74329bb47e2f773469ebb6a1e585175370fda78e03413abbcafe51665e8cbe51adf37dd5a3ff376300ebdbe2a359589951a72867bd3fcc574bd77b9ac85127023f931de3c5bcb213efeab3d94a7ee4a3d20acc6f6e575755b10bceb74290f4182c9bddc407d4361710492611568ebcb0b2ffac09e70d0c977d5f"
   */
  stClientSecret?: string;
}

export interface GenerateStOauthBody {
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
}

export interface ViperAppLinks {
  /** app deep linking to partners in android */
  android?: string;
  /** app deep linking to partners in ios */
  ios?: string;
  /** whether deep app linking is enabled */
  isLinkingEnabled?: boolean;
}

/**
 * The type of event passed to the app being executed. The type will be one of:
 *   * DEVICE_COMMANDS_EVENT - _Only applicable for cloud-to-cloud device integration apps._ An event as a result of a device command execution request.
 *   * DEVICE_EVENT - A device event as a result of a subscription the app created.
 *   * DEVICE_HEALTH_EVENT - A device health event as a result of a change in a device's health.
 *   * DEVICE_LIFECYCLE_EVENT - A device lifecycle event as the result of a life change to the device.
 *   * HUB_HEALTH_EVENT - A hub health event as a result of a change in a hub's health.
 *   * MODE_EVENT - A mode event is triggered when the location's mode is changed.
 *   * SCENE_LIFECYCLE_EVENT - A scene lifecycle event as a result of a life change to the scene.
 *   * SECURITY_ARM_STATE_EVENT - A security arm state event as a result of a change in the arm state of a security system.
 *   * TIMER_EVENT - An event as a result of a scheduled app execution.
 *   * WEATHER_EVENT - An event with weather information.
 */
export enum EventType {
  DEVICE_COMMANDS_EVENT = 'DEVICE_COMMANDS_EVENT',
  DEVICE_EVENT = 'DEVICE_EVENT',
  DEVICE_HEALTH_EVENT = 'DEVICE_HEALTH_EVENT',
  DEVICE_LIFECYCLE_EVENT = 'DEVICE_LIFECYCLE_EVENT',
  HUB_HEALTH_EVENT = 'HUB_HEALTH_EVENT',
  MODE_EVENT = 'MODE_EVENT',
  SCENE_LIFECYCLE_EVENT = 'SCENE_LIFECYCLE_EVENT',
  SECURITY_ARM_STATE_EVENT = 'SECURITY_ARM_STATE_EVENT',
  TIMER_EVENT = 'TIMER_EVENT',
  INSTALLED_APP_LIFECYCLE_EVENT = 'INSTALLED_APP_LIFECYCLE_EVENT',
  WEATHER_EVENT = 'WEATHER_EVENT',
}

/**
 * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
 * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
 * * `USER` A user-level event, where the user can be found in `ownerId`.
 * @default "LOCATION"
 */
export enum EventOwnerType {
  LOCATION = 'LOCATION',
  USER = 'USER',
}

/** An event on a device that matched a subscription for this app. */
export interface DeviceEvent {
  /**
   * The ID of the event.
   * @example "736e3903-001c-4d40-b408-ff40d162a06b"
   */
  eventId?: string;
  /**
   * The id of the location in which the event was triggered.
   *
   * This field is not used or populated for user-level events.
   *
   * Location id may also be sent in `ownerId` with `ownerType` = `LOCATION`.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  /** ID for what owns the device event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /**
   * The ID of the device associated with the DEVICE_EVENT.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The name of the component on the device that the event is associated with.
   * @example "main"
   */
  componentId?: string;
  /**
   * The name of the capability associated with the DEVICE_EVENT.
   * @example "motionSensor"
   */
  capability?: string;
  /**
   * The name of the DEVICE_EVENT. This typically corresponds to an attribute name of the device-handler’s capabilities.
   * @example "motion"
   */
  attribute?: string;
  /**
   * The value of the event. The type of the value is dependent on the capability's attribute type.
   * @example "active"
   */
  value?: object;
  /**
   * The root level data type of the value field. The data types are representitive of standard JSON data types.
   * @example "number"
   */
  valueType?: string;
  /**
   * Unit of the value field.
   * @example "°C"
   */
  unit?: string;
  /** Whether or not the state of the device has changed as a result of the DEVICE_EVENT. */
  stateChange?: boolean;
  /** json map as defined by capability data schema */
  data?: object;
  /**
   * The name of subscription that caused delivery.
   * @example "motion_sensors"
   */
  subscriptionName?: string;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface ModeEvent {
  /** The id of the event. */
  eventId?: string;
  /** The id of the location in which the event was triggered. */
  locationId?: string;
  /** The ID of the mode associated with a MODE_EVENT. */
  modeId?: string;
}

/** An event that is caused by a schedule for this app being fired. */
export interface TimerEvent {
  /** The ID of the event. */
  eventId?: string;
  /**
   * The name of the schedule that caused this event.
   * @example "lights_off_timeout"
   */
  name?: string;
  /** The type of TIMER_EVENT. */
  type?: TimerType;
  /**
   * The IS0-8601 date time strings in UTC that this event was scheduled for.
   * @format date-time
   * @example "2017-08-04T12:44:18Z"
   */
  time?: string;
  /** The CRON expression if the schedule was of type CRON. */
  expression?: string;
}

/** An event that contains commands for devices that were created by this app. */
export interface DeviceCommandsEvent {
  /** The id of the event. */
  eventId?: string;
  /** The guid of the device that the commands are for. */
  deviceId?: string;
  /** The device profile ID of the device instance. */
  profileId?: string;
  /** The external ID that was set during install of a device. */
  externalId?: string;
  commands?: DeviceCommandsEventCommand[];
}

/** The type of TIMER_EVENT. */
export enum TimerType {
  CRON = 'CRON',
  ONCE = 'ONCE',
}

export interface DeviceCommandsEventCommand {
  /** @example "main" */
  componentId?: string;
  /** @example "switch" */
  capability?: string;
  /** @example "on" */
  command?: string;
  /** @example [] */
  arguments?: object[];
}

/** A device lifecycle event. */
export interface DeviceLifecycleEvent {
  /**
   * The device lifecycle. The lifecycle will be one of:
   * * CREATE - Invoked when a device is created.
   * * DELETE - Invoked when a device is deleted.
   * * UPDATE - Invoked when a device is updated.
   * * MOVE_FROM - Invoked when a device is moved from a location.
   * * MOVE_TO - Invoked when a device is moved to a location.
   * * ROOM_MOVE - Invoked when a device is moved into or out of a room within a location
   */
  lifecycle?: DeviceLifecycle;
  /** The id of the event. */
  eventId?: string;
  /**
   * The id of the location in which the event was triggered.
   *
   * This field is not used or populated for user-level events.
   *
   * Location id may also be sent in `ownerId` with `ownerType` = `LOCATION`.
   */
  locationId?: string;
  /** ID for what owns the device lifecyle event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** The id of the device. */
  deviceId?: string;
  /** The name of the device */
  deviceName?: string;
  /** The principal that made the change */
  principal?: string;
  /** Create device lifecycle. */
  create?: DeviceLifecycleCreate;
  /** Delete device lifecycle. */
  delete?: DeviceLifecycleDelete;
  /** Update device lifecycle. */
  update?: DeviceLifecycleUpdate;
  /** Move device lifecycle. */
  moveFrom?: DeviceLifecycleMove;
  /** Move device lifecycle. */
  moveTo?: DeviceLifecycleMove;
  /** Room move device lifecycle. */
  roomMove?: DeviceLifecycleRoomMove;
}

/** An event that represents a change in the arm state of a security system. */
export interface SecurityArmStateEvent {
  /** The id of the event. */
  eventId?: string;
  /** The id of the location in which the event was triggered. */
  locationId?: string;
  /** The arm state of a security system. */
  armState?: 'UNKNOWN' | 'ARMED_STAY' | 'ARMED_AWAY' | 'DISARMED';
  /** A set of key / value pairs useful for passing any optional arguments. */
  optionalArguments?: Record<string, SimpleValue>;
}

/** An event that represents a change in the health of the a device. */
export interface DeviceHealthEvent {
  /** The id of the event. */
  eventId?: string;
  /**
   * The id of the location in which the event was triggered.
   *
   * This field is not used or populated for user-level events.
   *
   * Location id may also be sent in `ownerId` with `ownerType` = `LOCATION`.
   */
  locationId?: string;
  /** ID for what owns the device health event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** The id of the device. */
  deviceId?: string;
  /** The id of the hub. */
  hubId?: string;
  /** The status of the device. */
  status?: 'OFFLINE' | 'ONLINE' | 'UNHEALTHY';
  /** The reason the device is offline. */
  reason?:
    | 'NONE'
    | 'SERVICE_UNAVAILABLE'
    | 'HUB_OFFLINE'
    | 'ZWAVE_OFFLINE'
    | 'ZIGBEE_OFFLINE'
    | 'BLUETOOTH_OFFLINE'
    | 'HUB_DISCONNECTED';
  /** Entity that created the event. */
  eventSource?: DeviceEventSource;
}

/** An event that represents a change in the health of a hub. */
export interface HubHealthEvent {
  /** The id of the event. */
  eventId?: string;
  /** The id of the location in which the event was triggered. */
  locationId?: string;
  /** The id of the hub. */
  hubId?: string;
  /** The status of the hub. */
  status?:
    | 'OFFLINE'
    | 'ONLINE'
    | 'ZWAVE_OFFLINE'
    | 'ZWAVE_ONLINE'
    | 'ZIGBEE_OFFLINE'
    | 'ZIGBEE_ONLINE'
    | 'BLUETOOTH_OFFLINE'
    | 'BLUETOOTH_ONLINE';
  /** The reason the hub is offline. */
  reason?: 'NONE' | 'DISCONNECTED' | 'INACTIVE';
}

/** A scene lifecycle event. */
export interface SceneLifecycleEvent {
  /**
   * The scene lifecycle. The lifecycle will be one of:
   * * CREATE - Invoked when a scene is created.
   * * UPDATE - Invoked when a scene is updated.
   * * DELETE - Invoked when a scene is deleted.
   * * CREATEFORBIXBY - Invoked when a scene is created for Bixby.
   * * UPDATEFORBIXBY - Invoked when a scene is updated for Bixby.
   * * DELETEFORBIXBY - Invoked when a scene is deleted for Bixby.
   */
  lifecycle?: SceneLifecycle;
  /** The id of the event. */
  eventId?: string;
  /** The id of the location in which the event was triggered. */
  locationId?: string;
  /** The id of the scene. */
  sceneId?: string;
  /** The version of the scene. */
  version?: string;
  /** The migration owner uuid */
  migrateUuid?: string;
  /** Create scene lifecycle. */
  create?: SceneLifecycleCreate;
  /** Update scene lifecycle. */
  update?: SceneLifecycleUpdate;
  /** Delete scene lifecycle. */
  delete?: SceneLifecycleDelete;
  /** Create scene lifecycle for bixby. */
  createForBixby?: SceneLifecycleCreateForBixby;
  /** Create scene lifecycle for bixby. */
  updateForBixby?: SceneLifecycleUpdateForBixby;
  /** Create scene lifecycle for bixby. */
  deleteForBixby?: SceneLifecycleDeleteForBixby;
}

/**
 * The device lifecycle. The lifecycle will be one of:
 * * CREATE - Invoked when a device is created.
 * * DELETE - Invoked when a device is deleted.
 * * UPDATE - Invoked when a device is updated.
 * * MOVE_FROM - Invoked when a device is moved from a location.
 * * MOVE_TO - Invoked when a device is moved to a location.
 * * ROOM_MOVE - Invoked when a device is moved into or out of a room within a location
 */
export enum DeviceLifecycle {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  MOVE_FROM = 'MOVE_FROM',
  MOVE_TO = 'MOVE_TO',
  ROOM_MOVE = 'ROOM_MOVE',
}

/** Create device lifecycle. */
export interface DeviceLifecycleCreate {
  presentationId?: string;
  manufacturerName?: string;
  categories?: {
    name?: string;
  }[];
  parentDeviceId?: string;
  hubId?: string;
}

/** Delete device lifecycle. */
export type DeviceLifecycleDelete = object;

export interface IconDiff {
  old?: string;
  new?: string;
}

export interface IndoorMapDiff {
  old?: {
    coordinates?: number[];
    rotation?: number[];
    visible?: boolean;
    data?: Record<string, string>;
  };
  new?: {
    coordinates?: number[];
    rotation?: number[];
    visible?: boolean;
    data?: Record<string, string>;
  };
}

/** Update device lifecycle. */
export interface DeviceLifecycleUpdate {
  labelDiff?: {
    old?: string;
    new?: string;
  };
  presentationKeysDiff?: {
    /**
     * manufacturerName before the update
     * @example "SmartThings"
     */
    previousManufacturerName?: string;
    /**
     * manufacturerName after the update
     * @example "SmartThingsCommunity"
     */
    newManufacturerName?: string;
    /**
     * presentation ID before the update
     * @format uuid
     * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
     */
    previousPresentationId?: string;
    /**
     * presentation ID after the update
     * @format uuid
     * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
     */
    newPresentationId?: string;
  };
  componentDiff?: {
    old?: {
      id?: string;
      label?: string;
      categories?: {
        name?: string;
      }[];
      capabilities?: {
        id?: string;
        version?: number;
      }[];
      icon?: string;
    };
    new?: {
      id?: string;
      label?: string;
      categories?: {
        name?: string;
      }[];
      capabilities?: {
        id?: string;
        version?: number;
      }[];
      icon?: string;
    };
  };
  iconDiff?: IconDiff;
  IndoorMapDiff?: IndoorMapDiff;
}

/** Move device lifecycle. */
export interface DeviceLifecycleMove {
  locationId?: string;
}

/** Room move device lifecycle. */
export interface DeviceLifecycleRoomMove {
  roomIdFrom?: string;
  roomIdTo?: string;
}

/** A simple value. */
export interface SimpleValue {
  /** The type of the value. */
  valueType?: 'NULL_VALUE' | 'INT_VALUE' | 'DOUBLE_VALUE' | 'STRING_VALUE' | 'BOOLEAN_VALUE';
  intValue?: number;
  /** @format double */
  doubleValue?: number;
  stringValue?: string;
  boolValue?: boolean;
}

/**
 * The scene lifecycle. The lifecycle will be one of:
 * * CREATE - Invoked when a scene is created.
 * * UPDATE - Invoked when a scene is updated.
 * * DELETE - Invoked when a scene is deleted.
 * * CREATEFORBIXBY - Invoked when a scene is created for Bixby.
 * * UPDATEFORBIXBY - Invoked when a scene is updated for Bixby.
 * * DELETEFORBIXBY - Invoked when a scene is deleted for Bixby.
 */
export enum SceneLifecycle {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  CREATEFORBIXBY = 'CREATEFORBIXBY',
  UPDATEFORBIXBY = 'UPDATEFORBIXBY',
  DELETEFORBIXBY = 'DELETEFORBIXBY',
}

/** Create scene lifecycle. */
export type SceneLifecycleCreate = object;

/** Update scene lifecycle. */
export type SceneLifecycleUpdate = object;

/** Delete scene lifecycle. */
export type SceneLifecycleDelete = object;

/** Create scene lifecycle for bixby. */
export type SceneLifecycleCreateForBixby = object;

/** Create scene lifecycle for bixby. */
export type SceneLifecycleUpdateForBixby = object;

/** Create scene lifecycle for bixby. */
export type SceneLifecycleDeleteForBixby = object;

/** An Installed App Lifecycle Event. */
export interface InstalledAppLifecycleEvent {
  /** The id of the event. */
  eventId?: string;
  /**
   * The ID of the location in which the event was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  installedAppId?: string;
  /** The ID of the application. */
  appId?: string;
  /**
   * The installed app lifecycle. The lifecycle will be one of:
   * * CREATE - Invoked when an application is created.
   * * INSTALL - Invoked when an application is installed.
   * * UPDATE - Invoked when an application is updated.
   * * DELETE - Invoked when an application is deleted.
   * * OTHER -
   */
  lifecycle?: InstalledAppLifecycle;
  /** Create installed app lifecycle. */
  create?: InstalledAppLifecycleCreate;
  /** Install installed app lifecycle. */
  install?: InstalledAppLifecycleInstall;
  /** Update installed app lifecycle. */
  update?: InstalledAppLifecycleUpdate;
  /** Delete installed app lifecycle. */
  delete?: InstalledAppLifecycleDelete;
  /** Other installed app lifecycle. */
  other?: InstalledAppLifecycleOther;
  error?: InstalledAppLifecycleError;
}

/**
 * The installed app lifecycle. The lifecycle will be one of:
 * * CREATE - Invoked when an application is created.
 * * INSTALL - Invoked when an application is installed.
 * * UPDATE - Invoked when an application is updated.
 * * DELETE - Invoked when an application is deleted.
 * * OTHER -
 */
export enum InstalledAppLifecycle {
  CREATE = 'CREATE',
  INSTALL = 'INSTALL',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  OTHER = 'OTHER',
}

/** Create installed app lifecycle. */
export type InstalledAppLifecycleCreate = object;

/** Update installed app lifecycle. */
export type InstalledAppLifecycleUpdate = object;

/** Delete installed app lifecycle. */
export type InstalledAppLifecycleDelete = object;

/** Install installed app lifecycle. */
export type InstalledAppLifecycleInstall = object;

/** Other installed app lifecycle. */
export type InstalledAppLifecycleOther = object;

export interface InstalledAppLifecycleError {
  code?: string;
  message?: string;
  target?: string;
  details?: InstalledAppLifecycleError[];
}

/** Weather data */
export interface WeatherData {
  /** Cloud ceiling in meters */
  cloudCeilingInM?: number;
  /** The phrase of the cloud cover */
  cloudCoverPhrase?: string;
  /** Relative Humidity Percentage */
  relativeHumidityInPercent?: number;
  sunriseDate?: string;
  sunsetDate?: string;
  /**
   * Temperature in degrees celsius
   * @format double
   */
  temperatureInC?: number;
  /**
   * Feels-like temperature in degrees celsius
   * @format double
   */
  temperatureFeelsLikeInC?: number;
  uvDescription?: string;
  uvIndex?: number;
  /** @format double */
  visibilityInKm?: number;
  windDirectionInDegrees?: number;
  windDirectionCardinal?: string;
  windGustInKmph?: number;
  windSpeedInKmph?: number;
  conditionPhraseLong?: string;
  conditionState?: 'UNKNOWN' | 'CLEAR' | 'SNOW' | 'RAIN' | 'CLOUDY' | 'STORM' | 'DUSTY' | 'FOGGY';
}

/** Air quality data */
export interface AirQualityData {
  airQualityIndex?: number;
  /** @format double */
  o3AmountInUgm3?: number;
  o3Index?: number;
  /** @format double */
  no2AmountInUgm3?: number;
  no2Index?: number;
  /** @format double */
  so2AmountInUgm3?: number;
  so2Index?: number;
  /** @format double */
  coAmountInUgm3?: number;
  coIndex?: number;
  /** @format double */
  pm10AmountInUgm3?: number;
  pm10Index?: number;
  /** @format double */
  pm25AmountInUgm3?: number;
  pm25Index?: number;
}

/** Severe Weather Alert data */
export interface SevereAlertData {
  headlineText?: string;
  detailUrl?: string;
  startTime?: string;
  endTime?: string;
  severity?: 'UNKNOWN_SEVERITY' | 'EXTREME' | 'SEVERE' | 'MODERATE';
  state?: 'NONE' | 'NEW' | 'UPDATE' | 'CANCEL';
}

/** An event representing the current weather forecast. */
export interface WeatherEvent {
  /** Weather data */
  weatherData?: WeatherData;
  /** Air quality data */
  airQualityData?: AirQualityData;
  /** Severe Weather Alert data */
  severeAlertData?: SevereAlertData;
  /** The id of the GeoPlace. */
  geoPlaceId?: string;
  /** The postal code of the weather event. */
  postalCode?: string;
}

export type CreateDeviceConfigRequest = CreateProfileDeviceConfigRequest & DeviceConfigType;

export type GenerateConfigExclusion = ComponentId & BaseCapabilityReference & DeviceConfigView;

export interface ComponentId {
  /**
   * Human readable identifier for a device component.
   * @example "main"
   */
  component?: string;
}

/**
 * A view in the mobile application that can display a device.
 * `Detail view` - The full view of a device.
 * `Dashboard view` - The view of a device amongst a list of devices.
 * `Automation conditions` - The `if` part of an automation. The automation trigger.
 * `Automation actions` - The `then` part of an automation. The device interaction (command).
 */
export interface DeviceConfigView {
  view?: 'DETAIL_VIEW' | 'DASHBOARD' | 'AUTOMATION_ACTIONS' | 'AUTOMATION_CONDITIONS';
}

export interface DeviceConfigType {
  /** @default "profile" */
  type?: 'dth' | 'profile';
}

export interface CreateProfileDeviceConfigRequest {
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  icons?: Icons;
  dashboard?: {
    states?: DeviceConfigEntryForDashboardState[];
    actions?: DeviceConfigEntryForDashboardAction[];
    basicPlus?: BasicPlusItem[];
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    groupVisibleConditions?: GroupVisibleConditions;
  };
  detailView?: DeviceConfigEntry[];
  automation?: {
    conditions?: ExcludedDeviceConditionConfigEntry[];
    actions?: ExcludedDeviceActionConfigEntry[];
  };
}

export interface DeviceProfileConfig {
  /** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
  automation?: AutomationConfiguration;
}

/** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
export interface AutomationConfiguration {
  /** Provides custom configuration for each automation action item. */
  actions?: AutomationActionItemConfiguration[];
}

/** Provides custom configuration for an automation action item. For example, this configuration may be used exclude specific capabilities from an automation action item. */
export interface AutomationActionItemConfiguration {
  /** ID of the capability associated with the action */
  capability: string;
  config: {
    exclusion?: {
      exclude?: ExcludedActionItem[];
    };
  };
}

export interface ExcludedActionItem {
  /** @example "pictureMode" */
  capability?: string;
}

export interface DeviceConfiguration {
  /** The name of the manufacturer */
  mnmn: Mnmn;
  /** A unique identifier for the presentation of a device. This can be a model number on legacy device integrations, but also may be a system generated UUID based on a device's structure and display configuration. */
  vid: Vid;
  /**
   * The version of the device configuration.
   * @default "0.0.1"
   * @example "0.0.1"
   */
  version?: string;
  /** @default "profile" */
  type?: 'dth' | 'profile';
  /** Information used for obtaining details page plugins on different platforms. Array of Details page link objects. */
  dpInfo?: DpInfo;
  /**
   * DEPRECATED: Please use iconUrl under icons property.
   * @example "icon://example_icon_url"
   */
  iconUrl?: string;
  icons?: Icons;
  dashboard?: {
    states?: DeviceConfigEntryForDashboardState[];
    actions?: DeviceConfigEntryForDashboardAction[];
    basicPlus?: BasicPlusItem[];
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    groupVisibleConditions?: GroupVisibleConditions;
  };
  detailView?: DeviceConfigEntry[];
  automation?: {
    conditions?: ExcludedDeviceConditionConfigEntry[];
    actions?: ExcludedDeviceActionConfigEntry[];
    /** To specify informative descriptions for condition or action in automation view */
    descriptions?: DescriptionsInAutomation;
  };
}

export type PublicDeviceConfiguration = DeviceConfiguration & {
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId?: string;
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
};

export type DossierDevicePresentation = {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId?: string;
} & DevicePresentation;

export type DeviceConfigEntry = DeviceConfigEntryBase & {
  /** A list of valid values for the command argument or attribute that can override those defined by the alternatives provided in the capability presentation. */
  values?: CapabilityValue[];
  /** A format which is applied some operations(add / replace / remove) from the rfc6902(https://tools.ietf.org/html/rfc6902#section-4). Please note that array in the patch is sequentially processed. */
  patch?: PatchItem[];
};

export type ExcludedDeviceActionConfigEntry = DeviceConfigEntry & {
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedActionItemId[];
};

export type ExcludedDeviceConditionConfigEntry = DeviceConfigEntry & {
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedConditionItemId[];
};

export interface CapabilityValue {
  /**
   * This can be either command name or attribute name. For pointing commands without arguments(enumCommands), specify `{{enumCommands}}` then this override values will apply to enumCommands.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * A list of values supported among those defined in the capability alternatives. For instance, a device may not support `auto` for supported thermostat fan modes, so this field might be an array containing `on` and `off`.
   * @example ["cooling","heating"]
   */
  enabledValues?: string[];
  label?: string;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** The incremental step that increases or decreases for numeric values. */
  step?: Step;
}

export interface DevicePresentation {
  /** The name of the manufacturer */
  mnmn: Mnmn;
  /** A unique identifier for the presentation of a device. This can be a model number on legacy device integrations, but also may be a system generated UUID based on a device's structure and display configuration. */
  vid: Vid;
  /**
   * The version of the device presentation.
   * @default "0.0.1"
   * @example "0.0.1"
   */
  version?: string;
  /**
   * DEPRECATED: Please use iconUrl under icons property.
   * @example "icon://example_icon_url"
   */
  iconUrl?: string;
  icons?: Icons;
  dashboard?: Dashboard;
  detailView?: DetailView;
  /** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device's state is met. */
  automation?: Automation;
  /** Information used for obtaining details page plugins on different platforms. Array of Details page link objects. */
  dpInfo: DpInfo;
  language?: Language;
}

/** The capability presentation describes how the capability will look in the app, what actions and states are shown, as well as how conditions and actions are expressed in an automation. */
export interface CapabilityPresentationForPUT {
  /** The dashboard is the main view in the SmartThings app that shows a list of devices and their state. */
  dashboard?: DashboardForCapability;
  detailView?: DetailViewForCapability;
  /** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device state is met. */
  automation?: AutomationForCapability;
}

export type CapabilityPresentation = {
  /** @example "audioVolume" */
  id: string;
  /**
   * The version number of the capability.
   * @example 1
   */
  version: Version;
} & CapabilityPresentationForPUT;

export type Language = LanguageItem[];

export interface LanguageItem {
  locale: string;
  /** The list of resources that contain translated text */
  poCodes: PoCodes[];
}

export interface PoCodes {
  label: string;
  /**
   * Po code. Should begin with '___PO_CODE'
   * @pattern ^___PO_CODE_[a-zA-Z0-9_]+$
   */
  po: string;
}

/** Information used for obtaining details page plugins on different platforms. Array of Details page link objects. */
export type DpInfo = {
  /** The OS of the UI Client used to show the details page. 'iOS': iOS SmartThings 'android': Android SmartThings */
  os: 'android' | 'ios' | 'tizen' | 'web';
  /**
   * This is linked to obtain the vendor-specific device details page. The device's dashboard card opens the detail view using this link when the user clicks the device card.
   * @example "plugin://example_detail_page_uri"
   */
  dpUri: string;
  /** This describes operating mode after onboarding. `easySetup` will launch the plugin for setting up your device while `deviceControl` will launch the plugin for controlling the device directly after onboarding. */
  operatingMode?: string;
  /** Complex devices can have sub dashboard cards and can pass an argument to the detailView when user clicks each sub dashboard cards. */
  arguments?: {
    /**
     * To specify key of `group` used in `dashboard`
     * @example "{{___PO_CODE_SMARTTHINGS_FLEX_OVEN}}"
     */
    key: string;
    /**
     * To specify group as an argument while launching the detailView.
     * @example "FLEX_UPPER_OVEN"
     */
    value: string;
  }[];
}[];

/** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
export type Alternatives = AlternativeItem[];

export interface AlternativeItem {
  /**
   * The label string to be displayed when the 'key' is evaluated.
   * @example "on"
   */
  key: string;
  /**
   * The alternative string to be displayed when the `key` is selected.
   * @example "Motion detected"
   */
  value: string;
  /**
   * This shows the active or inactive state of the value. `active` is shown in color, while `inactive` value is shown dimmed in the UI view. For example, Motion sensor capability would have `detected` as active and in color and `clear` as inactive and dimmed so that a user can see the `detected` event easily.
   * @default "active"
   */
  type?: 'inactive' | 'active';
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  /** Additional description for each value. This description is shown in detail view or automation under this particular key. */
  description?: string;
}

/**
 * Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category.
 * @example "icon://example_icon_url"
 */
export type IconUrl = string;

export type Icons = {
  /** @default "main" */
  group?: string;
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  /** To specify the condition whether the device is running or not, and a device icon corresponding to running is displayed on the UI. */
  runningConditions?: VisibleCondition[];
  badge?: {
    /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
    iconUrl: IconUrl;
    visibleConditions?: VisibleCondition[];
  }[];
}[];

/**
 * The incremental step that increases or decreases for numeric values.
 * @format double
 * @default 1
 */
export type Step = number;

/**
 * The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to.
 * @maxItems 2
 * @minItems 2
 * @example [0,100]
 */
export type Range = number[];

/** The method to compare */
export enum Operator {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  EQUALS = 'EQUALS',
  DOES_NOT_EQUAL = 'DOES_NOT_EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  ONE_OF = 'ONE_OF',
}

/**
 * The version number of the capability.
 * @default 1
 * @example 1
 */
export type Version = number;

/**
 * The name of the manufacturer
 * @example "SmartThingsCommunity"
 */
export type Mnmn = string;

/**
 * A unique identifier for the presentation of a device. This can be a model number on legacy device integrations, but also may be a system generated UUID based on a device's structure and display configuration.
 * @example "MySmartDevice"
 */
export type Vid = string;

/** @example {"capability":"switch","version":1} */
export interface CapabilityKey {
  capability: string;
  /** The version number of the capability. */
  version?: Version;
}

/**
 * @default "main"
 * @example "main"
 */
export type Component = string;

/**
 * This displays a string. This can be a formatted string with variables.
 * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
 * @example "{{temperatureMeasurement.value}}"
 */
export type FormattedLabel = string;

/** This display type creates a state UI that shows state only. */
export interface State {
  /**
   * This displays a string. This can be a formatted string with variables.
   * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
   */
  label?: FormattedLabel;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
}

/**
 * The attribute name specified in supportedValues is an array that has values supported at runtime.
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "supportedThermostatModes.value"
 */
export type SupportedValues = string;

/**
 * To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges.
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "supportedVolumes.value"
 */
export type SupportedValuesForNumericConstraints = string;

/**
 * Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version.
 * @example {"component":"main","value":"switch.value","operator":"EQUALS","operand":"on"}
 */
export interface VisibleCondition {
  /** The component that controls the visibility of this component. This can be another component or this one. */
  component: Component;
  capability: string;
  /** The version number of the capability. */
  version?: Version;
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The method to compare */
  operator: Operator;
  /** The value that the visible condition evaluates against. */
  operand: string;
}

/**
 * Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version.
 * @example {"component":"main","value":"switch.value","operator":"EQUALS","operand":"on"}
 */
export interface GroupVisibleConditions {
  /** The component that controls the visibility of this component. This can be another component or this one. */
  component: Component;
  capability: string;
  /** The version number of the capability. */
  version?: Version;
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The method to compare */
  operator: Operator;
  /** The value that the visible condition evaluates against. */
  operand: string;
}

export interface Dashboard {
  states?: StatesArrayItem[];
  actions?: ActionsArrayItem[];
  basicPlus?: BasicPlusItem[];
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  groupVisibleConditions?: GroupVisibleConditions;
}

/** The dashboard is the main view in the SmartThings app that shows a list of devices and their state. */
export interface DashboardForCapability {
  states?: StateItem[];
  actions?: ActionItem[];
}

/** @example {"label":"Motion: {{motion.value}}","alternatives":[{"key":"detected","value":"Detected","type":"active"},{"key":"clear","value":"None","type":"inactive"}]} */
export interface StateItem {
  /**
   * This displays a string. This can be a formatted string with variables.
   * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
   */
  label: FormattedLabel;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
}

/** @example {"displayType":"switch","switch":{"command":{"name":"setLock","on":"locked","off":"unlocked"},"state":{"value":"lock.value","on":"locked","off":"unlocked"}}} */
export interface ActionItem {
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'pushButton'
    | 'toggleSwitch'
    | 'switch'
    | 'standbyPowerSwitch'
    | 'statelessPowerToggle'
    | 'playPause'
    | 'playStop';
  pushButton?: PushButton;
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitchForDashboard;
  switch?: SwitchForDashboard;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitchForDashboard;
  /** This switch triggers power toggle action without showing any status. */
  statelessPowerToggle?: StatelessPowerToggleForDashboard;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
  group?: Group;
}

/**
 * To specify the function of the device using the extended area of the dashboard card.
 * @example {"displayType":"camera","camera":{"image":{"capability":"imageCapture","component":"main","version":1,"value":"image.value"},"overlayIcons":[{"iconUrl":"example_motion_icon","visibleCondition":{"capability":"motionSensor","component":"main","version":1,"value":"motion.value","operator":"EQUALS","operand":"detected"}},{"iconUrl":"example_object_human_icon","visibleCondition":{"capability":"objectDetection","component":"main","version":1,"value":"detected.value.value","operator":"EQUALS","operand":"human"}},{"iconUrl":"example_object_pet_icon","visibleCondition":{"capability":"objectDetection","component":"main","version":1,"value":"detected.value.value","operator":"EQUALS","operand":"pet"}}]}}
 */
export interface BasicPlusItem {
  /** To specify the type of UI component to display this basicPlus item. The corresponding field must also be included. For example, if you specify "camera" here, you must also include the "camera" key and its object definition for this basicPlus item. */
  displayType: 'camera';
  /** To render the captured image and overlay icon in the dashboard card of a camera device. */
  camera?: Camera;
}

/** To render the captured image and overlay icon in the dashboard card of a camera device. */
export interface Camera {
  /** To specifiy attribute path for a captured image. */
  image: {
    capability: string;
    /** The version number of the capability. */
    version?: Version;
    /** The component that controls the visibility of this component. This can be another component or this one. */
    component: Component;
    /** Notation which indicates the value of an attribute */
    value: Value;
  };
  /** To describe the overlay icon and the conditions under which it will be displayed. */
  overlayIcons?: {
    /** Icon Id used to retrieve a overlay icon to be drawn on the camera card. */
    iconUrl: string;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
  }[];
}

export type DetailView = DetailViewListItem[];

export type DetailViewForCapability = {
  /** @example "Front door" */
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'toggleSwitch'
    | 'standbyPowerSwitch'
    | 'switch'
    | 'slider'
    | 'pushButton'
    | 'textButton'
    | 'playPause'
    | 'playStop'
    | 'list'
    | 'textField'
    | 'numberField'
    | 'stepper'
    | 'state';
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitch;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  switch?: Switch;
  slider?: Slider;
  pushButton?: PushButton;
  /** To specify available values shown in buttons with text label. */
  textButton?: TextButton;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** To specify available values shown in a drop-down UI. User can select one of the value among the list items */
  list?: ListForDetailView;
  /** This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command */
  textField?: TextField;
  /** This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command */
  numberField?: NumberField;
  /** This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument. */
  stepper?: Stepper;
  /** This display type creates a state UI that shows state only. */
  state?: State;
}[];

export type DetailViewItem = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'toggleSwitch'
    | 'standbyPowerSwitch'
    | 'switch'
    | 'slider'
    | 'pushButton'
    | 'textButton'
    | 'playPause'
    | 'playStop'
    | 'list'
    | 'textField'
    | 'numberField'
    | 'stepper'
    | 'state'
    | 'multiArgCommand';
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitch;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  switch?: Switch;
  slider?: Slider;
  pushButton?: PushButton;
  /** To specify available values shown in buttons with text label. */
  textButton?: TextButton;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** To specify available values shown in a drop-down UI. User can select one of the value among the list items */
  list?: ListForDetailView;
  /** This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command */
  textField?: TextField;
  /** This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command */
  numberField?: NumberField;
  /** This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument. */
  stepper?: Stepper;
  /** This display type creates a state UI that shows state only. */
  state?: State;
  /** To specify multiple arguments command and displayType of each argument. */
  multiArgCommand?: MultiArgCommand;
};

/** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device state is met. */
export interface AutomationForCapability {
  /** To specify the conditions of device state to trigger actions in the automation view of SmartThings app. */
  conditions?: {
    /** @example "Audio volume" */
    label: string;
    /** Specify the type of UI component to use to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'enumSlider';
    slider?: SliderForAutomationCondition;
    list?: ListForAutomationCondition;
    numberField?: NumberFieldForAutomationCondition;
    textField?: TextFieldForAutomationCondition;
    /** This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order. */
    enumSlider?: EnumSliderForAutomationCondition;
    /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
    emphasis?: boolean;
  }[];
  /** To specify the actions of device control based on the device state in the automation view of SmartThings app. */
  actions?: {
    /** @example "Audio volume" */
    label: string;
    /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'multiArgCommand';
    slider?: SliderForAutomationAction;
    list?: ListForAutomationAction;
    textField?: TextFieldForAutomationAction;
    numberField?: NumberFieldForAutomationAction;
    /** To specify multiple arguments command and displayType of each argument. */
    multiArgCommand?: MultiArgCommand;
    /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
    emphasis?: boolean;
  }[];
}

export type AutomationCondition = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'enumSlider';
  slider?: SliderForAutomationCondition;
  list?: ListForAutomationCondition;
  numberField?: NumberFieldForAutomationCondition;
  textField?: TextFieldForAutomationCondition;
  /** This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order. */
  enumSlider?: EnumSliderForAutomationCondition;
  /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
  emphasis?: boolean;
};

export type AutomationAction = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType: 'slider' | 'list' | 'textField' | 'numberField' | 'multiArgCommand';
  slider?: SliderForAutomationAction;
  list?: ListForAutomationAction;
  textField?: TextFieldForAutomationAction;
  numberField?: NumberFieldForAutomationAction;
  /** To specify multiple arguments command and displayType of each argument. */
  multiArgCommand?: MultiArgCommand;
  /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
  emphasis?: boolean;
};

/** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device's state is met. */
export interface Automation {
  /** To specify the conditions of device state to trigger actions in the automation view of SmartThings app. */
  conditions?: AutomationListItem[];
  /** To specify the actions of device control based on the device state in the automation view of SmartThings app. */
  actions?: ActionListItem[];
  /** To specify informative descriptions for condition or action in automation view */
  descriptions?: DescriptionsInAutomation;
}

/**
 * The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard.
 * @default "main"
 * @example "main"
 */
export type Group = string;

/**
 * To specify available values shown in a drop-down UI. User can select one of the value among the list items
 * @example {"command":{"name":"setCleaningMode","alternatives":[{"key":"spot","value":"Spot cleaning mode"},{"key":"auto","value":"Auto cleaning mode"}]},"state":{"value":"cleaningMode.value","alternatives":[{"key":"spot","value":"Spot cleaning mode"},{"key":"auto","value":"Auto cleaning mode"}]}}
 */
export interface ListForDetailView {
  command: {
    /** name refers to command name and key of the alternatives is the argument of the command */
    name?: string;
    /** Additional description of a command. This description is shown in the list. */
    description?: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives: Alternatives;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
    /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
    supportedValues?: SupportedValues;
  };
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives: Alternatives;
  };
}

/** @example {"alternatives":[{"key":"cooling","value":"Cooling mode"},{"key":"heating","value":"Heating mode"}],"supportedValues":"supportedThermostatModes.value"} */
export interface ListBase {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives: Alternatives;
  /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
  supportedValues?: SupportedValues;
}

export type ListForAutomationAction = ListBase & {
  /** The name of the command that is called when an item is chosen from the list */
  command?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type ListForAutomationCondition = ListBase & {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /**
   * To specify whether to allow multiple selection within a list or not. Default value is false.
   * @default false
   */
  multiSelectable?: boolean;
};

/**
 * This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command
 * @example {"value":"volume.value","unit":"volume.unit","command":"setVolume","range":[0,100],"supportedValues":"supportedVolumes.value"}
 */
export interface NumberField {
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** Notation which indicates the unit */
  unit?: Unit;
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/** @example {"command":"setVolume","unit":"volume.unit","range":[0,100],"supportedValues":"supportedVolumes.value"} */
export interface NumberFieldForAutomationAction {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/** @example {"value":"volume.value","unit":"volume.unit","range":[0,100],"supportedValues":"supportedVolumes.value"} */
export interface NumberFieldForAutomationCondition {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/**
 * To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments.
 * @example {"command":{"name":"setPlaybackState","play":"play","pause":"pause"},"state":{"value":"playbackState.value","play":"playing","pause":"paused","alternatives":[{"key":"playing","value":"Playing","type":"active"},{"key":"paused","value":"Paused","type":"inactive"}]}}
 */
export type PlayPause = UtilRequiredKeys<PlayPauseCommand, 'command'> & {
  state: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The value of "attribute" which indicates playing state. When the attribute value equals to this then UI will show playing state. */
    play: string;
    /** The value of "attribute" which indicates paused state. When the attribute value equals to this then UI will show paused state. */
    pause: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
};

/** @example {"command":"setButton","argument":"push"} */
export interface PushButton {
  command: string;
  argument?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
}

/** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
export type PlayStop = PlayStopCommand & {
  state: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The value of "attribute" which indicates playing state. When the attribute value equals to this then UI will show playing state. */
    play: string;
    /** The value of "attribute" which indicates stopped state. When the attribute value equals to this then UI will show stopped state. */
    stop: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
  };
};

export type Slider = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /**
   * The command which will send the value of the slider as an argument
   * @example "setVolume"
   */
  command?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
};

/**
 * To display slider display type, at least one of the command and value must be specified.
 * @example {"range":[0,100],"step":0.5,"unit":"volume.unit","supportedValues":"supportedVolumes.value"}
 */
export interface SliderBase {
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range: Range;
  /** The incremental step that increases or decreases for numeric values. */
  step?: Step;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

export type SliderForAutomationAction = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type SliderForAutomationCondition = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
};

/**
 * This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order.
 * @example {"value":"dustHealthConcern.value","alternatives":[{"key":"hazardous","value":"Hazardous"},{"key":"veryUnhealthy","value":"Very Unhealthy"},{"key":"unhealthy","value":"Unhealthy"},{"key":"moderate","value":"Moderate"},{"key":"good","value":"Good"}],"supportedOperators":[{"operator":"EQUALS","label":"Equals to"},{"operator":"GREATER_THAN_OR_EQUALS","label":"Greater than or equals to"}]}
 */
export interface EnumSliderForAutomationCondition {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives: Alternatives;
  /** Notation which indicates the value of an attribute */
  value: Value;
  supportedOperators?: {
    /** The operator to be supported by this display type. */
    operator: 'EQUALS' | 'GREATER_THAN_OR_EQUALS' | 'LESS_THAN_OR_EQUALS';
    /** The alternative string of given operator. */
    label: string;
  }[];
}

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
export type StandbyPowerSwitch = SwitchCommand & SwitchState & object;

/**
 * This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument.
 * @example {"command":{"name":"setVolume"},"value":"volume.value","step":1,"range":[0,100],"supportedValues":"supportedVolumes.value"}
 */
export interface Stepper {
  command: {
    /** To specify a single command like "setValue(number)", use "command" field for the command name. If this field is specified then "increase" and "descrease" fields should not be specified. App will calculate desired value when user clicks "+" and "-" button in the UI based on the current value of "attribute" with specified "step". */
    name?: string;
    /** To specify a command for "increase" without an argument. */
    increase?: string;
    /** To specify a command for "decrease" without an argument. */
    decrease?: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The incremental step that increases or decreases for numeric values. */
  step: Step;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

export type Switch = SwitchCommand & SwitchState & object;

/**
 * This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command
 * @example {"command":"sendNotification","value":"notification.value"}
 */
export interface TextField {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"command":"sendNotification","range":[0,20]} */
export interface TextFieldForAutomationAction {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"value":"notification.value"} */
export interface TextFieldForAutomationCondition {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** A button style switch element for the UI. */
export type ToggleSwitch = SwitchCommand & SwitchState & object;

/** To specify multiple arguments command and displayType of each argument. */
export interface MultiArgCommand {
  /**
   * Command name to trigger
   * @example "playTrack"
   */
  command: string;
  arguments: {
    /** @example "Audio volume" */
    label: string;
    /** Specify the type of UI component to use to display this action or state. The corresponding field must also be included. For example, if you specify "list" here, you must also include the "list" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'textField' | 'numberField';
    slider?: SliderForArgument;
    list?: ListForArgument;
    textField?: TextFieldForArgument;
    numberField?: NumberFieldForArgument;
  }[];
}

export type SliderForArgument = SliderBase & {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type ListForArgument = ListBase & {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

/** @example {"name":"uri","range":[5,50]} */
export interface TextFieldForArgument {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"name":"level","range":[0,10]} */
export interface NumberFieldForArgument {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** Argument name of a command */
export type ArgumentName = string;

export type StatesArrayItem = StateItem &
  CapabilityKey & {
    component: Component;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
    /** To specify composite use of different state items. If composite is true, multiple states items in the same group are combined to a label. */
    composite?: Composite;
    /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
    group?: Group;
    formatInfo?: FormatInfo;
    /**
     * To specify whether the status to be displayed is transient or not
     * @default false
     */
    transient?: boolean;
  };

export type ActionsArrayItem = ActionItem &
  CapabilityKey & {
    component?: Component;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
    /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
    group?: Group;
  };

export type DetailViewListItem = DetailViewItem & {
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
};

export type AutomationListItem = AutomationCondition & {
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedConditionItem[];
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
};

export type ActionListItem = AutomationAction & {
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedActionItem[];
};

/** A button style switch element for the UI. */
export type ToggleSwitchForDashboard = SwitchForDashboard & object;

/** @example {"command":{"name":"setLock","on":"locked","off":"unlocked"}} */
export interface SwitchCommand {
  /** To specify separate commands with no arguments for on and off, use the "on" and "off" fields respectively. To specify a single command, use "name" for the command and the "on" and "off" fields for the arguments. */
  command: {
    name?: string;
    on: string;
    off: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked","label":"Lock: {{lock.value}}","alternatives":[{"key":"locked","value":"Locked","type":"inactive"},{"key":"unlocked","value":"Unlocked","type":"active"}]}} */
export interface SwitchState {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The attribute value that corresponds to the `on` state. */
    on: string;
    /** The attribute value that corresponds to the `off` state. */
    off: string;
    /**
     * This displays a string. This can be a formatted string with variables.
     * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
     */
    label?: FormattedLabel;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked"}} */
export interface SwitchStateForDashboard {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value?: Value;
    on: string;
    off: string;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
}

export type SwitchForDashboard = SwitchCommand & SwitchStateForDashboard & object;

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
export type StandbyPowerSwitchForDashboard = SwitchCommand & SwitchState & object;

/**
 * This switch triggers power toggle action without showing any status.
 * @example {"command":"setButton","argument":"push"}
 */
export interface StatelessPowerToggleForDashboard {
  command: string;
  argument?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
}

/**
 * Display type for a play/pause button.
 * @example {"command":{"name":"setPlaybackState","play":"playing","pause":"paused"}}
 */
export interface PlayPauseCommand {
  /** To specify separate commands with no arguments for on and off, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  command: {
    name?: string;
    play: string;
    pause: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/**
 * Display type for a play/stop button.
 * @example {"command":{"name":"setPlaybackState","play":"play","stop":"pause"}}
 */
export interface PlayStopCommand {
  /** To specify separate commands with no arguments for on and off, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the "play" and "stop" fields for the arguments. */
  command: {
    name?: string;
    play: string;
    stop: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** To specify available values shown in buttons with text label. */
export interface TextButton {
  /**
   * To specify command name with argument(s) and key of the buttons is the argument of the command. If this is omitted then keys at `buttons` array are the enumCommands without arguments.
   * @example "setThermostatMode"
   */
  command?: string;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** @minItems 2 */
  buttons: {
    /**
     * A command name or an argument name of a command to be mapped with this button.
     * @example "cooling"
     */
    key: string;
    /**
     * The alternative string to be displayed when the `key` is evaluated.
     * @example "Cooling"
     */
    label: string;
    /**
     * To focus this button according to the current status of given attribute which is mapped with this button.
     * @example "Cooling"
     */
    state?: string;
  }[];
  /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
  supportedValues?: SupportedValues;
}

/**
 * Notation which indicates the value of an attribute
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "switch.value"
 */
export type Value = string;

/**
 * Notation which indicates the unit
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.unit)+
 * @example "temperature.unit"
 */
export type Unit = string;

export interface ExcludedConditionItem {
  /**
   * To express that a specific value is selected
   * @example "HDMI"
   */
  value?: object;
  exclude: {
    /** @example "main" */
    component?: string;
    /** @example "pictureMode" */
    capability: string;
    /**
     * @default 1
     * @example 1
     */
    version?: number;
    attributes?: ExcludeItemsAttributes;
  }[];
}

export interface ExcludedActionItem {
  /**
   * To express that a specific value is selected
   * @example "off"
   */
  value?: object;
  exclude: {
    /**
     * To specify target component to exclude, if it's omitted then all components with this capability will be excluded
     * @example "main"
     */
    component?: string;
    /** @example "pictureMode" */
    capability: string;
    /**
     * @default 1
     * @example 1
     */
    version?: number;
    commands?: ExcludeItemsCommands;
  }[];
}

export type ExcludedConditionItemId = {
  /** The index of the array in the given capability to which this exclusion object will be inserted */
  id?: number;
} & ExcludedConditionItem;

export type ExcludedActionItemId = {
  /** The index of the array in the given capability to which this exclusion object will be inserted */
  id?: number;
} & ExcludedActionItem;

export type ExcludeItemsCommands = {
  name: string;
  /** To exclude only some values of the attribute */
  excludedValues?: string[];
}[];

export type ExcludeItemsAttributes = {
  /** Attribute name to be excluded */
  name: string;
  /** To exclude only some values of the attribute */
  excludedValues?: string[];
}[];

/**
 * The data type of the `value`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ValueType = string;

/**
 * The data type of the `argument`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ArgumentType = string;

export interface PatchItem {
  /**
   * Operation objects MUST have exactly one "op" member, whose value indicates the operation to perform
   * @example "replace"
   */
  op: 'add' | 'replace' | 'remove';
  /**
   * path specifies a string format for identifying a specific value within a JSON document. It is used by all operations in patch to specify the part of the document to operate on.
   * @example "/0/alternatives/1/value"
   */
  path: string;
  /** @example "Focus mode" */
  value?: object;
}

export interface DeviceConfigEntryBase {
  /** @example "main" */
  component: string;
  /** @example "thermostatMode" */
  capability: string;
  /** The version number of the capability. */
  version?: Version;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
}

export interface CapabilityValueForDashboardState {
  label?: string;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
}

export type DeviceConfigEntryForDashboardState = DeviceConfigEntryBase & {
  /** An index among the multiple items of dashboard provided in the capability presentation. */
  idx?: Idx;
  /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
  group?: Group;
  /**
   * A list of valid values for the command argument or attribute that can override those defined by the alternatives provided in the capability presentation.
   * @maxItems 1
   */
  values?: CapabilityValueForDashboardState[];
  /** To specify composite use of different state items. If composite is true, multiple states items in the same group are combined to a label. */
  composite?: Composite;
  formatInfo?: FormatInfo;
};

export type DeviceConfigEntryForDashboardAction = DeviceConfigEntryBase & {
  /** An index among the multiple items of dashboard provided in the capability presentation. */
  idx?: Idx;
  /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
  group?: Group;
  /** To override the referenced capability presentation inline. It corresponds to the schema of the dashboard.actions item of capability presentation. */
  inline?: object & ActionItem;
};

/**
 * An index among the multiple items of dashboard provided in the capability presentation.
 * @default 0
 */
export type Idx = number;

/**
 * To specify composite use of different state items. If composite is true, multiple states items in the same group are combined to a label.
 * @default false
 */
export type Composite = boolean;

export type FormatInfo = {
  /** Notation which indicates the value of an attribute */
  key: Value;
  /**
   * To specify the type of format to display this attribute value. The corresponding field must also be included. For example, if you specify "remainingTime" here, you must also include the "remainingTime" key and its object definition for formatInfo.
   * @example "remainingTime"
   */
  type: 'remainingTime' | 'time';
  remainingTime?: {
    timeFormat: TimeFormat;
    /**
     * Specify the frequency time(second) so UI client can know how often to update the remaing time.
     * @default 60
     * @example 60
     */
    frequency?: number;
  };
  time?: {
    timeFormat: TimeFormat;
  };
}[];

/**
 * @pattern (MM/dd ){0,1}(HH:|hh:){0,1}mm(:ss){0,1}
 * @example "HH:mm:ss"
 */
export type TimeFormat = string;

/** To specify informative descriptions for condition or action in automation view */
export interface DescriptionsInAutomation {
  conditions?: DescriptionItem[];
  actions?: DescriptionItem[];
}

export interface DescriptionItem {
  /** @default "OR" */
  operator?: 'AND' | 'OR';
  /** @example "Sample description" */
  label: string;
  visibleConditions?: VisibleCondition[];
}

/** Entity that created the event. */
export enum DeviceEventSource {
  OCFDEVICE = 'OCFDEVICE',
  HUBDEVICE = 'HUBDEVICE',
  HUB = 'HUB',
  CLOUD = 'CLOUD',
}

export interface MeshGraph {
  devices?: {
    /**
     * @format uuid
     * @example "6496be9a-aa23-4320-b60f-904e472db962"
     */
    deviceId?: string;
    /** @example true */
    repeater?: boolean;
    route?: '[object Object]'[];
    /**
     * @min 0
     * @max 5
     */
    connectionQuality?: number;
    /** @example "2020-02-05T17:28:26.1234Z" */
    updatedTime?: string;
  }[];
}

export interface Hub {
  /**
   * @format uuid
   * @example "6496be9a-aa23-4320-b60f-904e472db962"
   */
  id?: string;
  /** @example "Happy Hub" */
  name?: string;
  /** @example "D052A82674C90001" */
  eui?: string;
  /** @example "john.doe@smartthings.com" */
  owner?: string;
  /** @example "asdfasdf" */
  serialNumber?: string;
  /** @example "000.020.00203" */
  firmwareVersion?: string;
}

/**
 * A JSON object of Hub Characteristics. Values could be of any type. There are no required keys.
 * More information is available [here](https://smartthings.atlassian.net/wiki/spaces/HUBPLT/pages/2348782106/Hub+Characteristics+Guidelines+and+Schema)
 * @example {"key1":"value1","key2":"value2","key3":["a","b","c"]}
 */
export type HubCharacteristics = Record<string, object>;

export interface ReplacementRequest {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  sourceHubDeviceId?: string;
}

export interface HubReplacementProgress {
  /**
   * The identifier used to look up the status of the replacement job
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  jobId: string;
  /** The current overall state of the replacement */
  state?: HubReplacementState;
  isFailure?: boolean;
  failureInfo?: ErrorResponse[];
  destinationHubId?: string;
  sourceHubId?: string;
}

export interface HubBackupMetadata {
  /**
   * Unix timestamp of when backup was generated in milliseconds
   * @format int64
   */
  generationDate?: number;
}

/** The current overall state of the replacement */
export enum HubReplacementState {
  CLOUD_VALIDATION_STARTED = 'CLOUD_VALIDATION_STARTED',
  CLOUD_VALIDATION_COMPLETE = 'CLOUD_VALIDATION_COMPLETE',
  HUB_VALIDATION_STARTED = 'HUB_VALIDATION_STARTED',
  HUB_VALIDATION_COMPLETE = 'HUB_VALIDATION_COMPLETE',
  CLOUD_SETTINGS_MOVED = 'CLOUD_SETTINGS_MOVED',
  DRIVERS_INSTALLED = 'DRIVERS_INSTALLED',
  FABRIC_JOINED = 'FABRIC_JOINED',
  REPARENTING_STARTED = 'REPARENTING_STARTED',
  REPARENTING_COMPLETE = 'REPARENTING_COMPLETE',
  LOCAL_REPLACEMENT_STARTED = 'LOCAL_REPLACEMENT_STARTED',
  REPLACEMENT_COMPLETE = 'REPLACEMENT_COMPLETE',
}

export interface ReplacementCandidates {
  sourceMeta?: SourceMetadata;
  lastBackupMeta?: HubBackupMetadata;
  candidates?: ReplacementCandidate[];
}

export interface SourceMetadata {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  hubDeviceId: string;
  isReplacementSupported: boolean;
}

export interface CandidateMetadata {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  hubDeviceId: string;
  /** Single boolean flag to denote if replacement of source with this candidate should be allowed */
  canReplaceSource: boolean;
  /** denotes if replacement is supported in general on this hub */
  isReplacementSupported: boolean;
  /** does this hub already have child devices */
  hasChildren: boolean;
}

export interface ReplacementCandidate {
  candidateMeta?: CandidateMetadata;
  supportedFeatures?: SupportedFeatures;
  unsupportedDevices?: ReplacementDevice[];
}

export interface ReplacementDevice {
  deviceId: string;
  /** Unavailable = device could work with dongle. Unsupported = device will never work on hub */
  unsupportedType?: UnsupportedType;
  /**
   * The type of device integration (may be null).
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is OCF, the details are in the "ocf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  deviceType?: DeviceIntegrationType;
}

/**
 * Unavailable = device could work with dongle. Unsupported = device will never work on hub
 * @example "Unavailable"
 */
export enum UnsupportedType {
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

export interface InstalledDriver {
  /**
   * Unique Identifier of the driver
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  driverId: string;
  /**
   * User friendly Identifier for Driver
   * @example "Caleb's Fiendly Driver"
   */
  name: string;
  /**
   * Description of Driver
   * @example "One friendly driver alright"
   */
  description?: string;
  /** version of the driver currently in use */
  version: string;
  /** identifier for channel this driver is installed from */
  channelId?: string;
  /** developer of the driver */
  developer?: string;
  /**
   * information on how to reach vendor
   * @example "You can find us at JustAFriendlyDriver.com"
   */
  vendorSupportInformation?: string;
  /**
   * map of permissions and attributes used by the driver.
   * In format of {"permissions":{"perm1":{...}, "perm2"{...}}}
   * @example {"lan":{},"lan_internet":{"allowed_hosts":["smartthings.com","samsung.com"]}}
   */
  permissions?: Record<string, object>;
  /** Flag to denote that this driver is part of a works with SmartThings channel */
  isWWST?: boolean;
}

export interface InstallDriverRequest {
  /**
   * Unique Identifier of the channel the driver is being installed from
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  channelId?: string;
}

export interface EdgeDeviceUpdateRequest {
  /**
   * Unique Identifier of the driver
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  driverId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

export interface DiscoveryCodeRequest {
  /** Type of discovery code being sent down (NOVA, Zigbee3, ZwaveS2) */
  type: DiscoveryCodeType;
  /**
   * The device code that was scanned or manually entered by the user
   * @example "B6E4BB590E374B85828690535526F722BCC0"
   */
  code: string;
  /**
   * The EUID of the Zigbee device, required if type is zigbee3
   * @example "24FD5B000105DB96"
   */
  euid?: string;
}

export interface DiscoveryStartRequest {
  /**
   * Determines the length of time where device discovery will be active. This value should be similar to the poll rate. A value of 0 will stop the discovery instead of letting the hub discover indefinitely
   * @example 15
   */
  timeout: number;
  /**
   * If true, Zigbee devices can only join securely. This does not affect the ability to join non-Zigbee devices. Defaults to false.
   * @example true
   */
  secureJoin?: boolean;
  /**
   * If true then the mobile client supports the Z-Wave S2 onboarding flow, defaults to false
   * @example true
   */
  s2Supported?: boolean;
  /** If set then enable discovery of all of the specified types of devices. If not set then all hub connected device types will be discoverable. */
  discoveryTypes?: ('ZIGBEE' | 'ZWAVE' | 'LAN' | 'BLUETOOTH' | 'BLUETOOTH.MESH')[];
  /** List of strings that specify which drivers to start up during discovery. If field is null or empty, all drivers will start up during discovery. */
  driverIds?: string[];
}

/** List of installed Hub Device drivers */
export type InstalledDrivers = InstalledDriver[];

/** List of driver channels */
export type HubDriverChannels = HubDriverChannel[];

export interface HubUpdateRequest {
  /** @example "Happy hub" */
  name?: string;
  /** @example "1234abcd-eaff-47b3-80d6-a4cbe14e3344" */
  locationId?: string;
}

/**
 * Type of discovery code being sent down (NOVA, Zigbee3, ZwaveS2)
 * @example "zigbee3"
 */
export enum DiscoveryCodeType {
  AdtQr = 'adt-qr',
  Zigbee3 = 'zigbee3',
  Zwaves2 = 'zwaves2',
}

export interface HubDriverChannel {
  /**
   * Unique Identifier of the channel
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  channelId: string;
  /**
   * User friendly Identifier for Channel
   * @example "Caleb's Fiendly Drivers"
   */
  name: string;
  /**
   * Description of Channel and Contained Drivers
   * @example "Just some friendly Drivers Here"
   */
  description?: string;
  /** ISO-8601 timestamp of creation of channel */
  createdDate?: string;
  /** ISO-8601 timestamp of last modification of channel */
  lastModifiedDate?: string;
  /** Url to web interface to modifiy channel subscriptions */
  subscriptionUrl?: string;
  /** Flag to denote that it works with SmartThings channel */
  isWWST?: boolean;
}

export interface HubRequestLogsAuditData {
  reason?: string;
  user?: string;
}

/** Response from requesting hub logs */
export type FetchLogsResponse = InternalHubCommandResponse & {
  /** The S3 bucket holding the hub logs requested */
  bucket?: string;
  /** The requesting hubId */
  objectName?: string;
};

export interface InternalHubCommandResponse {
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  correlationId?: string;
  /** The ID of the hub */
  hubId?: HubIdFieldSchema;
  /** The command to execute on the hub */
  commandName?: HubCommandFieldSchema;
}

/**
 * The ID of the hub
 * @example "D052A900003100FB"
 */
export type HubIdFieldSchema = string;

/**
 * The command to execute on the hub
 * @example "ping"
 */
export type HubCommandFieldSchema = string;

export interface SupportedFeatures {
  /** Possible Values for Hub Characteristic "Availability" flags */
  zigbeeAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  zwaveAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  threadAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  lanAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  edgeDriversAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  matterAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  localVirtualDeviceAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  childDeviceAvailability?: AvailabilityCharacteristic;
}

export type Driver = PagedDriver & {
  /**
   * @maxItems 100
   * @minItems 0
   */
  fingerprints?: DriverFingerprint[];
  permissions?: DriverPermissions;
};

export interface PagedDriver {
  /** The ID of the Sprocket driver */
  driverId: DriverId;
  /** The name of the driver */
  name: DriverName;
  /** A user scoped package key that's used to lookup the respective driver record */
  packageKey: PackageKey;
  /**
   * @maxItems 100
   * @minItems 0
   */
  deviceIntegrationProfiles?: DeviceIntegrationProfileKey[];
  permissions?: DriverPermissions;
  /** The version of the driver revision being returned */
  version?: DriverVersion;
}

/** The version of the driver revision being returned */
export type DriverVersion = string;

/**
 * @maxItems 100
 * @minItems 0
 */
export type DriverPermissions = DriverPermission[];

export interface DriverPermission {
  /** Name of the permission */
  name: string;
  /** Additional properties on a driver permission */
  attributes: PermissionAttributes;
}

/** Additional properties on a driver permission */
export type PermissionAttributes = Record<string, object>;

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id?: string;
  /**
   * Major Version of the integration profile
   * @format int64
   */
  majorVersion?: number;
}

/**
 * A user scoped package key that's used to lookup the respective driver record
 * @pattern ^[a-zA-Z0-9 _/\\\-()\\[\\]{}\.]{1,36}$
 * @example "smartthings.zigbee.bulb-rgbw"
 */
export type PackageKey = string;

/**
 * The name of the driver
 * @format ^[a-zA-Z0-9 _\/\\-()\[\]{}\.]{1,50}$
 * @example "Generic Button"
 */
export type DriverName = string;

export interface DriverFingerprint {
  /** The identifier for the respective fingerprint, unique per driver */
  id: FingerprintId;
  /** Type of fingerprint */
  type: FingerprintType;
  /** Label assigned to device at join time. If this is not set the driver name is used. */
  deviceLabel?: FingerprintDeviceLabel;
  zigbeeGeneric?: ZigbeeGenericFingerprint;
  zigbeeManfacturer?: ZigbeeManufacturerFingerprint;
  zwaveManufacturer?: ZWaveManufacturerFingerprint;
  zwaveGeneric?: ZWaveGenericFingerprint;
}

/**
 * The identifier for the respective fingerprint, unique per driver
 * @format ^[a-zA-Z0-9 _/\\\-()\\[\\]{}\.]{1,36}$
 * @example "smartthings.motion-v4"
 */
export type FingerprintId = string;

/** Type of fingerprint */
export enum FingerprintType {
  DTH = 'DTH',
  ZIGBEE_GENERIC = 'ZIGBEE_GENERIC',
  ZIGBEE_MANUFACTURER = 'ZIGBEE_MANUFACTURER',
  ZWAVE_MANUFACTURER = 'ZWAVE_MANUFACTURER',
  ZWAVE_GENERIC = 'ZWAVE_GENERIC',
}

/**
 * Label assigned to device at join time. If this is not set the driver name is used.
 * @format ^[a-zA-Z0-9 _\/\\-()\[\]{}\.]{1,50}$
 * @example "Motion Sensor"
 */
export type FingerprintDeviceLabel = string;

export interface ZigbeeGenericFingerprint {
  clusters?: Clusters;
  /** Device Identifiers associated with a generic zigbee fingerprint */
  deviceIdentifiers?: DeviceIdentifiers;
  /** Device profiles associated with a generic zigbee fingerprint */
  zigbeeProfiles?: ZigbeeProfiles;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
}

/**
 * Device profiles associated with a generic zigbee fingerprint
 * @example [260]
 */
export type ZigbeeProfiles = number[];

/**
 * Reported manufacturer of the device
 * @minLength 0
 * @maxLength 32
 * @example "SmartThings"
 */
export type ZigbeeManufacturer = string;

/**
 * Reported model of the device
 * @minLength 0
 * @maxLength 32
 * @example "motionv4"
 */
export type ZigbeeModel = string;

export interface ZigbeeManufacturerFingerprint {
  /** Reported manufacturer of the device */
  manufacturer?: ZigbeeManufacturer;
  /** Reported model of the device */
  model?: ZigbeeModel;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
}

export interface ZWaveManufacturerFingerprint {
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
  /** 16-bit manufacturer defined product type */
  productType: ZWaveProductType;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
}

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

export interface ZWaveGenericFingerprint {
  /** 8-bit indicator for the generic type of the device */
  genericType?: ZWaveGenericType;
  /** List of reported command classes */
  specificType?: ZWaveSpecificType[];
  /** List of CommandClasses to match on */
  commandClasses?: CommandClasses;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
}

/**
 * 8-bit indicator for the generic type of the device
 * @min 0
 * @max 255
 * @example 6
 */
export type ZWaveGenericType = number;

/**
 * 8-bit indicator for the specific type of the device
 * @min 0
 * @max 255
 * @example 6
 */
export type ZWaveSpecificType = number;

export interface CommandClasses {
  /** List of 8-bit command class identifiers to match regardless of controlled or supported */
  either?: number[];
  /** List of 8-bit command class identifiers that are controlled */
  controlled?: number[];
  /** List of 8-bit command class identifiers that are supported */
  supported?: number[];
}

/** A paginated array of Drivers. */
export interface PagedDrivers {
  items: PagedDriver[];
  _links: Links;
}

export interface Clusters {
  /** List of 16-bit cluster identifiers for client clusters */
  client?: ClientClusters;
  /** List of 16-bit cluster identifiers for server clusters */
  server?: ServerClusters;
}

/** List of 16-bit cluster identifiers for client clusters */
export type ClientClusters = number[];

/** List of 16-bit cluster identifiers for server clusters */
export type ServerClusters = number[];

/**
 * Device Identifiers associated with a generic zigbee fingerprint
 * @example [257]
 */
export type DeviceIdentifiers = number[];

export interface BasicChannel {
  /** Name of the channel */
  name?: string;
  /** Description of the channel */
  description?: string;
  /** The type of channel */
  type?: ChannelType;
  /** URL for a developer-provided Terms of Service agreement for the channel */
  termsOfServiceUrl?: string;
}

/** The type of channel */
export enum ChannelType {
  DRIVER = 'DRIVER',
}

/**
 * The identifier of the Sprocket channel
 * @format uuid
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type ChannelId = string;

export interface DetailedChannel {
  /** The identifier of the Sprocket channel */
  channelId?: ChannelId;
  /** Name of the channel */
  name?: string;
  /** Description of the channel */
  description?: string;
  /** The type of channel */
  type?: ChannelType;
  /** URL for a developer-provided Terms of Service agreement for the channel */
  termsOfServiceUrl?: string;
  /** The ISO-8601 formatted timestamp when the channel was created */
  createdDate?: string;
  /** The ISO-8601 formatted timestamp when the channel was last modified */
  lastModifiedDate?: string;
}

/** A paginated array of channel details. */
export interface PagedDetailedChannels {
  items: DetailedChannel[];
  _links?: Links;
}

export interface PatchChannel {
  /** Name of the channel */
  name?: string;
  /** Description of the channel */
  description?: string;
  /** URL for a developer-provided Terms of Service agreement for the channel */
  termsOfServiceUrl?: string;
}

export interface DriverRevision {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The version of the driver revision being returned */
  version?: DriverVersion;
}

export interface DriverChannel {
  /** The identifier of the Sprocket channel */
  channelId?: ChannelId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The version of the driver revision being returned */
  version?: DriverVersion;
  /** The ISO-8601 formatted timestamp when the channel was created */
  createdDate?: string;
  /** The ISO-8601 formatted timestamp when the channel was last modified */
  lastModifiedDate?: string;
}

/** A paginated array of driver channel details. */
export interface PagedDriverChannels {
  items: DriverChannel[];
  _links?: Links;
}

export interface UpdateDriverChannel {
  /** The version of the driver revision being returned */
  version?: DriverVersion;
}

/** An internal platform representation of a developer organization. */
export type OrganizationResponse = OrganizationCreateRequest & {
  /** The user group for organization developers. */
  developerGroupId?: string;
  /** The user group for organization admins. */
  adminGroupId?: string;
  /**
   * A generated UUID for an organization.
   * @format uuid
   */
  organizationId: string;
  /**
   * Denotes whether this is the default user org for the caller.
   * @default false
   */
  isDefaultUserOrg?: boolean;
};

/** User specifiable fields on Organization creation. Returned fields may be limited depending on access level. */
export type OrganizationCreateRequest = OrganizationUpdateRequest & {
  /** Manufacturer name for the organization. */
  manufacturerName?: ManufacturerName;
  /**
   * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
   * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
   */
  name: OrganizationName;
};

/** Request body to update the mutable fields of a developer organization. `NOTE`: warehouseGroupId cannot be updated from a present to a null value */
export interface OrganizationUpdateRequest {
  /** A pretty name for a developer organization. */
  label?: Label;
  /** The groupId that corresponds to this organization in warehouse. */
  warehouseGroupId?: WarehouseGroupId;
  /** Legacy `mnId` (also `mnid`) field used by some Samsung services. */
  mnId?: MnId;
}

/** List response type for multiple organizations. */
export interface PagedOrganizationResponse {
  items?: OrganizationResponse[];
  _links?: Links;
}

/** Simple object response for deleted entity. */
export type DeleteResponse = Record<string, any>;

/** Request body for sending organization invites to users. */
export interface InviteRequest {
  /**
   * Individuals to invite to an organization with a role.
   * @maxItems 20
   */
  invitees?: InviteRequestItem[];
}

/** Request body for sending organization invites to users. */
export interface InviteResponse {
  /** A list of developer users to invite to the organization. */
  results?: InviteResponseItem[];
}

/** Invidiual member to invite to an organization. */
export interface InviteRequestItem {
  /** The E-mail address of the invited party. */
  email: Email;
  role: Role;
}

/** The status for an individual organization member invitation. */
export type InviteResponseItem = InviteRequestItem & {
  /**
   * Status code for this invite entry.
   * @example 200
   */
  status: number;
  /**
   * Information on the individual invitation.
   * @example "Success"
   */
  info: string;
  /** Invite ID for sucessfully created invitations. */
  inviteId?: string;
  /** The URL the invitee can follow to accept a successful invitation (they must be logged in). */
  acceptUrl?: string;
};

/** A user UUID. */
export interface OrganizationMember {
  /**
   * A raw user principal (user uuid).
   * @format uuid
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  principal?: string;
  /**
   * @default "RAW"
   * @example "RAW"
   */
  principalType?: 'RAW';
}

export type OrganizationMemberRole = OrganizationMember & {
  role?: Role;
};

/**
 * A member to be modified according to the available types of modifications.
 * For a `CHANGE_ROLE` modification, the `role` property will be required.
 */
export interface ModifyMemberItem {
  /** A user UUID. */
  member: OrganizationMember;
  /** The modification to make to an organization member. */
  modification: Modification;
  role?: Role;
}

/**
 * The E-mail address of the invited party.
 * @example "person@people.net"
 */
export type Email = string;

/** @example "ADMIN" */
export enum Role {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
}

/**
 * The modification to make to an organization member.
 * @example "CHANGE_ROLE"
 */
export enum Modification {
  REMOVE = 'REMOVE',
  CHANGE_ROLE = 'CHANGE_ROLE',
}

/**
 * A pretty name for a developer organization.
 * @min 3
 * @max 256
 * @example "Shoes n' Boots"
 */
export type Label = string;

/**
 * Manufacturer name for the organization.
 * @example "ShoeBoots"
 */
export type ManufacturerName = string;

/**
 * Legacy `mnId` (also `mnid`) field used by some Samsung services.
 * @example "ShoeBoots"
 */
export type MnId = string;

/**
 * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
 * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
 * @min 3
 * @max 128
 * @example "shoesNBoots1"
 */
export type OrganizationName = string;

/**
 * The groupId that corresponds to this organization in warehouse.
 * @format uuid
 * @example "81bfb21a-8716-410b-b2c7-40c14f585b60"
 */
export type WarehouseGroupId = string;

export interface GetDevicesParams {
  /**
   * The Device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The Device Locations to filter the results by. */
  locationId?: string[];
  /** The Device IDs to filter the results by. */
  deviceId?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted Devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list Devices accessible by the given accessLevel. */
  accessLevel?: number;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface ExecuteDeviceCommandsParams {
  /** Specifies whether the command should be executed in order or asynchronously. */
  ordered?: boolean;
  /** The Device ID */
  deviceId: string;
}

export interface ListDeviceProfilesParams {
  /** Filter the results by Device Profile IDs. */
  profileId?: string[];
}

export interface GenerateDeviceConfigParams {
  /**
   * Represents the way that the provided device type is formatted, either in the form of a "dth" or a "profile"
   * @default "profile"
   */
  typeIntegration?: 'profile' | 'dth';
  /** Data Management Shard ID where the device type resides. Only useful for `DTH` type integrations. Example: `na04` */
  typeShardId?: string;
  /** A parameter that can be set if you want to exclude capabilities having no presentation from the device presentation configuration. */
  excludeUndisplayableCapabilitiesFromPresentation?: boolean;
  /** Device Profile or DTH ID. Assumes profile if the typeIntegration parameter is not set. */
  typeIntegrationId: string;
}

export interface GetDeviceConfigurationParams {
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
}

export interface GetDevicePresentationParams {
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /**
   * The ID of a device for which we want to load the device presentation.
   * If the device ID is provided, no other fields are required.
   */
  deviceId?: string;
  /** view type */
  view?: 'dashboard' | 'detailView' | 'automation';
}

export interface ListDeviceGroupsParams {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface ListLocationsParams {
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /** Maximum number of Locations returned in a paged result set. */
  limit?: number;
  /** Next page result set key. */
  page?: string;
}

export interface CreateLocationParams {
  /**
   * If set to true, the response may contain the allowed list property.  Note that setting this to true may significantly slow the response time.  If you are creating a location for your own account, then you know you will have all these permissions and can avoid the trouble of passing in this parameter.
   * @default false
   */
  allowed?: string;
}

export interface GetLocationParams {
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface CreateRoomParams {
  /**
   * If set to true, the response may contain the allowed list property.  Note that setting this to true may significantly slow the response time.  If you are creating a room for your own account, then you know you will have all these permissions and can avoid the trouble of passing in this parameter.
   * @default false
   */
  allowed?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface DeleteModeParams {
  /** The `requestId` received from the 409 conflict response when first making the request to delete a Mode. The presence of this query parameter, once validated, will trigger the deletion of the Mode. */
  requestId?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId: string;
}

export interface ListInvitationsInviteeParams {
  /** Filter by invitation status. Default is PENDING. */
  status?: string;
}

export interface ListInvitationsInviterParams {
  /** Filter by invitation status. Default is PENDING. */
  status?: string;
}

export interface ListInstallationsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** State of the installed application */
  installedAppStatus?: 'PENDING' | 'AUTHORIZED' | 'REVOKED' | 'DISABLED';
  /** Denotes the type of installed app. */
  installedAppType?: 'LAMBDA_SMART_APP' | 'WEBHOOK_SMART_APP';
  /**
   * May be used to filter a resource by its assigned user-tags.  Multiple tag query params are automatically joined with OR.
   *
   * Example usage in query string:
   * ```
   * ?tag:key_name=value1&tag:key_name=value2
   * ```
   * @format ^[a-zA-Z_]{1,64}$
   */
  tag?: string;
  /**
   * The ID of an App
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  appId?: string;
  /**
   * The ID of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /**
   * The ID of the Device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
}

export interface GetInstallationParams {
  /** If set to true, the item in the response will contain the allowed list property. */
  allowed?: boolean;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface ListInstallationConfigParams {
  /** Filter for configuration status. */
  configurationStatus?: 'STAGED' | 'DONE' | 'AUTHORIZED' | 'REVOKED';
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface DeleteAllSubscriptionsParams {
  /**
   * Limit deletion to subscriptions for a particular device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * Limit deletion to subscriptions for a particular mode or deletes parent if last mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface CreateAppParams {
  /** The Signature Type of the application. For WEBHOOK_SMART_APP only. */
  signatureType?: 'APP_RSA' | 'ST_PADLOCK';
  /** Override default configuration to use either PING or CONFIRMATION lifecycle. For WEBHOOK_SMART_APP only. */
  requireConfirmation?: boolean;
}

export interface ListAppsParams {
  /** The App Type of the application. */
  appType?: 'LAMBDA_SMART_APP' | 'WEBHOOK_SMART_APP';
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   */
  classification?: 'AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE';
  /**
   * May be used to filter a resource by its assigned user-tags.  Multiple tag query params are automatically joined with OR.
   *
   * Example usage in query string:
   * ```
   * ?tag:key_name=value1&tag:key_name=value2
   * ```
   * @format ^[a-zA-Z_]{1,64}$
   */
  tag?: string;
}

export interface UpdateAppParams {
  /** The Signature Type of the application. For WEBHOOK_SMART_APP only. */
  signatureType?: 'APP_RSA' | 'ST_PADLOCK';
  /** Override default configuration to use either PING or CONFIRMATION lifecycle. For WEBHOOK_SMART_APP only. */
  requireConfirmation?: boolean;
  /** The appName or appId field of an app. */
  appNameOrId: string;
}

export interface ListRulesParams {
  /**
   * The ID of the Location you want to list Rules for.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * If set to true, all rules are returned
   * @default false
   */
  includeAllParents?: string;
  /** The max number of Rules to fetch */
  max?: number;
  /** The start index of Rules to fetch */
  offset?: number;
}

export interface CreateRuleParams {
  /**
   * The ID of the Location where the Rule should be posted.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface DeleteAllRulesParams {
  /**
   * The ID of the location in which the rules must be deleted.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRuleParams {
  /**
   * The ID of the Location containing the Rule you wish to retrieve.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The rule ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface UpdateRuleParams {
  /**
   * The ID of the Location that contains the Rule.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The rule ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface DeleteRuleParams {
  /**
   * The ID of the Location that contains the Rule.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The rule ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface ExecuteRuleParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The rule ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface ListScenesParams {
  /**
   * The location of a scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface ExecuteSceneParams {
  /**
   * The location of a scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the Scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface ListPreferencesParams {
  /** Filters the queried preferences by namespace. */
  namespace?: string;
  /** The number of records to return in this page */
  pageSize?: number;
  /** The index of the last record retrieved. */
  startKey?: string;
}

export interface CreateCapabilityParams {
  /**
   * The namespace of the Capability
   * @pattern ^[a-z0-9]{1,36}$
   */
  namespace?: string;
}

export interface GetCapabilityLocalizationParams {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** The ID of the capability. */
  capabilityId: string;
  /** The version of the Capability */
  capabilityVersion: number;
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  locale: string;
}

export interface UpdateCapabilityLocalizationParams {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** The ID of the capability. */
  capabilityId: string;
  /** The version of the Capability */
  capabilityVersion: number;
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  locale: string;
}

export interface PatchCapabilityLocalizationParams {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** The ID of the capability. */
  capabilityId: string;
  /** The version of the Capability */
  capabilityVersion: number;
  /** The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt). */
  locale: string;
}

/** The capability presentation describes how the capability will look in the app, what actions and states are shown, as well as how conditions and actions are expressed in an automation. */
export interface UpdateCustomCapabilityPresentationPayload {
  /** The dashboard is the main view in the SmartThings app that shows a list of devices and their state. */
  dashboard?: DashboardForCapability;
  detailView?: DetailViewForCapability;
  /** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device state is met. */
  automation?: AutomationForCapability;
}

export interface ListUserOrganizationsParams {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
}

export interface GetDevicesHistoryParams {
  /** The device locations IDs to filter the results by. */
  locationId?: string[];
  /** The device IDs to filter the results by. */
  deviceId?: string[];
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Optional. Number of records to return. Default is 20.
   * @default 20
   */
  limit?: number;
  /**
   * If set to true, device activities are listed in chronological order. Default is false.
   * @default false
   */
  oldestFirst?: boolean;
}

export interface GetDevicesByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** isaId of the user. */
  isaId: string;
}

export interface DeleteIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId of the user. */
  isaId: string;
}

export interface DeleteSubscriptionByIsaIdParams {
  /** installed app ID */
  isaId: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetCapabilityByLocationIdParams {
  /** Geo place ID of a specific alert.  To use of this query, query "name=alert" is REQUIRED and not to combine with any other capabilty.  (postalCode and geoplaceId cannot be used together) */
  geoplaceId?: string;
  /** Postal code of a specific alert.  To use of this query, query "name=alert" is REQUIRED and not to combine with any other capabilty. (postalCode and geoplaceId cannot be used together) */
  postalCode?: string;
  /** Comma separated string of capabilities (alert, weather, airQuality, forecast, airQualityForcast). For example, "weather,airQuality" */
  name?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetAlertLinkByLocationIdParams {
  /** The ID of the Geo Place (geoplaceId, postalCode, and subscriptionId cannot be combined) */
  geoplaceId?: string;
  /** The postal code (geoplaceId, postalCode, and subscriptionId cannot be combined) */
  postalCode?: string;
  /** The ID of the Nimbus subscription (geoplaceId, postalCode and subscirptionId cannot be combined) */
  subscriptionId?: string;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListDriverChannelsParams {
  /** The type of channels */
  channelType?: string;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface ListHubInstalledDriversParams {
  /** optional filter to only return installed drivers that can be used by the passed in device */
  deviceId?: string;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface UpdateHubDeviceParams {
  /**
   * A flag that is used to indicate that the driver and profile should be updated even if the fingerprinting process
   * fails. Additionally, forceUpdate is required when a new device integration profile key is provided in
   * the request payload.
   */
  forceUpdate?: boolean;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
  /** The Device ID */
  deviceId: string;
}

export interface EnableZWaveExclusionParams {
  /**
   * the amount of time the hub should stay in exclusion mode
   * @default 15
   */
  timeout?: number;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface ListHubsParams {
  /** The locationId of hub */
  locationId?: string;
}

export interface ListHubCharactersticsParams {
  /**
   * The subset of names you want to filter the characterstics to. If not specified all values will be returned
   * These values have to be exact matches to (including proper capitilization)
   */
  characteristicNames?: string[];
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface GetHubReplacementCandidatesParams {
  /** The destination hub to filter candidates results to. */
  destinationHubId?: string;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface ListDriversParams {
  driverIds?: string[];
}

export interface ListChannelsParams {
  /** Filter channels by subscriber type */
  type?: 'HUB';
  /** Filter channels based on the subscriber (e.g. hub ID) */
  subscriberId?: string;
  /** Filter channels based on user access. Defaults to filtering channels a user has both read and write access to. */
  includeReadOnly?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://api.smartthings.com/v1';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title SmartThings API
 * @version 1.0-PREVIEW
 * @baseUrl https://api.smartthings.com/v1
 *
 * # Overview
 *
 * This is the reference documentation for the SmartThings API.
 *
 * The SmartThings API, a RESTful API, provides a method for your integration to communicate with the SmartThings Platform. The API is the core of the platform. It is used to control devices, create Automations, manage Locations, retrieve user and device information; if you want to communicate with the SmartThings platform, you’ll be using the SmartThings API. All responses are sent as [JSON](http://www.json.org/).
 *
 * The SmartThings API consists of several endpoints, including Rules, Locations, Devices, and more. Even though each of these endpoints are not standalone APIs, you may hear them referred to as such. For example, the Rules API is used to build Automations.
 *
 * # Authentication
 *
 * Before using the SmartThings API, you’ll need to obtain an Authorization Token. All SmartThings resources are protected with [OAuth 2.0 Bearer Tokens](https://tools.ietf.org/html/rfc6750#section-2.1) sent on the request as an `Authorization: Bearer <TOKEN>` header. Operations require specific OAuth scopes that specify the exact permissions authorized by the user.
 *
 * ## Authorization token types
 *
 * There are two types of tokens:
 *   * SmartApp tokens
 *   * Personal access tokens (PAT).
 *
 * ### SmartApp tokens
 *
 * SmartApp tokens are used to communicate between third-party integrations, or SmartApps, and the SmartThings API.
 * When a SmartApp is called by the SmartThings platform, it is sent an authorization token that can be used to interact with the SmartThings API.
 *
 * ### Personal access tokens
 *
 * Personal access tokens are used to authorize interaction with the API for non-SmartApp use cases. When creating personal access tokens, you can specifiy the permissions granted to the token. These permissions define the OAuth2 scopes for the personal access token.
 *
 * Personal access tokesn can be created and managed on the [personal access tokens page](https://account.smartthings.com/tokens).
 *
 * ## OAuth2 scopes
 *
 * Operations may be protected by one or more OAuth security schemes, which specify the required permissions.
 * Each scope for a given scheme is required.
 * If multiple schemes are specified (uncommon), you may use either scheme.
 *
 * SmartApp token scopes are derived from the permissions requested by the SmartApp and granted by the end-user during installation.
 * Personal access token scopes are associated with the specific permissions authorized when the token is created.
 *
 * Scopes are generally in the form `permission:entity-type:entity-id`.
 *
 * **An `*` used for the `entity-id` specifies that the permission may be applied to all entities that the token type has access to, or may be replaced with a specific ID.**
 *
 * For more information about authrization and permissions, visit the [Authorization section](https://developer-preview.smartthings.com/docs/advanced/authorization-and-permissions) in the SmartThings documentation.
 *
 * <!-- ReDoc-Inject: <security-definitions> -->
 *
 * # Errors
 *
 * The SmartThings API uses conventional HTTP response codes to indicate the success or failure of a request.
 *
 * In general:
 *
 * * A `2XX` response code indicates success
 * * A `4XX` response code indicates an error given the inputs for the request
 * * A `5XX` response code indicates a failure on the SmartThings platform
 *
 * API errors will contain a JSON response body with more information about the error:
 *
 * ```json
 * {
 *   "requestId": "031fec1a-f19f-470a-a7da-710569082846"
 *   "error": {
 *     "code": "ConstraintViolationError",
 *     "message": "Validation errors occurred while process your request.",
 *     "details": [
 *       { "code": "PatternError", "target": "latitude", "message": "Invalid format." },
 *       { "code": "SizeError", "target": "name", "message": "Too small." },
 *       { "code": "SizeError", "target": "description", "message": "Too big." }
 *     ]
 *   }
 * }
 * ```
 *
 * ## Error Response Body
 *
 * The error response attributes are:
 *
 * | Property | Type | Required | Description |
 * | --- | --- | --- | --- |
 * | requestId | String | No | A request identifier that can be used to correlate an error to additional logging on the SmartThings servers.
 * | error | Error | **Yes** | The Error object, documented below.
 *
 * ## Error Object
 *
 * The Error object contains the following attributes:
 *
 * | Property | Type | Required | Description |
 * | --- | --- | --- | --- |
 * | code | String | **Yes** | A SmartThings-defined error code that serves as a more specific indicator of the error than the HTTP error code specified in the response. See [SmartThings Error Codes](#section/Errors/SmartThings-Error-Codes) for more information.
 * | message | String | **Yes** | A description of the error, intended to aid debugging of error responses.
 * | target | String | No | The target of the error. For example, this could be the name of the property that caused the error.
 * | details | Error[] | No | An array of Error objects that typically represent distinct, related errors that occurred during the request. As an optional attribute, this may be null or an empty array.
 *
 * ## Standard HTTP Error Codes
 *
 * The following table lists the most common HTTP error responses:
 *
 * | Code | Name | Description |
 * | --- | --- | --- |
 * | 400 | Bad Request | The client has issued an invalid request. This is commonly used to specify validation errors in a request payload.
 * | 401 | Unauthorized | Authorization for the API is required, but the request has not been authenticated.
 * | 403 | Forbidden | The request has been authenticated but does not have appropriate permissions, or a requested resource is not found.
 * | 404 | Not Found | The requested path does not exist.
 * | 406 | Not Acceptable | The client has requested a MIME type via the Accept header for a value not supported by the server.
 * | 415 | Unsupported Media Type | The client has defined a contentType header that is not supported by the server.
 * | 422 | Unprocessable Entity | The client has made a valid request, but the server cannot process it. This is often used for APIs for which certain limits have been exceeded.
 * | 429 | Too Many Requests | The client has exceeded the number of requests allowed for a given time window.
 * | 500 | Internal Server Error | An unexpected error on the SmartThings servers has occurred. These errors are generally rare.
 * | 501 | Not Implemented | The client request was valid and understood by the server, but the requested feature has yet to be implemented. These errors are generally rare.
 *
 * ## SmartThings Error Codes
 *
 * SmartThings specifies several standard custom error codes.
 * These provide more information than the standard HTTP error response codes.
 * The following table lists the standard SmartThings error codes and their descriptions:
 *
 * | Code | Typical HTTP Status Codes | Description |
 * | --- | --- | --- |
 * | PatternError | 400, 422 | The client has provided input that does not match the expected pattern.
 * | ConstraintViolationError | 422 | The client has provided input that has violated one or more constraints.
 * | NotNullError | 422 | The client has provided a null input for a field that is required to be non-null.
 * | NullError | 422 | The client has provided an input for a field that is required to be null.
 * | NotEmptyError | 422 | The client has provided an empty input for a field that is required to be non-empty.
 * | SizeError | 400, 422 | The client has provided a value that does not meet size restrictions.
 * | Unexpected Error | 500 | A non-recoverable error condition has occurred. A problem occurred on the SmartThings server that is no fault of the client.
 * | UnprocessableEntityError | 422 | The client has sent a malformed request body.
 * | TooManyRequestError | 429 | The client issued too many requests too quickly.
 * | LimitError | 422 | The client has exceeded certain limits an API enforces.
 * | UnsupportedOperationError | 400, 422 | The client has issued a request to a feature that currently isn't supported by the SmartThings platform. These errors are generally rare.
 *
 * ## Custom Error Codes
 *
 * An API may define its own error codes where appropriate.
 * Custom error codes are documented in each API endpoint's documentation section.
 *
 * # Warnings
 * The SmartThings API issues warning messages via standard HTTP Warning headers. These messages do not represent a request failure, but provide additional information that the requester might want to act upon.
 * For example, a warning will be issued if you are using an old API version.
 *
 * # API Versions
 *
 * The SmartThings API supports both path and header-based versioning.
 * The following are equivalent:
 *
 * - https://api.smartthings.com/v1/locations
 * - https://api.smartthings.com/locations with header `Accept: application/vnd.smartthings+json;v=1`
 *
 * Currently, only version 1 is available.
 *
 * # Paging
 *
 * Operations that return a list of objects return a paginated response.
 * The `_links` object contains the items returned, and links to the next and previous result page, if applicable.
 *
 * ```json
 * {
 *   "items": [
 *     {
 *       "locationId": "6b3d1909-1e1c-43ec-adc2-5f941de4fbf9",
 *       "name": "Home"
 *     },
 *     {
 *       "locationId": "6b3d1909-1e1c-43ec-adc2-5f94d6g4fbf9",
 *       "name": "Work"
 *     }
 *     ....
 *   ],
 *   "_links": {
 *     "next": {
 *       "href": "https://api.smartthings.com/v1/locations?page=3"
 *     },
 *     "previous": {
 *       "href": "https://api.smartthings.com/v1/locations?page=1"
 *     }
 *   }
 * }
 * ```
 *
 * # Allowed Permissions
 *
 * The response payload to a request for a SmartThings entity (e.g. a location or a device) may contain an
 * `allowed` list property.  This list contains strings called **action identifiers** (such as `w:locations`)
 * that provide information about what actions are permitted by the user's token on that entity at the time the request was
 * processed.
 *
 * The action identifiers are defined in the API documentation for the 200 response of the particular endpoint queried.
 * For each documented action identifier (e.g. `w:locations`), you will find a description of the user action
 * (e.g. "edit the name of the location") associated with that identifier. The endpoint documentation will contain a
 * complete list of the action identifiers that may appear in the allowed list property.
 *
 * If the `allowed` list property is present in the response payload:
 * * the user action documented for an action identifier present in the list is permitted for the user on the entity at the time the request is processed
 * * the user action documented for an action identifier **not** present in the list is **not** permitted to the user on the entity at the time the request is processed
 *
 * If the `allowed` list property is **not** present or has a `null` value in the response payload, then the response provides **no information**
 * about any user actions being permissible except that the user has permission to view the returned entity.
 *
 * The response provides **no information** about the permissibility of user actions that are not specifically mentioned
 * in the documentation for the particular endpoint.
 *
 * The table below is a high-level guide to interpreting action identifiers.  It does not indicate
 * that any given endpoint will document or return any of the action identifiers listed below.
 * Remember that the endpoint API documentation is the final source of truth for interpreting action identifiers in a response payload.
 *
 * | Action Identifier Format | Examples | Meaning |
 * | --- | --- | --- |
 * | `w:grant:`\<grant type> | `w:grant:share` on a location payload | User may **bestow** the grant type on the entity to another user (e.g. through an invitation.) |
 * | `r:`\<child type> | `r:devices` on a location payload | User may **list and view** child type entities of the returned entity.  NOTE: there may be finer-grained controls on the child type entities. |
 * | `l:`\<child type> | `l:devices` on a location payload | User may **list and summarize** child type entities of the returned entity.  NOTE: there may be finer-grained controls on the child type entities.  This is weaker than `r:`\<child type> and rarely used. |
 * | `w:`\<child type> | `w:devices` on a location payload | User may **create** entities of the child type as children of the returned entity. |
 * | `x:`\<child type> | `x:devices` on a location payload | User may **execute commands** on child type entities of the returned entity.  NOTE: there may be finer-grained controls on the child type entities. |
 * | `r:`\<entity type> | `r:locations` on a location payload | This will only be returned in a list/summary response and only in a case when the list/summary is designed not to show all the details of the entity. |
 * | `w:`\<entity type> | `w:locations` on a location payload<br/>`w:devices` on a device payload | User may **edit** specifically-documented properties of the returned entity. |
 * | `x:`\<entity type> | `x:devices` on a device payload | user may **execute commands** on the returned entity.  NOTE: there may be finer-grained controls on the children of the entity. |
 * | `d:`\<entity type> | `d:locations` on a location payload | User may **delete** the returned entity. |
 * | `r:`\<entity type>`:`\<attribute group> | `r:locations:currentmode` on a location payload | User may **view** the specified (and clearly-documented) attribute or attribute group of the returned entity. |
 * | `w:`\<entity type>`:`\<attribute group> | `w:locations:geo` on a location payload | User may **edit** the specified (and clearly-documented) attribute or attribute group of the returned entity. |
 * | `x:`\<entity type>`:`\<attribute group> | `x:devices:switch` on a device payload | User may **execute commands** on the specified (and clearly-documented) attribute or attribute group of the returned entity. |
 *
 * # Localization
 *
 * Some SmartThings APIs support localization.
 * Specific information regarding localization endpoints are documented in the API itself.
 * However, the following applies to all endpoints that support localization.
 *
 * ## Fallback Patterns
 *
 * When making a request with the `Accept-Language` header, the following fallback pattern is observed:
 * 1. Response will be translated with exact locale tag.
 * 2. If a translation does not exist for the requested language and region, the translation for the language will be returned.
 * 3. If a translation does not exist for the language, English (en) will be returned.
 * 4. Finally, an untranslated response will be returned in the absence of the above translations.
 *
 * ## Accept-Language Header
 * The format of the `Accept-Language` header follows what is defined in [RFC 7231, section 5.3.5](https://tools.ietf.org/html/rfc7231#section-5.3.5)
 *
 * ## Content-Language
 * The `Content-Language` header should be set on the response from the server to indicate which translation was given back to the client.
 * The absense of the header indicates that the server did not recieve a request with the `Accept-Language` header set.
 */
export class ApiApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices
     * @name GetDevices
     * @summary List Devices
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Install a Device. This call is only available for SmartApp-managed Devices. The SmartApp that creates the Device is responsible for handling commands for the Device and updating the status of the Device by creating events. Requires installed app principal.
     *
     * @tags Devices
     * @name InstallDevice
     * @summary Install a Device
     * @request POST:/devices
     * @secure
     */
    installDevice: (InstallationRequest: DeviceInstallRequest, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices`,
        method: 'POST',
        body: InstallationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Device's given description.
     *
     * @tags Devices
     * @name GetDevice
     * @summary Get the Description of a Device
     * @request GET:/devices/{deviceId}
     * @secure
     */
    getDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Device with a given Device ID. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to delete, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name DeleteDevice
     * @summary Delete a Device
     * @request DELETE:/devices/{deviceId}
     * @secure
     */
    deleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceCommandsResponse, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the properties of a Device. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to update, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name UpdateDevice
     * @summary Update a Device
     * @request PUT:/devices/{deviceId}
     * @secure
     */
    updateDevice: (deviceId: string, updateDeviceRequest: UpdateDeviceRequest, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'PUT',
        body: updateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a specified command on a Device.
     *
     * @tags Devices
     * @name ExecuteDeviceCommands
     * @summary Execute Commands on a Device
     * @request POST:/devices/{deviceId}/commands
     * @secure
     */
    executeDeviceCommands: (
      { deviceId, ...query }: ExecuteDeviceCommandsParams,
      executeCapabilityCommand: DeviceCommandsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCommandsResponse, ErrorResponse>({
        path: `/devices/${deviceId}/commands`,
        method: 'POST',
        query: query,
        body: executeCapabilityCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for a Device. When a Device is managed by a SmartApp, the Device is responsible for creating events to update the Device attributes on the SmartThings Platform. The OAuth token used must be for the SmartApp that created the Device.
     *
     * @tags Devices
     * @name CreateDeviceEvents
     * @summary Create Device Events
     * @request POST:/devices/{deviceId}/events
     * @secure
     */
    createDeviceEvents: (deviceId: string, deviceEventRequest: DeviceEventsRequest, params: RequestParams = {}) =>
      this.request<CreateDeviceEventsResponse, ErrorResponse>({
        path: `/devices/${deviceId}/events`,
        method: 'POST',
        body: deviceEventRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current status of all of a Device component's attributes. The results may be filtered if the requester only has permission to view a subset of the Device's components or capabilities. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API. DEPRECATION NOTICE: healthState is no longer included in response.
     *
     * @tags Devices
     * @name GetDeviceStatus
     * @summary Get the Full Status of a Device
     * @request GET:/devices/{deviceId}/status
     * @secure
     */
    getDeviceStatus: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceStatus, ErrorResponse>({
        path: `/devices/${deviceId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status of all attributes of a specified component. The results may be filtered if the requester only has permission to view a subset of the component's capabilities. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API.
     *
     * @tags Devices
     * @name GetDeviceComponentStatus
     * @summary Get the Status of a Device Component
     * @request GET:/devices/{deviceId}/components/{componentId}/status
     * @secure
     */
    getDeviceComponentStatus: (deviceId: string, componentId: string, params: RequestParams = {}) =>
      this.request<ComponentStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current status of a Device component's capability. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API.
     *
     * @tags Devices
     * @name GetDeviceStatusByCapability
     * @summary Get the Status of a Capability
     * @request GET:/devices/{deviceId}/components/{componentId}/capabilities/{capabilityId}/status
     * @secure
     */
    getDeviceStatusByCapability: (
      deviceId: string,
      componentId: string,
      capabilityId: string,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/capabilities/${capabilityId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  deviceprofiles = {
    /**
     * @description Create a Device Profile.
     *
     * @tags Profiles
     * @name CreateDeviceProfile
     * @summary Create a Device Profile
     * @request POST:/deviceprofiles
     * @secure
     */
    createDeviceProfile: (request: CreateDeviceProfileRequest, params: RequestParams = {}) =>
      this.request<DeviceProfileResponse, ErrorResponse>({
        path: `/deviceprofiles`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Device Profiles in an authenticated user's account.
     *
     * @tags Profiles
     * @name ListDeviceProfiles
     * @summary List all Device Profiles for a User
     * @request GET:/deviceprofiles
     * @secure
     */
    listDeviceProfiles: (query: ListDeviceProfilesParams, params: RequestParams = {}) =>
      this.request<PagedDeviceProfiles, ErrorResponse>({
        path: `/deviceprofiles`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the Device Profile of a given Device.
     *
     * @tags Profiles
     * @name GetDeviceProfile
     * @summary Get a Device Profile
     * @request GET:/deviceprofiles/{deviceProfileId}
     * @secure
     */
    getDeviceProfile: (deviceProfileId: string, params: RequestParams = {}) =>
      this.request<DeviceProfileResponse, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Device Profile by Device Profile ID.
     *
     * @tags Profiles
     * @name DeleteDeviceProfile
     * @summary Delete a Device Profile
     * @request DELETE:/deviceprofiles/{deviceProfileId}
     * @secure
     */
    deleteDeviceProfile: (deviceProfileId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceProfileResponse, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Device Profile. The Device Profile must be currently deployed.
     *
     * @tags Profiles
     * @name UpdateDeviceProfile
     * @summary Update a Device Profile
     * @request PUT:/deviceprofiles/{deviceProfileId}
     * @secure
     */
    updateDeviceProfile: (deviceProfileId: string, request: UpdateDeviceProfileRequest, params: RequestParams = {}) =>
      this.request<DeviceProfileResponse, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of supported locales for the device profile
     *
     * @tags Profiles
     * @name GetDeviceProfileLocales
     * @summary Get i18n locales
     * @request GET:/deviceprofiles/{deviceProfileId}/i18n
     * @secure
     */
    getDeviceProfileLocales: (deviceProfileId: string, params: RequestParams = {}) =>
      this.request<DeviceProfileLocaleTranslations, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}/i18n`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the translations for a particular locale.
     *
     * @tags Profiles
     * @name GetDeviceProfileTranslations
     * @summary Get translations for the device profile
     * @request GET:/deviceprofiles/{deviceProfileId}/i18n/{locale}
     * @secure
     */
    getDeviceProfileTranslations: (deviceProfileId: string, locale: string, params: RequestParams = {}) =>
      this.request<DeviceProfileTranslations, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}/i18n/${locale}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create or update a translation.
     *
     * @tags Profiles
     * @name PutDeviceProfileTranslations
     * @summary Upsert a translation for the device profile
     * @request PUT:/deviceprofiles/{deviceProfileId}/i18n/{locale}
     * @secure
     */
    putDeviceProfileTranslations: (
      deviceProfileId: string,
      locale: string,
      translations: DeviceProfileTranslations,
      params: RequestParams = {},
    ) =>
      this.request<DeviceProfileTranslations, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}/i18n/${locale}`,
        method: 'PUT',
        body: translations,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete the translations for a device profile by locale.
     *
     * @tags Profiles
     * @name DeleteDeviceProfileTranslations
     * @summary Delete translations
     * @request DELETE:/deviceprofiles/{deviceProfileId}/i18n/{locale}
     * @secure
     */
    deleteDeviceProfileTranslations: (deviceProfileId: string, locale: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/deviceprofiles/${deviceProfileId}/i18n/${locale}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  presentation = {
    /**
     * @description Examines the profile of the Device and constructs a default device configuration. Note: This API functionality is in BETA
     *
     * @tags Presentations
     * @name GenerateDeviceConfig
     * @summary Generate Device Configuration from a Device Profile or DTH
     * @request GET:/presentation/types/{typeIntegrationId}/deviceconfig
     * @secure
     */
    generateDeviceConfig: ({ typeIntegrationId, ...query }: GenerateDeviceConfigParams, params: RequestParams = {}) =>
      this.request<CreateDeviceConfigRequest, ErrorResponse>({
        path: `/presentation/types/${typeIntegrationId}/deviceconfig`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Make an idempotent call to either create or get a device configuration based on the structure of the provided payload. Note: This API functionality is in BETA
     *
     * @tags Presentations
     * @name CreateDeviceConfiguration
     * @summary Create a Device Configuration
     * @request POST:/presentation/deviceconfig
     * @secure
     */
    createDeviceConfiguration: (request: CreateDeviceConfigRequest, params: RequestParams = {}) =>
      this.request<PublicDeviceConfiguration, ErrorResponse>({
        path: `/presentation/deviceconfig`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve a device configuration. Note: This API functionality is in BETA
     *
     * @tags Presentations
     * @name GetDeviceConfiguration
     * @summary Get a Device Configuration
     * @request GET:/presentation/deviceconfig
     * @secure
     */
    getDeviceConfiguration: (query: GetDeviceConfigurationParams, params: RequestParams = {}) =>
      this.request<PublicDeviceConfiguration, ErrorResponse>({
        path: `/presentation/deviceconfig`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a device presentation. If Manufacturer Name is omitted, the default `SmartThingsCommunity` will be assumed. This endpoint currently supports automatic generation of UI-metadata only for those presentations created through the presentation APIs, and not custom UI-metadata created through the legacy workflow. Note: This API functionality is in BETA
     *
     * @tags Presentations
     * @name GetDevicePresentation
     * @summary Get a Device Presentation
     * @request GET:/presentation
     * @secure
     */
    getDevicePresentation: (query: GetDevicePresentationParams, params: RequestParams = {}) =>
      this.request<DossierDevicePresentation, ErrorResponse>({
        path: `/presentation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags devicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/devicegroups
     * @secure
     */
    listDeviceGroups: (query: ListDeviceGroupsParams, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, ErrorResponse>({
        path: `/devicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group Upon group creation, the group type is decided based on the given input and the capabilities of the included devices; the resulting group type may not be what is passed in.
     *
     * @tags devicegroups
     * @name CreateDeviceGroup
     * @summary create a device group
     * @request POST:/devicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single device group by Id
     *
     * @tags devicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/devicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags devicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/devicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags devicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/devicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets status of all devices in the group, and an aggregate. The capabilities returned here are not a complete list of the group's, or individual devices', capabilities. For that, please use the /devicegroups/{deviceGroupId} endpoint.
     *
     * @tags devicegroups
     * @name GetDeviceGroupStatus
     * @summary Show status of all devices in a group
     * @request GET:/devicegroups/{deviceGroupId}/status
     * @secure
     */
    getDeviceGroupStatus: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupStatusGizmoResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a device group command.
     *
     * @tags devicegroups
     * @name ExecuteDeviceGroupCommand
     * @summary Execute a device group command.
     * @request POST:/devicegroups/{deviceGroupId}/commands
     * @secure
     */
    executeDeviceGroupCommand: (
      deviceGroupId: string,
      executeDeviceGroupCommand: DeviceGroupCommandRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceGroupCommandResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}/commands`,
        method: 'POST',
        body: executeDeviceGroupCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description List all Locations currently accessible to the requester.  (Possibly paginated.)
     *
     * @tags Locations
     * @name ListLocations
     * @summary List Locations
     * @request GET:/locations
     * @secure
     */
    listLocations: (query: ListLocationsParams, params: RequestParams = {}) =>
      this.request<PagedLocations, void | ErrorResponse>({
        path: `/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Location for a user. The Location will be created geographically close to the country code provided in the request body. If Location creation is not supported in the requested country code, the API will return a 422 error response with an error code of UnsupportedGeoRegionError.
     *
     * @tags Locations
     * @name CreateLocation
     * @summary Create a Location
     * @request POST:/locations
     * @secure
     */
    createLocation: (
      query: CreateLocationParams,
      createLocationRequest: CreateLocationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateLocationResponse, ErrorResponse>({
        path: `/locations`,
        method: 'POST',
        query: query,
        body: createLocationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific Location if accessible to the requester.
     *
     * @tags Locations
     * @name GetLocation
     * @summary Get a Location
     * @request GET:/locations/{locationId}
     * @secure
     */
    getLocation: ({ locationId, ...query }: GetLocationParams, params: RequestParams = {}) =>
      this.request<Location, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update one or more fields of a specified Location. All fields in the request body are optional. Only the specified fields will be updated.
     *
     * @tags Locations
     * @name UpdateLocation
     * @summary Update a Location
     * @request PUT:/locations/{locationId}
     * @secure
     */
    updateLocation: (locationId: string, updateLocationRequest: UpdateLocationRequest, params: RequestParams = {}) =>
      this.request<UpdateLocationResponse, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'PUT',
        body: updateLocationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update or unset one or more fields of a specified Location.  If, for a given value, both `toNull=true` and a `value` are provided, the response will be a `422`.
     *
     * @tags Locations
     * @name PatchLocation
     * @summary Patch a location
     * @request PATCH:/locations/{locationId}
     * @secure
     */
    patchLocation: (locationId: string, patchLocationRequest: PatchLocationRequest, params: RequestParams = {}) =>
      this.request<UpdateLocationResponse, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'PATCH',
        body: patchLocationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Location from a user's account.
     *
     * @tags Locations
     * @name DeleteLocation
     * @summary Delete a Location
     * @request DELETE:/locations/{locationId}
     * @secure
     */
    deleteLocation: (locationId: string, params: RequestParams = {}) =>
      this.request<DeleteLocationResponse, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Rooms currently available in a Location.
     *
     * @tags Rooms
     * @name ListRooms
     * @summary List Rooms
     * @request GET:/locations/{locationId}/rooms
     * @secure
     */
    listRooms: (locationId: string, params: RequestParams = {}) =>
      this.request<PagedRooms, ErrorResponse>({
        path: `/locations/${locationId}/rooms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Room for a given Location.
     *
     * @tags Rooms
     * @name CreateRoom
     * @summary Create a Room
     * @request POST:/locations/{locationId}/rooms
     * @secure
     */
    createRoom: (
      { locationId, ...query }: CreateRoomParams,
      createRoomRequest: CreateRoomRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateRoomResponse, ErrorResponse>({
        path: `/locations/${locationId}/rooms`,
        method: 'POST',
        query: query,
        body: createRoomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get details of a specific Room.
     *
     * @tags Rooms
     * @name GetRoom
     * @summary Get a Room
     * @request GET:/locations/{locationId}/rooms/{roomId}
     * @secure
     */
    getRoom: (locationId: string, roomId: string, params: RequestParams = {}) =>
      this.request<Room, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update one or more fields of a specified Room. All fields in the request body are optional. Only the specified fields will be updated.
     *
     * @tags Rooms
     * @name UpdateRoom
     * @summary Update a Room
     * @request PUT:/locations/{locationId}/rooms/{roomId}
     * @secure
     */
    updateRoom: (
      locationId: string,
      roomId: string,
      updateRoomRequest: UpdateRoomRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRoomResponse, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}`,
        method: 'PUT',
        body: updateRoomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Room from a Location.
     *
     * @tags Rooms
     * @name DeleteRoom
     * @summary Delete a Room
     * @request DELETE:/locations/{locationId}/rooms/{roomId}
     * @secure
     */
    deleteRoom: (locationId: string, roomId: string, params: RequestParams = {}) =>
      this.request<DeleteRoomResponse, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the Modes of a Location from a user's account.
     *
     * @tags Modes
     * @name GetModes
     * @summary Get the Modes of a Location.
     * @request GET:/locations/{locationId}/modes
     * @secure
     */
    getModes: (locationId: string, params: RequestParams = {}) =>
      this.request<ModesResponse, ErrorResponse>({
        path: `/locations/${locationId}/modes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Mode for a location.
     *
     * @tags Modes
     * @name CreateMode
     * @summary Create a Mode.
     * @request POST:/locations/{locationId}/modes
     * @secure
     */
    createMode: (locationId: string, createModeRequest: CreateModeRequest, params: RequestParams = {}) =>
      this.request<CreateModeResponse, ErrorResponse>({
        path: `/locations/${locationId}/modes`,
        method: 'POST',
        body: createModeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific Mode from a Location.
     *
     * @tags Modes
     * @name GetMode
     * @summary Get a Mode.
     * @request GET:/locations/{locationId}/modes/{modeId}
     * @secure
     */
    getMode: (locationId: string, modeId: string, params: RequestParams = {}) =>
      this.request<Mode, ErrorResponse>({
        path: `/locations/${locationId}/modes/${modeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Mode if no automations are affected. Otherwise, return the list of affected automations in a 409 response. When making a request with a valid `requestId` query parameter, the Mode will be deleted.
     *
     * @tags Modes
     * @name DeleteMode
     * @summary Delete a Mode.
     * @request DELETE:/locations/{locationId}/modes/{modeId}
     * @secure
     */
    deleteMode: ({ locationId, modeId, ...query }: DeleteModeParams, params: RequestParams = {}) =>
      this.request<DeleteModeResponse, ErrorResponse>({
        path: `/locations/${locationId}/modes/${modeId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Mode.
     *
     * @tags Modes
     * @name UpdateMode
     * @summary Update a Mode
     * @request PUT:/locations/{locationId}/modes/{modeId}
     * @secure
     */
    updateMode: (
      locationId: string,
      modeId: string,
      updateModeRequest: UpdateModeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateModeResponse, ErrorResponse>({
        path: `/locations/${locationId}/modes/${modeId}`,
        method: 'PUT',
        body: updateModeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get current Mode of a Location.
     *
     * @tags Modes
     * @name GetCurrentMode
     * @summary Get the current Location Mode.
     * @request GET:/locations/{locationId}/modes/current
     * @secure
     */
    getCurrentMode: (locationId: string, params: RequestParams = {}) =>
      this.request<Mode, ErrorResponse>({
        path: `/locations/${locationId}/modes/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change the location's current Mode. Note: This can cause enabled automations to run if the location's Mode is an automation trigger.
     *
     * @tags Modes
     * @name ChangeMode
     * @summary Change the location's current Mode.
     * @request PUT:/locations/{locationId}/modes/current
     * @secure
     */
    changeMode: (locationId: string, changeModeRequest: ChangeModeRequest, params: RequestParams = {}) =>
      this.request<UpdateModeResponse, ErrorResponse>({
        path: `/locations/${locationId}/modes/current`,
        method: 'PUT',
        body: changeModeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  invitations = {
    /**
     * @description Create Invitations for a single, specified user.  While the request payload suggests that multiple invitees are accepted, they are not.
     *
     * @tags Invitations
     * @name CreateInvitation
     * @summary Create a Invitation.
     * @request POST:/invitations
     * @secure
     */
    createInvitation: (createInvitationRequest: CreateInvitationRequest, params: RequestParams = {}) =>
      this.request<Invitation, ErrorResponse>({
        path: `/invitations`,
        method: 'POST',
        body: createInvitationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Invitations received by the current user.
     *
     * @tags Invitations
     * @name ListInvitationsInvitee
     * @summary List Invitations for an Invitee.
     * @request GET:/invitations/invitee
     * @secure
     */
    listInvitationsInvitee: (query: ListInvitationsInviteeParams, params: RequestParams = {}) =>
      this.request<PagedInvitations, ErrorResponse>({
        path: `/invitations/invitee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Invitations sent by the current user.
     *
     * @tags Invitations
     * @name ListInvitationsInviter
     * @summary List Invitations for an Inviter.
     * @request GET:/invitations/inviter
     * @secure
     */
    listInvitationsInviter: (query: ListInvitationsInviterParams, params: RequestParams = {}) =>
      this.request<PagedInvitations, ErrorResponse>({
        path: `/invitations/inviter`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific Invitation.
     *
     * @tags Invitations
     * @name GetInvitation
     * @summary Get a Invitation.
     * @request GET:/invitations/{invitationId}
     * @secure
     */
    getInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<Invitation, ErrorResponse>({
        path: `/invitations/${invitationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Invitation.
     *
     * @tags Invitations
     * @name DeleteInvitation
     * @summary Delete a Invitation.
     * @request DELETE:/invitations/{invitationId}
     * @secure
     */
    deleteInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<DeleteInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accept a specific Invitation.
     *
     * @tags Invitations
     * @name AcceptInvitation
     * @summary Accept a Invitation.
     * @request POST:/invitations/{invitationId}/accept
     * @secure
     */
    acceptInvitation: (
      invitationId: string,
      acceptInvitationRequest: AcceptInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<AcceptInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}/accept`,
        method: 'POST',
        body: acceptInvitationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reject a specific Invitation.
     *
     * @tags Invitations
     * @name RejectInvitation
     * @summary Rejects a Invitation.
     * @request DELETE:/invitations/{invitationId}/reject
     */
    rejectInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<RejectInvitationResponse, ErrorResponse>({
        path: `/invitations/${invitationId}/reject`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  installedapps = {
    /**
     * @description Create an Installed App.  Optionally, configuration may be sent with request along with a configuration status.  This allows caller to create and mark install as 'DONE' in a single call. A single user account is allowed to contain a maximum of 1000 installs.  Upon hitting that limit a 422 error response is returned with an error code of LimitError.
     *
     * @tags installedapps
     * @name CreateInstallation
     * @summary Create an installed app.
     * @request POST:/installedapps
     * @secure
     */
    createInstallation: (createInstalledAppRequest: CreateInstalledAppRequest, params: RequestParams = {}) =>
      this.request<InstalledAppComposite, ErrorResponse>({
        path: `/installedapps`,
        method: 'POST',
        body: createInstalledAppRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all installed applications within the specified locations. If no locations are provided, then list all installed apps accessible by the principle.
     *
     * @tags Installedapps
     * @name ListInstallations
     * @summary List Installed Apps
     * @request GET:/installedapps
     * @secure
     */
    listInstallations: (query: ListInstallationsParams, params: RequestParams = {}) =>
      this.request<PagedInstalledApps, ErrorResponse>({
        path: `/installedapps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Token Information of an Installedapp Principal.
     *
     * @tags installedapps
     * @name Me
     * @summary Get Token Information
     * @request GET:/installedapps/me
     * @secure
     */
    me: (params: RequestParams = {}) =>
      this.request<InstalledAppMeResponse, ErrorResponse>({
        path: `/installedapps/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a single installed application.
     *
     * @tags Installedapps
     * @name GetInstallation
     * @summary Get an Installed App
     * @request GET:/installedapps/{installedAppId}
     * @secure
     */
    getInstallation: ({ installedAppId, ...query }: GetInstallationParams, params: RequestParams = {}) =>
      this.request<InstalledApp, ErrorResponse>({
        path: `/installedapps/${installedAppId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an Installed App.
     *
     * @tags Installedapps
     * @name UpdateInstallation
     * @summary Update an Installed App
     * @request PUT:/installedapps/{installedAppId}
     * @secure
     */
    updateInstallation: (
      installedAppId: string,
      updateInstalledAppRequest: UpdateInstalledAppRequest,
      params: RequestParams = {},
    ) =>
      this.request<InstalledApp, ErrorResponse>({
        path: `/installedapps/${installedAppId}`,
        method: 'PUT',
        body: updateInstalledAppRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an installed app.
     *
     * @tags Installedapps
     * @name DeleteInstallation
     * @summary Delete an Installed App
     * @request DELETE:/installedapps/{installedAppId}
     * @secure
     */
    deleteInstallation: (installedAppId: string, params: RequestParams = {}) =>
      this.request<DeleteInstalledAppResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Assert the Installed App is owned by the token.
     *
     * @tags Installedapps
     * @name AssertInstallationOwner
     * @summary Assert ownership of an installed app.
     * @request HEAD:/installedapps/{installedAppId}
     * @secure
     */
    assertInstallationOwner: (installedAppId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/installedapps/${installedAppId}`,
        method: 'HEAD',
        secure: true,
        ...params,
      }),

    /**
     * @description List all configurations potentially filtered by status for an installed app.
     *
     * @tags Installedapps
     * @name ListInstallationConfig
     * @summary List an Installed App's Configurations
     * @request GET:/installedapps/{installedAppId}/configs
     * @secure
     */
    listInstallationConfig: ({ installedAppId, ...query }: ListInstallationConfigParams, params: RequestParams = {}) =>
      this.request<PagedInstallConfigurations, ErrorResponse>({
        path: `/installedapps/${installedAppId}/configs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an Installed App configuration.  Call implicitly operates on the latest 'STAGED' configuration.
     *
     * @tags Installedapps
     * @name UpdateInstallationConfig
     * @summary Update an installed app configuration.
     * @request PUT:/installedapps/{installedAppId}/configs
     * @secure
     */
    updateInstallationConfig: (
      installedAppId: string,
      updateInstallConfigurationRequest: UpdateInstallConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<InstallConfigurationDetail, ErrorResponse>({
        path: `/installedapps/${installedAppId}/configs`,
        method: 'PUT',
        body: updateInstallConfigurationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a detailed install configuration model containing actual config entries / values.
     *
     * @tags Installedapps
     * @name GetInstallationConfig
     * @summary Get an Installed App Configuration
     * @request GET:/installedapps/{installedAppId}/configs/{configurationId}
     * @secure
     */
    getInstallationConfig: (installedAppId: string, configurationId: string, params: RequestParams = {}) =>
      this.request<InstallConfigurationDetail, ErrorResponse>({
        path: `/installedapps/${installedAppId}/configs/${configurationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Allows specific configuration keys to be removed / upserted from any configuration that may already exist. This operation is only supported on install configurations in status of 'STAGED'.  Useful for iteratively configuring an installed app.
     *
     * @tags Installedapps
     * @name PatchInstallationConfig
     * @summary Partial update an installed app configuration.
     * @request PATCH:/installedapps/{installedAppId}/configs/{configurationId}
     * @secure
     */
    patchInstallationConfig: (
      installedAppId: string,
      configurationId: string,
      patchInstalledAppRequest: PatchInstalledAppRequest,
      params: RequestParams = {},
    ) =>
      this.request<InstallConfigurationDetail, ErrorResponse>({
        path: `/installedapps/${installedAppId}/configs/${configurationId}`,
        method: 'PATCH',
        body: patchInstalledAppRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get an installed app's tags.
     *
     * @tags Installedapps
     * @name GetInstalledAppTags
     * @summary Get an installed app's tags
     * @request GET:/installedapps/{installedAppId}/tags
     * @secure
     */
    getInstalledAppTags: (installedAppId: string, params: RequestParams = {}) =>
      this.request<GetTagsResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/tags`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an installed app's tags.  In addition to the general tagging restrictions, the prefix of `app:` is reserved for this API.
     *
     * @tags Installedapps
     * @name UpdateInstalledAppTags
     * @summary Update an installed app's tags
     * @request PUT:/installedapps/{installedAppId}/tags
     * @secure
     */
    updateInstalledAppTags: (
      installedAppId: string,
      updateInstalledAppTagsRequest: UpdateTagsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTagsResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/tags`,
        method: 'PUT',
        body: updateInstalledAppTagsRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Patch an installed app's tags.  In addition to the general tagging restrictions, the prefix of `app:` is reserved for this API.
     *
     * @tags Installedapps
     * @name PatchInstalledAppTags
     * @summary Patch an installed app's tags
     * @request PATCH:/installedapps/{installedAppId}/tags
     * @secure
     */
    patchInstalledAppTags: (
      installedAppId: string,
      patchInstalledAppTagsRequest: PatchTagsRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatchTagsResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/tags`,
        method: 'PATCH',
        body: patchInstalledAppTagsRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for an installed app.  This allows Apps to create events to trigger custom behavior in installed apps. Requires a SmartApp token.
     *
     * @tags Installedapps
     * @name CreateInstalledAppEvents
     * @summary Create Installed App Events
     * @request POST:/installedapps/{installedAppId}/events
     * @secure
     */
    createInstalledAppEvents: (
      installedAppId: string,
      createInstalledAppEventsRequest: CreateInstalledAppEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateInstalledAppEventsResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/events`,
        method: 'POST',
        body: createInstalledAppEventsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send a message to a message group.
     *
     * @tags installedapps
     * @name SendInstalledAppMessage
     * @summary Send a message to a message grouping.
     * @request POST:/installedapps/{installedAppId}/send-message
     * @secure
     */
    sendInstalledAppMessage: (
      installedAppId: string,
      sendInstalledAppMessageRequest: SendInstalledAppMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<SendInstalledAppMessageResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/send-message`,
        method: 'POST',
        body: sendInstalledAppMessageRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List the subscriptions for the installed app.
     *
     * @tags Subscriptions
     * @name ListSubscriptions
     * @summary List an Installed App's Subscriptions
     * @request GET:/installedapps/{installedAppId}/subscriptions
     */
    listSubscriptions: (installedAppId: string, params: RequestParams = {}) =>
      this.request<PagedSubscriptions, ErrorResponse>({
        path: `/installedapps/${installedAppId}/subscriptions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a subscription to a type of event from the specified source. Both the source and the installed app must be in the location specified and the installed app must have read access to the event being subscribed to. An installed app is only permitted to created 20 subscriptions. ### Authorization scopes For installed app principal: * installed app id matches the incoming request installed app id location must match the installed app location | Subscription Type  | Scope required                                                                         | | ------------------ | ---------------------------------------------------------------------------------------| | DEVICE             | `r:devices:$deviceId`                                                                  | | CAPABILITY         | `r:devices:*:*:$capability` or `r:devices:*`,                                          | | MODE               | `r:locations:$locationId` or `r:locations:*`                                           | | DEVICE_LIFECYCLE   | `r:devices:$deviceId` or `r:devices:*`                                                 | | DEVICE_HEALTH      | `r:devices:$deviceId` or `r:devices:*`                                                 | | SECURITY_ARM_STATE | `r:security:locations:$locationId:armstate` or `r:security:locations:*:armstate`       | | HUB_HEALTH         | `r:hubs`                                                                               | | SCENE_LIFECYCLE    | `r:scenes:*`                                                                           |
     *
     * @tags Subscriptions
     * @name SaveSubscription
     * @summary Create a Subscription for an Installed App
     * @request POST:/installedapps/{installedAppId}/subscriptions
     * @secure
     */
    saveSubscription: (installedAppId: string, request: SubscriptionRequest, params: RequestParams = {}) =>
      this.request<Subscription, ErrorResponse>({
        path: `/installedapps/${installedAppId}/subscriptions`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all subscriptions for the installed app.
     *
     * @tags Subscriptions
     * @name DeleteAllSubscriptions
     * @summary Delete All of an Installed App's Subscriptions
     * @request DELETE:/installedapps/{installedAppId}/subscriptions
     */
    deleteAllSubscriptions: ({ installedAppId, ...query }: DeleteAllSubscriptionsParams, params: RequestParams = {}) =>
      this.request<SubscriptionDelete, ErrorResponse>({
        path: `/installedapps/${installedAppId}/subscriptions`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific subscription for the installed app.
     *
     * @tags Subscriptions
     * @name GetSubscription
     * @summary Get an Installed App's Subscription
     * @request GET:/installedapps/{installedAppId}/subscriptions/{subscriptionId}
     */
    getSubscription: (installedAppId: string, subscriptionId: string, params: RequestParams = {}) =>
      this.request<Subscription, ErrorResponse>({
        path: `/installedapps/${installedAppId}/subscriptions/${subscriptionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a specific subscription for the installed app.
     *
     * @tags Subscriptions
     * @name DeleteSubscription
     * @summary Delete an Installed App's Subscription
     * @request DELETE:/installedapps/{installedAppId}/subscriptions/{subscriptionId}
     */
    deleteSubscription: (installedAppId: string, subscriptionId: string, params: RequestParams = {}) =>
      this.request<SubscriptionDelete, ErrorResponse>({
        path: `/installedapps/${installedAppId}/subscriptions/${subscriptionId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description List the schedules for the installed app.
     *
     * @tags Schedules
     * @name GetSchedules
     * @summary List Installed App Schedules
     * @request GET:/installedapps/{installedAppId}/schedules
     * @secure
     */
    getSchedules: (installedAppId: string, params: RequestParams = {}) =>
      this.request<PagedSchedules, ErrorResponse>({
        path: `/installedapps/${installedAppId}/schedules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a schedule for an installed app. The installed app must be in the location specified and the installed app must have permission to create schedules.
     *
     * @tags Schedules
     * @name CreateSchedule
     * @summary Save an Installed App Schedule
     * @request POST:/installedapps/{installedAppId}/schedules
     * @secure
     */
    createSchedule: (installedAppId: string, request: ScheduleRequest, params: RequestParams = {}) =>
      this.request<Schedule, ErrorResponse>({
        path: `/installedapps/${installedAppId}/schedules`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all schedules for the installed app.
     *
     * @tags Schedules
     * @name DeleteSchedules
     * @summary Delete All of an Installed App's Schedules
     * @request DELETE:/installedapps/{installedAppId}/schedules
     * @secure
     */
    deleteSchedules: (installedAppId: string, params: RequestParams = {}) =>
      this.request<DeleteScheduleResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/schedules`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific schedule for the installed app.
     *
     * @tags Schedules
     * @name GetSchedule
     * @summary Get an Installed App's Schedule
     * @request GET:/installedapps/{installedAppId}/schedules/{scheduleName}
     * @secure
     */
    getSchedule: (installedAppId: string, scheduleName: string, params: RequestParams = {}) =>
      this.request<Schedule, ErrorResponse>({
        path: `/installedapps/${installedAppId}/schedules/${scheduleName}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a specific schedule for the installed app.
     *
     * @tags Schedules
     * @name DeleteSchedule
     * @summary Delete a Schedule
     * @request DELETE:/installedapps/{installedAppId}/schedules/{scheduleName}
     * @secure
     */
    deleteSchedule: (installedAppId: string, scheduleName: string, params: RequestParams = {}) =>
      this.request<DeleteScheduleResponse, ErrorResponse>({
        path: `/installedapps/${installedAppId}/schedules/${scheduleName}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  subscriptions = {
    /**
     * @description The subscription created is initially in an inactive state.  The response body contains a "registrationUrl" which should be followed to activate and begin receiving SSE events. The OAuth scopes needed to make this call vary depending on the types of subscriptions you'd like to create.
     *
     * @tags sse
     * @name PostSubscription
     * @summary Create a subscription
     * @request POST:/subscriptions
     * @secure
     */
    postSubscription: (subscription: CreateSubscriptionRequest, params: RequestParams = {}) =>
      this.request<CreateSubscriptionResponse, ErrorResponse>({
        path: `/subscriptions`,
        method: 'POST',
        body: subscription,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description No specific OAuth scopes are required for this API.  You simply need to be the same principal that created the subscription.
     *
     * @tags sse
     * @name GetSubscription
     * @summary Get a subscription
     * @request GET:/subscriptions/{subscriptionId}
     * @secure
     */
    getSubscription: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<GetSubscriptionResponse, ErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a subscription. Subscription cannot be updated unless it has been activated. A subscription is activated when a connection is established via the registrationUrl provided in the Create call. The OAuth scopes needed to make this call vary depending on the types of subscriptions you'd like to create.
     *
     * @tags sse
     * @name UpdateSubscription
     * @summary Update a subscription
     * @request PUT:/subscriptions/{subscriptionId}
     * @secure
     */
    updateSubscription: (
      subscriptionId: string,
      subscription: UpdateSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionResponse, ErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'PUT',
        body: subscription,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description No specific OAuth scopes are required for this API.  You simply need to be the same principal that created the subscription.
     *
     * @tags sse
     * @name DeleteSubscription
     * @summary Delete a subscription
     * @request DELETE:/subscriptions/{subscriptionId}
     * @secure
     */
    deleteSubscription: (subscriptionId: string, params: RequestParams = {}) =>
      this.request<DeleteSubscriptionResponse, ErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'DELETE',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags subscriptions
     * @name PostRegister
     * @summary (Private) Register an inactive subscription
     * @request POST:/subscriptions/{subscriptionId}/register
     * @secure
     */
    postRegister: (
      subscriptionId: string,
      subscriptionTarget: RegisterSubscriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<RegisterSubscriptionResponse, ErrorResponse>({
        path: `/subscriptions/${subscriptionId}/register`,
        method: 'POST',
        body: subscriptionTarget,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  apps = {
    /**
     * @description A single developer account is allowed to contain a maximum of 100 apps.  Upon hitting that limit, a 422 error response is returned with an error code of LimitError.
     *
     * @tags Apps
     * @name CreateApp
     * @summary Create an App
     * @request POST:/apps
     * @secure
     */
    createApp: (query: CreateAppParams, createOrUpdateAppRequest: CreateAppRequest, params: RequestParams = {}) =>
      this.request<CreateAppResponse, ErrorResponse>({
        path: `/apps`,
        method: 'POST',
        query: query,
        body: createOrUpdateAppRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all apps configured in an account.
     *
     * @tags Apps
     * @name ListApps
     * @summary List All Apps
     * @request GET:/apps
     * @secure
     */
    listApps: (query: ListAppsParams, params: RequestParams = {}) =>
      this.request<PagedApps, ErrorResponse>({
        path: `/apps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single app.
     *
     * @tags Apps
     * @name GetApp
     * @summary Get an App
     * @request GET:/apps/{appNameOrId}
     * @secure
     */
    getApp: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<App, ErrorResponse>({
        path: `/apps/${appNameOrId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an app.
     *
     * @tags Apps
     * @name UpdateApp
     * @summary Update an App
     * @request PUT:/apps/{appNameOrId}
     * @secure
     */
    updateApp: (
      { appNameOrId, ...query }: UpdateAppParams,
      updateAppRequest: UpdateAppRequest,
      params: RequestParams = {},
    ) =>
      this.request<App, ErrorResponse>({
        path: `/apps/${appNameOrId}`,
        method: 'PUT',
        query: query,
        body: updateAppRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an app.
     *
     * @tags Apps
     * @name DeleteApp
     * @summary Delete an App
     * @request DELETE:/apps/{appNameOrId}
     * @secure
     */
    deleteApp: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<DeleteAppResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the settings for an app.
     *
     * @tags Apps
     * @name GetAppSettings
     * @summary Get an App's Settings
     * @request GET:/apps/{appNameOrId}/settings
     * @secure
     */
    getAppSettings: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<GetAppSettingsResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the settings for an app.
     *
     * @tags Apps
     * @name UpdateAppSettings
     * @summary Update an App's Settings
     * @request PUT:/apps/{appNameOrId}/settings
     * @secure
     */
    updateAppSettings: (
      appNameOrId: string,
      updateAppSettingsRequest: UpdateAppSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAppSettingsResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/settings`,
        method: 'PUT',
        body: updateAppSettingsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve an app's oauth settings.
     *
     * @tags Apps
     * @name GetAppOauth
     * @summary Get an App's OAuth Settings
     * @request GET:/apps/{appNameOrId}/oauth
     * @secure
     */
    getAppOauth: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<AppOAuth, ErrorResponse>({
        path: `/apps/${appNameOrId}/oauth`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an app's oauth settings.
     *
     * @tags Apps
     * @name UpdateAppOauth
     * @summary Update an App's OAuth Settings
     * @request PUT:/apps/{appNameOrId}/oauth
     * @secure
     */
    updateAppOauth: (appNameOrId: string, updateAppOAuthRequest: UpdateAppOAuthRequest, params: RequestParams = {}) =>
      this.request<AppOAuth, ErrorResponse>({
        path: `/apps/${appNameOrId}/oauth`,
        method: 'PUT',
        body: updateAppOAuthRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description When an app is first created, an OAuth client/secret are automatically generated for the integration.  However, there are times when it may be useful to re-generate a client/secret such as in cases where a secret becomes compromised.
     *
     * @tags Apps
     * @name GenerateAppOauth
     * @summary Generate an App's OAuth Client/Secret
     * @request POST:/apps/{appNameOrId}/oauth/generate
     * @secure
     */
    generateAppOauth: (
      appNameOrId: string,
      generateAppOAuthRequest: GenerateAppOAuthRequest,
      params: RequestParams = {},
    ) =>
      this.request<GenerateAppOAuthResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/oauth/generate`,
        method: 'POST',
        body: generateAppOAuthRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get an app's tags.
     *
     * @tags Apps
     * @name GetAppTags
     * @summary Get an app's tags
     * @request GET:/apps/{appNameOrId}/tags
     * @secure
     */
    getAppTags: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<GetTagsResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/tags`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an app's tags.
     *
     * @tags Apps
     * @name UpdateAppTags
     * @summary Update an app's tags
     * @request PUT:/apps/{appNameOrId}/tags
     * @secure
     */
    updateAppTags: (appNameOrId: string, updateAppTagsRequest: UpdateTagsRequest, params: RequestParams = {}) =>
      this.request<UpdateTagsResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/tags`,
        method: 'PUT',
        body: updateAppTagsRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Patch an app's tags.
     *
     * @tags Apps
     * @name PatchAppTags
     * @summary Patch an app's tags
     * @request PATCH:/apps/{appNameOrId}/tags
     * @secure
     */
    patchAppTags: (appNameOrId: string, patchAppTagsRequest: PatchTagsRequest, params: RequestParams = {}) =>
      this.request<PatchTagsResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/tags`,
        method: 'PATCH',
        body: patchAppTagsRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prepare to register an App by sending the endpoint a confirmation message.
     *
     * @tags Apps
     * @name Register
     * @summary Send a Confirmation Request to an App
     * @request PUT:/apps/{appNameOrId}/register
     * @secure
     */
    register: (appNameOrId: string, appRegisterRequest: AppRegisterRequest, params: RequestParams = {}) =>
      this.request<AppRegisterResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/register`,
        method: 'PUT',
        body: appRegisterRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates the signature type of an App.  Signature options: * APP_RSA - Legacy signing mechanism comprised of a public / private key generated for an App during registration.  This mechanism requires an App to download the public key and deploy along side their integration to verify the signature in the authorization header. * ST_PADLOCK - App callbacks are signed with a SmartThings certificate which is publicly available at https://key.smartthings.com.  App's authorize callbacks by fetching the certificate over HTTPS and using it to validate the signature in the authorization header. When upgrading an App from APP_RSA to ST_PADLOCK, it is recommended to implement both verification methods. This will provide the ability to seamlessly switch between mechanisms if a rollback is needed.
     *
     * @tags Apps
     * @name UpdateSignatureType
     * @summary Update an App's Signature Type
     * @request PUT:/apps/{appNameOrId}/signature-type
     * @secure
     */
    updateSignatureType: (
      appNameOrId: string,
      updateSignatureTypeRequest: UpdateSignatureTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSignatureTypeResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/signature-type`,
        method: 'PUT',
        body: updateSignatureTypeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List message templates for an App.
     *
     * @tags message-templates
     * @name ListMessageTemplates
     * @summary List message templates for an App.
     * @request GET:/apps/{appNameOrId}/message-templates
     * @secure
     */
    listMessageTemplates: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<PagedMessageTemplates, ErrorResponse>({
        path: `/apps/${appNameOrId}/message-templates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete message templates for an App.
     *
     * @tags message-templates
     * @name DeleteMessageTemplates
     * @summary Delete message templates for an App.
     * @request DELETE:/apps/{appNameOrId}/message-templates
     * @secure
     */
    deleteMessageTemplates: (appNameOrId: string, params: RequestParams = {}) =>
      this.request<DeleteMessageTemplatesResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/message-templates`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a message template.
     *
     * @tags message-templates
     * @name GetMessageTemplate
     * @summary Get a message template definition for an App.
     * @request GET:/apps/{appNameOrId}/message-templates/{messageTemplateKey}
     * @secure
     */
    getMessageTemplate: (appNameOrId: string, messageTemplateKey: string, params: RequestParams = {}) =>
      this.request<GetMessageTemplateResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/message-templates/${messageTemplateKey}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a message template.
     *
     * @tags message-templates
     * @name DeleteMessageTemplate
     * @summary Delete a message template definition for an App.
     * @request DELETE:/apps/{appNameOrId}/message-templates/{messageTemplateKey}
     * @secure
     */
    deleteMessageTemplate: (appNameOrId: string, messageTemplateKey: string, params: RequestParams = {}) =>
      this.request<DeleteMessageTemplateResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/message-templates/${messageTemplateKey}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates / updates a message template.
     *
     * @tags message-templates
     * @name UpsertMessageTemplate
     * @summary Upsert a message template definition for an App.
     * @request PUT:/apps/{appNameOrId}/message-templates/{messageTemplateKey}
     * @secure
     */
    upsertMessageTemplate: (
      appNameOrId: string,
      messageTemplateKey: string,
      upsertMessageTemplateRequest: UpsertMessageTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpsertMessageTemplateResponse, ErrorResponse>({
        path: `/apps/${appNameOrId}/message-templates/${messageTemplateKey}`,
        method: 'PUT',
        body: upsertMessageTemplateRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  rules = {
    /**
     * @description Return a list of Rules contained in a specified location.
     *
     * @tags Rules
     * @name ListRules
     * @summary List Rules
     * @request GET:/rules
     * @secure
     */
    listRules: (query: ListRulesParams, params: RequestParams = {}) =>
      this.request<PagedRules, void | Error>({
        path: `/rules`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Rule for a specified location and user.
     *
     * @tags Rules
     * @name CreateRule
     * @summary Create a Rule
     * @request POST:/rules
     * @secure
     */
    createRule: (query: CreateRuleParams, request: RuleRequest, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all rules in a location
     *
     * @tags rules
     * @name DeleteAllRules
     * @summary Delete all rules
     * @request DELETE:/rules
     * @secure
     */
    deleteAllRules: (query: DeleteAllRulesParams, params: RequestParams = {}) =>
      this.request<void, void | Error>({
        path: `/rules`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Return the logic of a Rule based on the specified Rule ID, location, and user.
     *
     * @tags Rules
     * @name GetRule
     * @summary Get a Rule
     * @request GET:/rules/{ruleId}
     * @secure
     */
    getRule: ({ ruleId, ...query }: GetRuleParams, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the logic and action of a specified Rule.
     *
     * @tags Rules
     * @name UpdateRule
     * @summary Update a Rule
     * @request PUT:/rules/{ruleId}
     * @secure
     */
    updateRule: ({ ruleId, ...query }: UpdateRuleParams, request: RuleRequest, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'PUT',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Rule from a user's SmartThings account.
     *
     * @tags Rules
     * @name DeleteRule
     * @summary Delete a Rule
     * @request DELETE:/rules/{ruleId}
     * @secure
     */
    deleteRule: ({ ruleId, ...query }: DeleteRuleParams, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Trigger Rule execution for a specified user.
     *
     * @tags Rules
     * @name ExecuteRule
     * @summary Execute a Rule
     * @request POST:/rules/execute/{ruleId}
     * @secure
     */
    executeRule: ({ ruleId, ...query }: ExecuteRuleParams, params: RequestParams = {}) =>
      this.request<RuleExecutionResponse, void | Error>({
        path: `/rules/execute/${ruleId}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  scenes = {
    /**
     * @description Get a list of Scenes for a specified user. If no locationId is sent, all scenes for all available locations will be returned.
     *
     * @tags Scenes
     * @name ListScenes
     * @summary List Scenes
     * @request GET:/scenes
     * @secure
     */
    listScenes: (query: ListScenesParams, params: RequestParams = {}) =>
      this.request<ScenePagedResult, ErrorResponse>({
        path: `/scenes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a Scene based on a sceneId.
     *
     * @tags Scenes
     * @name ExecuteScene
     * @summary Execute a Scene
     * @request POST:/scenes/{sceneId}/execute
     * @secure
     */
    executeScene: ({ sceneId, ...query }: ExecuteSceneParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/scenes/${sceneId}/execute`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicepreferences = {
    /**
     * @description List all preferences available for a user.
     *
     * @tags Preferences
     * @name ListPreferences
     * @summary List all Preferences
     * @request GET:/devicepreferences
     * @secure
     */
    listPreferences: (query: ListPreferencesParams, params: RequestParams = {}) =>
      this.request<PagedPreferences, ErrorResponse>({
        path: `/devicepreferences`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a preference.
     *
     * @tags Preferences
     * @name CreatePreference
     * @summary Create a Preference
     * @request POST:/devicepreferences
     * @secure
     */
    createPreference: (createPreferenceRequest: PreferenceRequest, params: RequestParams = {}) =>
      this.request<PreferenceResponse, ErrorResponse>({
        path: `/devicepreferences`,
        method: 'POST',
        body: createPreferenceRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a preference by preference ID.
     *
     * @tags Preferences
     * @name GetPreferenceById
     * @summary Get Preference by ID
     * @request GET:/devicepreferences/{preferenceId}
     * @secure
     */
    getPreferenceById: (preferenceId: string, params: RequestParams = {}) =>
      this.request<PreferenceResponse, ErrorResponse>({
        path: `/devicepreferences/${preferenceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a preference by preference ID.
     *
     * @tags Preferences
     * @name UpdatePreferenceById
     * @summary Update Preference by ID
     * @request PUT:/devicepreferences/{preferenceId}
     * @secure
     */
    updatePreferenceById: (
      preferenceId: string,
      updatePreferenceRequest: PreferenceRequest,
      params: RequestParams = {},
    ) =>
      this.request<PreferenceResponse, ErrorResponse>({
        path: `/devicepreferences/${preferenceId}`,
        method: 'PUT',
        body: updatePreferenceRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a preference by preference ID.
     *
     * @tags Preferences
     * @name DeletePreferenceById
     * @summary Delete Preference by ID
     * @request DELETE:/devicepreferences/{preferenceId}
     * @secure
     */
    deletePreferenceById: (preferenceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/devicepreferences/${preferenceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  preferences = {
    /**
     * @description List all languages (i.e. locales) for which a Preference has translated values. The `locale` is the abbreviated internationalization code associated with the language.
     *
     * @tags Preferences
     * @name ListPreferenceLocalizations
     * @summary List a Preference's Localizations
     * @request GET:/preferences/{preferenceId}/i18n
     * @secure
     */
    listPreferenceLocalizations: (preferenceId: string, params: RequestParams = {}) =>
      this.request<PreferenceLocaleLocalizations, ErrorResponse>({
        path: `/preferences/${preferenceId}/i18n`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add translated values in a desired language (i.e. locale) for a Preference. The `locale` is the abbreviated internationalization code associated with the language for which values will be stored. Translated values can include: preference title, description, and enumeration option labels.
     *
     * @tags Preferences
     * @name CreatePreferenceLocalization
     * @summary Create a Preference Localization for a Locale
     * @request POST:/preferences/{preferenceId}/i18n
     * @secure
     */
    createPreferenceLocalization: (
      preferenceId: string,
      preferenceLocalization: PreferenceLocalization,
      params: RequestParams = {},
    ) =>
      this.request<PreferenceLocalization, ErrorResponse>({
        path: `/preferences/${preferenceId}/i18n`,
        method: 'POST',
        body: preferenceLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve translated values in a desired language (i.e. locale) for a Preference. The `locale` is the abbreviated internationalization code associated with the language.
     *
     * @tags Preferences
     * @name GetPreferenceLocalization
     * @summary Get a Preference Localization by Locale
     * @request GET:/preferences/{preferenceId}/i18n/{locale}
     * @secure
     */
    getPreferenceLocalization: (preferenceId: string, locale: string, params: RequestParams = {}) =>
      this.request<PreferenceLocalization, ErrorResponse>({
        path: `/preferences/${preferenceId}/i18n/${locale}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update existing translated values in a desired language (i.e. locale) for a Preference. The `locale` is the abbreviated internationalization code associated with the language for which values will be updated.<br/><br/> If the `tag` argument is provided in the request body, it will be ignored.
     *
     * @tags Preferences
     * @name UpdatePreferenceLocalization
     * @summary Update a Preference Localization for a Locale
     * @request PUT:/preferences/{preferenceId}/i18n/{locale}
     * @secure
     */
    updatePreferenceLocalization: (
      preferenceId: string,
      locale: string,
      preferenceLocalization: PreferenceLocalization,
      params: RequestParams = {},
    ) =>
      this.request<PreferenceLocalization, ErrorResponse>({
        path: `/preferences/${preferenceId}/i18n/${locale}`,
        method: 'PUT',
        body: preferenceLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Modify specific values of existing language (i.e. locale) translations for a Preference. The `locale` is the abbreviated internationalization code associated with the language for which values will be updated.<br/><br/> All fields in the request body are optional. Any fields populated will replace existing localization values. Any fields left blank will fall back to existing values.
     *
     * @tags Preferences
     * @name PatchPreferenceLocalization
     * @summary Patch a Preference Localization for a Locale
     * @request PATCH:/preferences/{preferenceId}/i18n/{locale}
     * @secure
     */
    patchPreferenceLocalization: (
      preferenceId: string,
      locale: string,
      preferenceLocalization: PreferenceLocalization,
      params: RequestParams = {},
    ) =>
      this.request<PreferenceLocalization, ErrorResponse>({
        path: `/preferences/${preferenceId}/i18n/${locale}`,
        method: 'PATCH',
        body: preferenceLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  capabilities = {
    /**
     * @description List all standard Capabilities.
     *
     * @tags Capabilities
     * @name ListCapabilities
     * @summary List all Capabilities
     * @request GET:/capabilities
     * @secure
     */
    listCapabilities: (params: RequestParams = {}) =>
      this.request<PagedCapabilities, ErrorResponse>({
        path: `/capabilities`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Capability.
     *
     * @tags Capabilities
     * @name CreateCapability
     * @summary Create a Capability
     * @request POST:/capabilities
     * @secure
     */
    createCapability: (
      query: CreateCapabilityParams,
      capabilityRequest: CreateCapabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<Capability, ErrorResponse>({
        path: `/capabilities`,
        method: 'POST',
        query: query,
        body: capabilityRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List a Capability's versions.
     *
     * @tags Capabilities
     * @name ListCapabilityVersions
     * @summary List a Capability's Versions
     * @request GET:/capabilities/{capabilityId}
     * @secure
     */
    listCapabilityVersions: (capabilityId: string, params: RequestParams = {}) =>
      this.request<PagedCapabilities, ErrorResponse>({
        path: `/capabilities/${capabilityId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Capability with a given ID and version.
     *
     * @tags Capabilities
     * @name GetCapability
     * @summary Get a Capability by ID and Version
     * @request GET:/capabilities/{capabilityId}/{capabilityVersion}
     * @secure
     */
    getCapability: (capabilityId: string, capabilityVersion: number, params: RequestParams = {}) =>
      this.request<Capability, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Capability. Capabilities with a `proposed` status can be updated at will. Capabilities with a `live`, `deprecated`, or `dead` status are immutable and can't be updated. Capability names cannot be changed.
     *
     * @tags Capabilities
     * @name UpdateCapability
     * @summary Update a Capability
     * @request PUT:/capabilities/{capabilityId}/{capabilityVersion}
     * @secure
     */
    updateCapability: (
      capabilityId: string,
      capabilityVersion: number,
      capabilityRequest: UpdateCapabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<Capability, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}`,
        method: 'PUT',
        body: capabilityRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Capability with a given ID and version. The Capability must be in `proposed` status. Once a Capability is updated to `live` status, it cannot be deleted and must be transitioned to `deprecated`.
     *
     * @tags Capabilities
     * @name DeleteCapability
     * @summary Delete a Capability by ID and Version
     * @request DELETE:/capabilities/{capabilityId}/{capabilityVersion}
     * @secure
     */
    deleteCapability: (capabilityId: string, capabilityVersion: number, params: RequestParams = {}) =>
      this.request<DeleteNamespaceResponse, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all languages (i.e. locales) for which a Capability has translated values. A `locale` is the abbreviated, internationalization code for the associated language.
     *
     * @tags Capabilities
     * @name ListCapabilityLocalizations
     * @summary List a Capability's Localizations
     * @request GET:/capabilities/{capabilityId}/{capabilityVersion}/i18n
     * @secure
     */
    listCapabilityLocalizations: (capabilityId: string, capabilityVersion: number, params: RequestParams = {}) =>
      this.request<CapabilityLocaleLocalizations, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/i18n`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add translated values in a desired language (i.e. locale) for a Capability. The `locale` is the abbreviated, internationalization code associated with the language for which values will be stored. Translated values can include: capability name labels, attribute name labels and attribute value labels.
     *
     * @tags Capabilities
     * @name CreateCapabilityLocalization
     * @summary Create a Capability Localization for a Locale
     * @request POST:/capabilities/{capabilityId}/{capabilityVersion}/i18n
     * @secure
     */
    createCapabilityLocalization: (
      capabilityId: string,
      capabilityVersion: number,
      capabilityLocalization: CapabilityLocalization,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityLocalization, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/i18n`,
        method: 'POST',
        body: capabilityLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve translated values in a desired language (i.e. locale) for a Capability. A `locale` is the abbreviated, internationalization code for the requested language.
     *
     * @tags Capabilities
     * @name GetCapabilityLocalization
     * @summary Get a Capability Localization by Locale
     * @request GET:/capabilities/{capabilityId}/{capabilityVersion}/i18n/{locale}
     * @secure
     */
    getCapabilityLocalization: (
      { capabilityId, capabilityVersion, locale, ...query }: GetCapabilityLocalizationParams,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityLocalization, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/i18n/${locale}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update existing translated values for a given language (i.e. locale) associated with a Capability. The `locale` is the abbreviated, internationalization code associated with the language for which values will be updated.<br /><br /> If the `tag` argument is provided in the request body, it will be ignored.
     *
     * @tags Capabilities
     * @name UpdateCapabilityLocalization
     * @summary Update a Capability Localization by Locale
     * @request PUT:/capabilities/{capabilityId}/{capabilityVersion}/i18n/{locale}
     * @secure
     */
    updateCapabilityLocalization: (
      { capabilityId, capabilityVersion, locale, ...query }: UpdateCapabilityLocalizationParams,
      capabilityLocalization: CapabilityLocalization,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityLocalization, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/i18n/${locale}`,
        method: 'PUT',
        query: query,
        body: capabilityLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Modify specific values of existing language (i.e. locale) translations for a Capability. The `locale` is the abbreviated, internationalization code associated with the language for which values will be modified.<br /><br /> All fields in the request body are optional. Any fields populated will replace existing localization values. Any fields left blank will fall back to existing values.
     *
     * @tags Capabilities
     * @name PatchCapabilityLocalization
     * @summary Patch a Capability Localization by Locale
     * @request PATCH:/capabilities/{capabilityId}/{capabilityVersion}/i18n/{locale}
     * @secure
     */
    patchCapabilityLocalization: (
      { capabilityId, capabilityVersion, locale, ...query }: PatchCapabilityLocalizationParams,
      capabilityLocalization: CapabilityLocalization,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityLocalization, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/i18n/${locale}`,
        method: 'PATCH',
        query: query,
        body: capabilityLocalization,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a Capability presentation. **Note:** This API functionality is in BETA
     *
     * @tags Presentations
     * @name CreateCustomCapabilityPresentation
     * @summary Create a Capability Presentation
     * @request POST:/capabilities/{capabilityId}/{capabilityVersion}/presentation
     * @secure
     */
    createCustomCapabilityPresentation: (
      capabilityId: string,
      capabilityVersion: number,
      createCustomCapabilityPresentationRequest: CreateCapabilityPresentationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityPresentation, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/presentation`,
        method: 'POST',
        body: createCustomCapabilityPresentationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Capability presentation with a given ID and version. **Note:** This API functionality is in BETA
     *
     * @tags Presentations
     * @name GetCapabilityPresentation
     * @summary Get a Capability Presentation by ID and Version
     * @request GET:/capabilities/{capabilityId}/{capabilityVersion}/presentation
     * @secure
     */
    getCapabilityPresentation: (capabilityId: string, capabilityVersion: number, params: RequestParams = {}) =>
      this.request<CapabilityPresentation, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/presentation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Capability presentation. **Note:** This API functionality is in BETA
     *
     * @tags Presentations
     * @name UpdateCustomCapabilityPresentation
     * @summary Update a Capability Presentation
     * @request PUT:/capabilities/{capabilityId}/{capabilityVersion}/presentation
     * @secure
     */
    updateCustomCapabilityPresentation: (
      capabilityId: string,
      capabilityVersion: number,
      capabilityRequestBodyForPUT: UpdateCustomCapabilityPresentationPayload,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityPresentation, ErrorResponse>({
        path: `/capabilities/${capabilityId}/${capabilityVersion}/presentation`,
        method: 'PUT',
        body: capabilityRequestBodyForPUT,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Namespaces are used to organize Capabilities created by a user. Namespaces are automatically created based on a user's token when a user creates a Capability. Any namespace associated with that user will be listed.
     *
     * @tags Namespaces
     * @name ListNamespaces
     * @summary List authenticated user's namespaces
     * @request GET:/capabilities/namespaces
     * @secure
     */
    listNamespaces: (params: RequestParams = {}) =>
      this.request<NamespaceList, ErrorResponse>({
        path: `/capabilities/namespaces`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description **DEPRECATED:** Use the POST `/capabilities` endpoint to create a capability and a uniquely named namespace will be automatically created.
     *
     * @tags Namespaces
     * @name CreateNamespace
     * @summary Create a namespace for custom Capabilities
     * @request POST:/capabilities/namespaces
     * @deprecated
     * @secure
     */
    createNamespace: (namespaceRequest: NamespaceRequest, params: RequestParams = {}) =>
      this.request<Namespace, ErrorResponse>({
        path: `/capabilities/namespaces`,
        method: 'POST',
        body: namespaceRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Capabilities by namespace. Namespaces are used to organize a user's Capabilities and provide a way to uniquely identify them. A user can retrieve all of the Capabilities under their assigned namespace by referencing it. The namespace is recognizable as the first part of a capabilityId in the format `namespace.capabilityName`.
     *
     * @tags Capabilities
     * @name ListNamespacedCapabilities
     * @summary List Capabilities by Namespace
     * @request GET:/capabilities/namespaces/{namespace}
     * @secure
     */
    listNamespacedCapabilities: (namespace: string, params: RequestParams = {}) =>
      this.request<PagedCapabilities, ErrorResponse>({
        path: `/capabilities/namespaces/${namespace}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a namespaced Capability.<br /><br /> **DEPRECATED:** Use the POST `/capabilities` endpoint to create a capability and a uniquely named namespace will be automatically created.
     *
     * @tags Capabilities
     * @name CreateNamespacedCapability
     * @summary Create a namespaced Capability
     * @request POST:/capabilities/namespaces/{namespace}
     * @deprecated
     * @secure
     */
    createNamespacedCapability: (
      namespace: string,
      capabilityRequest: CreateCapabilityRequest,
      params: RequestParams = {},
    ) =>
      this.request<Capability, ErrorResponse>({
        path: `/capabilities/namespaces/${namespace}`,
        method: 'POST',
        body: capabilityRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a namespace for custom Capabilities.<br /><br /> The namespace can only be deleted if there are no Capabilities.
     *
     * @tags Namespaces
     * @name DeleteNamespace
     * @summary Delete a custom Capability namespace
     * @request DELETE:/capabilities/namespaces/{namespace}
     * @secure
     */
    deleteNamespace: (namespace: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/capabilities/namespaces/${namespace}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a custom Capability namespace.<br /><br /> **DEPRECATED:** A unique namespace name is generated when creating a capability.
     *
     * @tags Namespaces
     * @name UpdateNamespace
     * @summary Update a custom Capability namespace
     * @request PUT:/capabilities/namespaces/{namespace}
     * @deprecated
     * @secure
     */
    updateNamespace: (namespace: string, namespaceRequest: NamespaceRequest, params: RequestParams = {}) =>
      this.request<Namespace, ErrorResponse>({
        path: `/capabilities/namespaces/${namespace}`,
        method: 'PUT',
        body: namespaceRequest,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organizations = {
    /**
     * @description Create an organization
     *
     * @tags Organizations
     * @name CreateOrganization
     * @summary Create developer organization
     * @request POST:/organizations
     * @secure
     */
    createOrganization: (request: OrganizationCreateRequest, params: RequestParams = {}) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a list of the organizations visible for a logged in user. If a service token is used, manufacturerName and/or organizationId must be specified. For a user token, these 2 query parameters are ignored. Listing will also provision a "default user organization" for a user if they do not already have one created.
     *
     * @tags Organizations
     * @name ListUserOrganizations
     * @summary List organizations
     * @request GET:/organizations
     * @secure
     */
    listUserOrganizations: (query: ListUserOrganizationsParams, params: RequestParams = {}) =>
      this.request<PagedOrganizationResponse, ErrorResponse>({
        path: `/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a single organization. Safe for external developers.
     *
     * @tags Organizations
     * @name GetOrganizationByNameOrId
     * @summary Get an organization by name or ID.
     * @request GET:/organizations/{organizationNameOrId}
     * @secure
     */
    getOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a developer organization.
     *
     * @tags Organizations
     * @name DeleteOrganizationByNameOrId
     * @summary Delete developer organization.
     * @request DELETE:/organizations/{organizationNameOrId}
     * @secure
     */
    deleteOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<DeleteResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an organization
     *
     * @tags Organizations
     * @name UpdateOrganization
     * @summary Update developer organization
     * @request PUT:/organizations/{organizationNameOrId}
     * @secure
     */
    updateOrganization: (
      organizationNameOrId: string,
      request: OrganizationUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Invite users to development organization by E-mail address or phone number.
     *
     * @tags Organizations
     * @name InviteUsers
     * @summary Invite users to organization
     * @request POST:/organizations/{organizationNameOrId}/members/invite
     * @secure
     */
    inviteUsers: (organizationNameOrId: string, request: InviteRequest, params: RequestParams = {}) =>
      this.request<InviteResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}/members/invite`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  history = {
    /**
     * @description Get a list of device activities
     *
     * @tags history
     * @name GetDevicesHistory
     * @summary Get device activities history
     * @request GET:/history/devices
     * @secure
     */
    getDevicesHistory: (query: GetDevicesHistoryParams, params: RequestParams = {}) =>
      this.request<PagedDeviceActivities, ErrorResponse>({
        path: `/history/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  schema = {
    /**
     * @description Get all SmartThings Schema Apps created under a specific Personal Access Token.
     *
     * @tags SchemaApps
     * @name GetAppsByUserToken
     * @summary Get Apps For a Given Access Token
     * @request GET:/schema/apps
     */
    getAppsByUserToken: (params: RequestParams = {}) =>
      this.request<UserIdApp, void>({
        path: `/schema/apps`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new SmartThings Schema App. When using a Personal Access Token, `userId` should not be provided in the body as this will be obtained from the access token.
     *
     * @tags SchemaApps
     * @name PostApps
     * @summary Create a Schema App
     * @request POST:/schema/apps
     */
    postApps: (SchemaAppDetails: PostEndpointApp, params: RequestParams = {}) =>
      this.request<PostReceipt, void>({
        path: `/schema/apps`,
        method: 'POST',
        body: SchemaAppDetails,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get SmartThings Schema App-related information.
     *
     * @tags SchemaApps
     * @name GetAppsByEndpointAppId
     * @summary Get Schema App Info
     * @request GET:/schema/apps/{endpointAppId}
     */
    getAppsByEndpointAppId: (endpointAppId: string, params: RequestParams = {}) =>
      this.request<EndpointApp, void>({
        path: `/schema/apps/${endpointAppId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update SmartThings Schema App-related information. When using a Personal Access Token, `userId` should not be provided in the body as this will be obtained from the access token.
     *
     * @tags SchemaApps
     * @name PutAppsByEndpointAppId
     * @summary Update Schema App Info
     * @request PUT:/schema/apps/{endpointAppId}
     */
    putAppsByEndpointAppId: (endpointAppId: string, SchemaAppDetails: EndpointApp, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/schema/apps/${endpointAppId}`,
        method: 'PUT',
        body: SchemaAppDetails,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete a SmartThings Schema App.
     *
     * @tags SchemaApps
     * @name DeleteAppsByEndpointAppId
     * @summary Delete a Schema App
     * @request DELETE:/schema/apps/{endpointAppId}
     */
    deleteAppsByEndpointAppId: (endpointAppId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/schema/apps/${endpointAppId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Get all SmartThings Schema Apps created by the specified `userId`. Using a Personal Access Token with this endpoint is the same as the `getAppsByUserToken` endpoint. If a Personal Access Token is used, `userId` must be the `samsung_account_id` that the Personal Access Token defines.
     *
     * @tags SchemaApps
     * @name GetAppsByUserId
     * @summary Get Schema Apps By userId
     * @request GET:/schema/apps/user/{userId}
     */
    getAppsByUserId: (userId: string, params: RequestParams = {}) =>
      this.request<UserIdApp, void>({
        path: `/schema/apps/user/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get devices and app related info for a given `isaId`. If relogin is not required, the pageType will be set to "loggedIn" and SmartThings will return the `isaId`, devices, `partnerName`, `appName` and icons. If relogin is needed, the pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response.
     *
     * @tags InstalledSchemaApps
     * @name GetDevicesByIsaId
     * @summary Get Devices By InstalledSchemaApp ID
     * @request GET:/schema/installedapps/{isaId}
     */
    getDevicesByIsaId: ({ isaId, ...query }: GetDevicesByIsaIdParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/schema/installedapps/${isaId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an ISA by `isaId` and delete all devices associated with the `isaId`.
     *
     * @tags InstalledSchemaApps
     * @name DeleteIsaByIsaId
     * @summary Delete an InstalledSchemaApp ID and Associated Devices
     * @request DELETE:/schema/installedapps/{isaId}
     */
    deleteIsaByIsaId: ({ isaId, ...query }: DeleteIsaByIsaIdParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/schema/installedapps/${isaId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Get installed SchemaApps for a specified `locationId`.
     *
     * @tags InstalledSchemaApps
     * @name GetIsaByLocationId
     * @summary Get InstalledSchemaApp By Location ID
     * @request GET:/schema/installedapps/location/{locationId}
     */
    getIsaByLocationId: (locationId: string, params: RequestParams = {}) =>
      this.request<LocationIsa, void>({
        path: `/schema/installedapps/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Generate new `stClientId` and `stClientSecret` for a SmartThings Schema App.
     *
     * @tags OAuth
     * @name GenerateStOauthCredentials
     * @summary Generate stClientId and stClientSecret
     * @request POST:/schema/oauth/stclient/credentials
     */
    generateStOauthCredentials: (GenerateStOauthBody: GenerateStOauthBody, params: RequestParams = {}) =>
      this.request<PostReceipt, void>({
        path: `/schema/oauth/stclient/credentials`,
        method: 'POST',
        body: GenerateStOauthBody,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  services = {
    /**
     * @description Get specified location ID information
     *
     * @tags Coordinate
     * @name GetServiceLocationInfoByLocationId
     * @request GET:/services/coordinate/locations/{locationId}
     * @secure
     */
    getServiceLocationInfoByLocationId: (locationId: string, params: RequestParams = {}) =>
      this.request<ServiceLocationInfo, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description delete a subscription by installed app ID
     *
     * @tags Coordinate
     * @name DeleteSubscriptionByIsaId
     * @request DELETE:/services/coordinate/locations/{locationId}/subscriptions
     * @secure
     */
    deleteSubscriptionByIsaId: (
      { locationId, ...query }: DeleteSubscriptionByIsaIdParams,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/subscriptions`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new subscription
     *
     * @tags Coordinate
     * @name PostSubscriptionByLocationId
     * @request POST:/services/coordinate/locations/{locationId}/subscriptions
     * @secure
     */
    postSubscriptionByLocationId: (
      locationId: string,
      ServiceSubscriptionBody: ServiceSubscriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<ServiceNewSubscription, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/subscriptions`,
        method: 'POST',
        body: ServiceSubscriptionBody,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a subscription
     *
     * @tags Coordinate
     * @name DeleteSubscriptionBySubscriptionId
     * @request DELETE:/services/coordinate/locations/{locationId}/subscriptions/{subscriptionId}
     * @secure
     */
    deleteSubscriptionBySubscriptionId: (locationId: string, subscriptionId: string, params: RequestParams = {}) =>
      this.request<ServiceDeleteSubscription, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/subscriptions/${subscriptionId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a subscription
     *
     * @tags Coordinate
     * @name PutSubscriptionBySubscriptionId
     * @request PUT:/services/coordinate/locations/{locationId}/subscriptions/{subscriptionId}
     * @secure
     */
    putSubscriptionBySubscriptionId: (
      locationId: string,
      subscriptionId: string,
      ServiceSubscriptionBody: ServiceSubscriptionBody,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/subscriptions/${subscriptionId}`,
        method: 'PUT',
        body: ServiceSubscriptionBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Gets all capability data given a location ID
     *
     * @tags Coordinate
     * @name GetCapabilityByLocationId
     * @request GET:/services/coordinate/locations/{locationId}/capabilities
     * @secure
     */
    getCapabilityByLocationId: (
      { locationId, ...query }: GetCapabilityByLocationIdParams,
      params: RequestParams = {},
    ) =>
      this.request<ServiceCapabilityData, ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/capabilities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Redirect to condent provider's alert detail link.  If no query given, coordinate of the location ID is used.  Otherwise the coordinate of geo place or subscription will be used.
     *
     * @tags Coordinate
     * @name GetAlertLinkByLocationId
     * @request GET:/services/coordinate/locations/{locationId}/link/alert
     * @secure
     */
    getAlertLinkByLocationId: ({ locationId, ...query }: GetAlertLinkByLocationIdParams, params: RequestParams = {}) =>
      this.request<any, void | ErrorResponse>({
        path: `/services/coordinate/locations/${locationId}/link/alert`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get details about options supported by the tts and playtext API
     *
     * @tags TTS
     * @name Info
     * @request GET:/services/tts/info
     * @secure
     */
    info: (params: RequestParams = {}) =>
      this.request<TTSInfo, ErrorResponse>({
        path: `/services/tts/info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Convert text to speech and return an audio URL. This audio file will be available for 7 days after creation.
     *
     * @tags TTS
     * @name Tts
     * @request POST:/services/tts
     * @secure
     */
    tts: (TTSBody: TTSBody, params: RequestParams = {}) =>
      this.request<ConvertedTTS, ErrorResponse>({
        path: `/services/tts`,
        method: 'POST',
        body: TTSBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Play text on a device which supports audioNotification
     *
     * @tags TTS
     * @name Playtext
     * @request POST:/services/tts/playtext
     * @secure
     */
    playtext: (PlaytextBody: PlaytextBody, params: RequestParams = {}) =>
      this.request<PlayedText, ErrorResponse>({
        path: `/services/tts/playtext`,
        method: 'POST',
        body: PlaytextBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  hubdevices = {
    /**
     * @description Returns the list of driver channels the hub is currently subscribed to. Currently only returns the `driver` channel type
     *
     * @tags HubDevices
     * @name ListDriverChannels
     * @summary Retrieves the list of driver channels
     * @request GET:/hubdevices/{hubDeviceId}/channels
     * @secure
     */
    listDriverChannels: ({ hubDeviceId, ...query }: ListDriverChannelsParams, params: RequestParams = {}) =>
      this.request<HubDriverChannels, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/channels`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the list of drivers currently installed on the hub
     *
     * @tags HubDevices
     * @name ListHubInstalledDrivers
     * @summary Retrieves the list of hub installed driver
     * @request GET:/hubdevices/{hubDeviceId}/drivers
     * @secure
     */
    listHubInstalledDrivers: ({ hubDeviceId, ...query }: ListHubInstalledDriversParams, params: RequestParams = {}) =>
      this.request<InstalledDrivers, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/drivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sends a discovery command down to the hubs for LAN, Zigbee, Z-Wave, and Bluetooth devices
     *
     * @tags HubDevices
     * @name DiscoveryStart
     * @summary Starts Hub Device Discovery
     * @request POST:/hubdevices/{hubDeviceId}/discovery/start
     * @secure
     */
    discoveryStart: (hubDeviceId: string, discoveryStartRequest: DiscoveryStartRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/start`,
        method: 'POST',
        body: discoveryStartRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends a stop discovery command down to the hubs
     *
     * @tags HubDevices
     * @name DiscoveryStop
     * @summary Stops Hub Device Discovery
     * @request POST:/hubdevices/{hubDeviceId}/discovery/stop
     * @secure
     */
    discoveryStop: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/stop`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Nova, Zigbee3, and ZWave S2 devices require a user submitted code as a security mechanism
     *
     * @tags HubDevices
     * @name SendHubDeviceDiscoveryCode
     * @summary Send Hub Device Discovery Code
     * @request POST:/hubdevices/{hubDeviceId}/discovery/code
     * @secure
     */
    sendHubDeviceDiscoveryCode: (
      hubDeviceId: string,
      DiscoveryCodeRequest: DiscoveryCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/code`,
        method: 'POST',
        body: DiscoveryCodeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates a hub device record (Widget Backed)
     *
     * @tags HubDevices
     * @name UpdateHubDevice
     * @summary Update Device Record For Hub Device
     * @request PATCH:/hubdevices/{hubDeviceId}/childdevice/{deviceId}
     * @secure
     */
    updateHubDevice: (
      { hubDeviceId, deviceId, ...query }: UpdateHubDeviceParams,
      updateHubDeviceRequest: EdgeDeviceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/childdevice/${deviceId}`,
        method: 'PATCH',
        query: query,
        body: updateHubDeviceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Install Driver on a Hub. The primary use case of this functionality is to install a self published driver to be included in generic discovery (e.g. scanning).
     *
     * @tags HubDevices
     * @name InstallDrivers
     * @summary Install Drivers
     * @request PUT:/hubdevices/{hubDeviceId}/drivers/{driverId}
     * @secure
     */
    installDrivers: (
      hubDeviceId: string,
      driverId: string,
      installDriverRequest: InstallDriverRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/drivers/${driverId}`,
        method: 'PUT',
        body: installDriverRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Removes a driver from being defaultly installed on a hub. This will allow the hub to clean up the deleted driver. However all dependent devices need to be removed for cleanup to fully occur.
     *
     * @tags HubDevices
     * @name UninstallDriver
     * @summary Uninstall Driver
     * @request DELETE:/hubdevices/{hubDeviceId}/drivers/{driverId}
     * @secure
     */
    uninstallDriver: (hubDeviceId: string, driverId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/drivers/${driverId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Returns the specific driver revision information of the driver that is in use by a hub
     *
     * @tags HubDevices
     * @name GetHubDeviceDriver
     * @summary Get Driver in use by Hub Device
     * @request GET:/hubdevices/{hubDeviceId}/drivers/{driverId}
     * @secure
     */
    getHubDeviceDriver: (hubDeviceId: string, driverId: string, params: RequestParams = {}) =>
      this.request<InstalledDriver, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/drivers/${driverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Enable ZWave exclusion mode for the passed in hubId for the specified timeout
     *
     * @tags HubDevices
     * @name EnableZWaveExclusion
     * @summary Enable ZWave Exclusion
     * @request POST:/hubdevices/{hubDeviceId}/zwave/exclusion
     * @secure
     */
    enableZWaveExclusion: ({ hubDeviceId, ...query }: EnableZWaveExclusionParams, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/zwave/exclusion`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Fetch all hubs, using an Oauth token with a principal. Only hubs that allow principal access will be returned in the response.
     *
     * @tags HubDevices
     * @name ListHubs
     * @summary List hubs for location
     * @request GET:/hubdevices
     * @secure
     */
    listHubs: (query: ListHubsParams, params: RequestParams = {}) =>
      this.request<Hub[], ErrorResponse>({
        path: `/hubdevices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a map of key/value pairs. Values could be of any type. There are no required keys. More information is available [here](https://smartthings.atlassian.net/wiki/spaces/HUBPLT/pages/2348782106/Hub+Characteristics+Guidelines+and+Schema)
     *
     * @tags HubDevices
     * @name ListHubCharacterstics
     * @summary List Hub Characterstics
     * @request GET:/hubdevices/{hubDeviceId}/characteristics
     * @secure
     */
    listHubCharacterstics: ({ hubDeviceId, ...query }: ListHubCharactersticsParams, params: RequestParams = {}) =>
      this.request<HubCharacteristics, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/characteristics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags HubDevices
     * @name GetHub
     * @summary Get hub
     * @request GET:/hubdevices/{hubDeviceId}
     * @secure
     */
    getHub: (hubDeviceId: string, locationId: string, params: RequestParams = {}) =>
      this.request<Hub, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags HubDevices
     * @name DeleteHub
     * @summary Delete a hub
     * @request DELETE:/hubdevices/{hubDeviceId}
     * @secure
     */
    deleteHub: (
      hubDeviceId: string,
      locationId: string,
      updateHubRequest: HubUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}`,
        method: 'DELETE',
        body: updateHubRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags HubDevices
     * @name PutHub
     * @summary Update a hub
     * @request PUT:/hubdevices/{hubDeviceId}
     * @secure
     */
    putHub: (hubDeviceId: string, locationId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the mesh graph for a specific zigbee device
     *
     * @tags HubDevices
     * @name GetZigbeeMeshGraph
     * @summary Retrieves the mesh graph for a specific zigbee device
     * @request GET:/hubdevices/{hubDeviceId}/zigbee/graph
     * @secure
     */
    getZigbeeMeshGraph: (hubDeviceId: string, locationId: string, params: RequestParams = {}) =>
      this.request<MeshGraph, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/zigbee/graph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the mesh graph for a specific z-wave device
     *
     * @tags HubDevices
     * @name GetZWaveMeshGraph
     * @summary Retrieves the mesh graph for a specific z-wave device
     * @request GET:/hubdevices/{hubDeviceId}/zwave/graph
     * @secure
     */
    getZWaveMeshGraph: (hubDeviceId: string, locationId: string, params: RequestParams = {}) =>
      this.request<MeshGraph, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/zwave/graph`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Request hub logs be collected by the hub and sent to the cloud for future analysis. Intended for uploading logs for a hub owned by user or owned by user being acted on behalf of Note: This doesn't return the logs, but instead information about where the logs are stored in the cloud
     *
     * @tags HubDevices
     * @name RequestHubLogs
     * @summary Request Hub Logs
     * @request POST:/hubdevices/{hubDeviceId}/upload/logs
     * @secure
     */
    requestHubLogs: (
      hubDeviceId: string,
      hubRequestLogsAuditData: HubRequestLogsAuditData,
      params: RequestParams = {},
    ) =>
      this.request<FetchLogsResponse, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/upload/logs`,
        method: 'POST',
        body: hubRequestLogsAuditData,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts the hub replacement process. Takes in the "destinationHubId" as a route param and the "sourceHubId" as a request body param. Will begin the process of transferring data from the source hub to the destination hub and overall replacing the source hub with the destination hub. This is an Async request and a 202 just represents the passing of initial validation checks. Additional status updates will be reported as events or by manually retrieving them using "Get Replacement Status"
     *
     * @tags HubDevices, Replacement
     * @name StartHubReplacement
     * @summary Start Hub Replacement
     * @request POST:/hubdevices/{hubDeviceId}/replacement
     * @secure
     */
    startHubReplacement: (hubDeviceId: string, ReplacementRequest: ReplacementRequest, params: RequestParams = {}) =>
      this.request<HubReplacementProgress, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement`,
        method: 'POST',
        body: ReplacementRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the current status of any replacement job that is active for the given hubDeviceId. If no job is currently active this returns a 404 not found
     *
     * @tags HubDevices, Replacement
     * @name GetHubReplacementStatus
     * @summary Get Hub Replacement Status
     * @request GET:/hubdevices/{hubDeviceId}/replacement
     * @secure
     */
    getHubReplacementStatus: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<HubReplacementProgress, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Given a Source HubDeviceId it returns the list of possible hubs in the same location that could be used to replace the given hub. Returns metadata information about if replacement should be allowed, and also information on what devices and protocols won't be support on the destination hub if replacement is initiated If a destinationHubId is passed in as a query param the results will be filtered down to the single candidate hub in question.
     *
     * @tags HubDevices, Replacement
     * @name GetHubReplacementCandidates
     * @summary Get Hub Replacement Candidates For the Given HubDeviceId
     * @request GET:/hubdevices/{hubDeviceId}/replacement/candidates
     * @secure
     */
    getHubReplacementCandidates: (
      { hubDeviceId, ...query }: GetHubReplacementCandidatesParams,
      params: RequestParams = {},
    ) =>
      this.request<ReplacementCandidates, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement/candidates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  drivers = {
    /**
     * @description Lists drivers owned by user
     *
     * @tags Drivers
     * @name ListDrivers
     * @summary List Drivers
     * @request GET:/drivers
     * @secure
     */
    listDrivers: (query: ListDriversParams, params: RequestParams = {}) =>
      this.request<PagedDrivers, any>({
        path: `/drivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns driver records for all drivers in the current default channel. These drivers are the set that are automatically matched against during device join events and will be automatically installed
     *
     * @tags Drivers
     * @name GetDefaultDrivers
     * @summary Get Current Default Drivers
     * @request GET:/drivers/default
     * @secure
     */
    getDefaultDrivers: (params: RequestParams = {}) =>
      this.request<PagedDrivers, any>({
        path: `/drivers/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a driver by identifier
     *
     * @tags Drivers
     * @name DeleteDriver
     * @summary Delete Driver
     * @request DELETE:/drivers/{driverId}
     * @secure
     */
    deleteDriver: (driverId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/drivers/${driverId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves a driver by identifier. Will return the latests version of driver
     *
     * @tags Drivers
     * @name GetDriver
     * @summary Get Driver
     * @request GET:/drivers/{driverId}
     * @secure
     */
    getDriver: (driverId: string, params: RequestParams = {}) =>
      this.request<Driver, any>({
        path: `/drivers/${driverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a specific revision of a driver
     *
     * @tags Drivers
     * @name GetDriverRevision
     * @summary Get Driver Revision
     * @request GET:/drivers/{driverId}/versions/{version}
     * @secure
     */
    getDriverRevision: (driverId: string, version: string, params: RequestParams = {}) =>
      this.request<Driver, any>({
        path: `/drivers/${driverId}/versions/${version}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Consumes driver package (`.zip`) that contains driver and profile definitions.
     *
     * @tags Drivers
     * @name UploadDriverPackage
     * @summary Upload Package
     * @request POST:/drivers/package
     * @secure
     */
    uploadDriverPackage: (version: string, params: RequestParams = {}) =>
      this.request<Driver, any>({
        path: `/drivers/package`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  distchannels = {
    /**
     * @description Create a channel for the user making the request
     *
     * @tags Channels
     * @name CreateChannel
     * @summary Create a channel
     * @request POST:/distchannels
     * @secure
     */
    createChannel: (Channel: BasicChannel, params: RequestParams = {}) =>
      this.request<DetailedChannel, any>({
        path: `/distchannels`,
        method: 'POST',
        body: Channel,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List channels for the authenticated user, optionally filtering by subscriber type and subsciber ID
     *
     * @tags Channels
     * @name ListChannels
     * @summary List channels
     * @request GET:/distchannels
     * @secure
     */
    listChannels: (query: ListChannelsParams, params: RequestParams = {}) =>
      this.request<PagedDetailedChannels, any>({
        path: `/distchannels`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get channel details by channel ID
     *
     * @tags Channels
     * @name ChannelById
     * @summary Get a channel by ID
     * @request GET:/distchannels/{channelId}
     * @secure
     */
    channelById: (channelId: string, params: RequestParams = {}) =>
      this.request<DetailedChannel, any>({
        path: `/distchannels/${channelId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a channel by channel ID
     *
     * @tags Channels
     * @name UpdateChannel
     * @summary Update a channel
     * @request PATCH:/distchannels/{channelId}
     * @secure
     */
    updateChannel: (channelId: string, ChannelUpdate: PatchChannel, params: RequestParams = {}) =>
      this.request<DetailedChannel, any>({
        path: `/distchannels/${channelId}`,
        method: 'PATCH',
        body: ChannelUpdate,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a channel by channel ID
     *
     * @tags Channels
     * @name DeleteChannel
     * @summary Delete a channel
     * @request DELETE:/distchannels/{channelId}
     * @secure
     */
    deleteChannel: (channelId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/distchannels/${channelId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Assign a specific driver and version to a channel
     *
     * @tags Channels
     * @name CreateDriverChannel
     * @summary Assign driver to channel
     * @request POST:/distchannels/{channelId}/drivers
     * @secure
     */
    createDriverChannel: (channelId: string, params: RequestParams = {}) =>
      this.request<DriverChannel, any>({
        path: `/distchannels/${channelId}/drivers`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of drivers assigned to the channel
     *
     * @tags Channels
     * @name GetChannelDrivers
     * @summary List drivers assigned to channel
     * @request GET:/distchannels/{channelId}/drivers
     * @secure
     */
    getChannelDrivers: (channelId: string, params: RequestParams = {}) =>
      this.request<PagedDriverChannels, any>({
        path: `/distchannels/${channelId}/drivers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve details for a specific driver channel
     *
     * @tags Channels
     * @name GetDriverChannel
     * @summary Retrieve a driver channel
     * @request GET:/distchannels/{channelId}/drivers/{driverId}
     * @secure
     */
    getDriverChannel: (channelId: string, driverId: string, params: RequestParams = {}) =>
      this.request<DriverChannel, any>({
        path: `/distchannels/${channelId}/drivers/${driverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the version for a driver assign to a channel
     *
     * @tags Channels
     * @name UpdateDriverChannelVersion
     * @summary Update driver channel version
     * @request PUT:/distchannels/{channelId}/drivers/{driverId}
     * @secure
     */
    updateDriverChannelVersion: (
      channelId: string,
      driverId: string,
      UpdateDriverChannel: UpdateDriverChannel,
      params: RequestParams = {},
    ) =>
      this.request<DriverChannel, any>({
        path: `/distchannels/${channelId}/drivers/${driverId}`,
        method: 'PUT',
        body: UpdateDriverChannel,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a driver channel
     *
     * @tags Channels
     * @name DeleteDriverChannel
     * @summary Delete driver channel
     * @request DELETE:/distchannels/{channelId}/drivers/{driverId}
     * @secure
     */
    deleteDriverChannel: (channelId: string, driverId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/distchannels/${channelId}/drivers/${driverId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
}
